import React, { useState, Suspense, useContext } from "react";
// import { Modal, ModalBody } from "reactstrap";
import $ from "jquery";
import { useHistory } from "react-router-dom";
import {
  Dialog as DialogComponent,
  // DialogActionsBar,
  // DialogCloseEvent,
} from "@progress/kendo-react-dialogs";
// import '@progress/kendo-theme-default/dist/all.css';
import {
  Splitter,
  SplitterOnChangeEvent,
  // BreadcrumbLinkMouseEvent,
} from "@progress/kendo-react-layout";
import { useInternationalization } from "@progress/kendo-react-intl";
import { process, SortDescriptor, State } from "@progress/kendo-data-query";
import { clone, getter } from "@progress/kendo-react-common";
import { confirmAlert } from 'react-confirm-alert';
import {
  GridRowDoubleClickEvent,
  GridRowClickEvent,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { UploadFileInfo } from "@progress/kendo-react-upload";
import { ProtocolSequence } from "../../custom_functions/Constance.jsx";
import { TreeViewItemClickEvent } from "@progress/kendo-react-treeview";
import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import { Offset } from "@progress/kendo-react-popup";
import { withAlert } from "react-alert";

import { withTranslation } from "react-multi-lang";
import { isMultitenant, convertprotocolshorthandtooriginal, getsequenceoncode, getprotocolordertype, protocoldefaultcheck } from "../../custom_functions/Constance.jsx";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import Service from "./../../custom_modules/general/Service.jsx";

import {
  DataModel,
  PanesModel,
  SplitBtnItems,
  SelectedItemType,
  UploadAddEvent,
  ViewChangeEvent,
  SortChangeEvent,
  AppSwitchChangeEvent,
  ContextMenuEvent,
} from "../../interfaces/FileManagerModels";
import {
  formatData,
  formatserverData,
  groupBy,
  getFolderTree,
  searchTreeItem,
  addDataItem,
  addFolderonObj,
  addprojectinsidetask,
  getFolderToSave,
  convertExtensionToIcon,
  convertDateFormat,
  convertToBreadcrumbData,
  removeDataItem,
  editDataItem,
  getFolderPath,
  removeItem,
  getDirectoryOncode,
  getDirectoryOncodeandfilefor,
  getDirectoryOnName,
  replaceallordertoFolderwithfilefor,
  addfileitemsforhomebutton,
  replaceonechangeorderordertoFolderwithfilefor,
  addfileitemstoFolderwithfilefor,
  getAllFolderFromItem,
  getAllFolderFromMultiItem,
  deleteorderitemstoFolderwithfilefor,
  addorderitemstoFolderwithfilefor,
  expandparentfolder,
  deletefileitemstoFolderwithfilefor,
  deletefileitemsforhomebutton,
  setdates,
  Movemultifolders,
  addorderitemsforhomebutton,
  searchTreeItemonpath,
  Onsetfolderexpande,
  replaceItem,
} from "../../helpers/helperMethods";
// import { ContextMenu } from "../../controls/ContextMenu";
import {
  Silentauditobject,
  AuditTrailValidation,
  GetutcDate,
  Servicecalls,
  Getuserprojectfromsession,
  Getprotocoluserworkflowfromsession,
  setDateAsuserDefined,
  dateDiffInDays,
  convertUTCDateToLocalDate,
  ControlRights,
  Getteamusersfromsession,
  userdetails,
  Manualauditobject,
  generateLink,
  GetutcDateaudi,
  valiadateTenantPackage,
  orderTypeforprotocol,
  Onsaveactivewidgetsdata,
  AuditTrailValidationOnScreen,
  formsequenceformatview,
  gridDtatExport,
  ProtocolOrderTransactionDataUpdate,
  gridDtatExportToolBar
} from "../../custom_functions/Functions.jsx";
import { useLayoutEffect, useEffect } from "react";
// import { PendingprotocolorderViewCell1 } from "../../controls/columnMenu";
// import Audit from "../../custom_modules/Audit";
// import { fas } from "@fortawesome/free-solid-svg-icons";
// import {
//   DeleteDialog,
//   EditDialog,
//   MoveDialog,
//   AddDialog,
//   CommonDialog,
// } from "../../controls/Dialog";

import {
  // GridView,
  // GridViewdummy,
  NameCell,
  DateCreatedCell,
} from "../../controls/GridView";
// import { object } from "yup";
import { MyprotocolFolderContext } from "../main_pages/orders/PProtocolorders.jsx";

import { updatewithoutcloseprotocolorderdatas } from "../../redux_store/actions/index.js";
import store from "../../redux_store/store/index";
// import { Button } from "react-bootstrap";
const Upgrade = React.lazy(() => import("../general/Upgrade.jsx"));
const isPremiumTenant = valiadateTenantPackage() === "3" ? true : false;
const Unsharelistview = React.lazy(() =>
  import("./../../custom_functions/ManipulationFunction.jsx").then(
    ({ Unsharelistview }) => ({ default: Unsharelistview })
  )
);
const FileManagerToolbar = React.lazy(() =>
  import("../../controls/FileManagerToolbar").then(
    ({ FileManagerToolbar }) => ({ default: FileManagerToolbar })
  )
);

const GridView = React.lazy(() =>
  import("../../controls/GridView").then(({ GridView }) => ({
    default: GridView,
  }))
);
const ListView = React.lazy(() =>
  import("../../controls/ListView").then(({ ListView }) => ({
    default: ListView,
  }))
);
const FileInformation = React.lazy(() =>
  import("../../controls/FileInformation").then(({ FileInformation }) => ({
    default: FileInformation,
  }))
);
const FolderTree = React.lazy(() =>
  import("../../controls/FolderTree").then(({ FolderTree }) => ({
    default: FolderTree,
  }))
);
const DateFilter = React.lazy(() =>
  import("../../controls/DateFilter").then(({ DateFilter }) => ({
    default: DateFilter,
  }))
);
const BreadcrumbComponent = React.lazy(() =>
  import("../../controls/Breadcrumb").then(({ BreadcrumbComponent }) => ({
    default: BreadcrumbComponent,
  }))
);
const DeleteDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ DeleteDialog }) => ({
    default: DeleteDialog,
  }))
);

const EditDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ EditDialog }) => ({
    default: EditDialog,
  }))
);

const MoveDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ MoveDialog }) => ({
    default: MoveDialog,
  }))
);

const AddDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ AddDialog }) => ({
    default: AddDialog,
  }))
);

const CommonDialog = React.lazy(() =>
  import("../../controls/Dialog").then(({ CommonDialog }) => ({
    default: CommonDialog,
  }))
);
const ContextMenu = React.lazy(() =>
  import("../../controls/ContextMenu").then(({ ContextMenu }) => ({
    default: ContextMenu,
  }))
);
const PendingprotocolorderViewCell = React.lazy(
  () => import("../../controls/PendingprotocolorderViewCell")
);


const Audit = React.lazy(() => import("../../custom_modules/Audit"));
const Protocolorder = React.lazy(() => import("./../Protocolorders.jsx"));
export const GlobalContext = React.createContext<any>(null);
export const ProtocolordershowContext = React.createContext<any>(null);
const splitterPanes: PanesModel[] = [
  {
    size: "20%",
    min: "20px",
    collapsible: true,
  },
  {},
  {
    size: "20%",
    min: "20px",
    collapsible: true,
  },
];

const initialSort: SortDescriptor[] = [
  {
    field: "path",
    dir: "desc",
  },
];

const DATA_ITEM_KEY = "path";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
const screen = "Protocol";
let Folderadd_Event: any = undefined;
let passobjectdates = {};
let testmasterdummy: any = null;
let Isview_Constence: boolean = false;
let SelectedCDPTreeItem: any;
let Usermanster_List: any = [];
let deletefolderevents = false;
const Protocolorderstructure = (props: any) => {
  const [idle_save, setidlesave] = React.useState(props?.idle_save);
  let excelExportRef = React.useRef<any>(null);
  const protocolordercontent = {
    protocolname: "",
    AI: {
      value: {
        data: [],
      },
    },
    abstract: { value: "" },
    matrices: { value: "" },
    material: { value: "" },
    sections: [],
    result: {},
  };
  const history = useHistory();
  const selectedTreeItemRef = React.useRef<any>(null);
  const currentDate = sessionStorage.getItem("currentDate");
  const Foldercontext = useContext(MyprotocolFolderContext);
  const intl = useInternationalization();
  let orderdataforfolder: any = [];
  let sateorderdummy: any = [];
  const updateuserrights = (_screenrights: any) => {
    let pending = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_PENDINGWORKPROTOCOL"
    );
    let complete = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_COMPLETEDWORKPROTOCOL"
    );
    let orderByMe = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_ORDERSHAREDBYMEPROTOCOL"
    );
    let orderToMe = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_ORDERSHAREDTOMEPROTOCOL"
    );
    let elnorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNPROTOCOL");
    let dynorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_DYNAMICPROTOCOL");
    let folder = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_FOLDERCREATIONPROTOCOL"
    );
    let moveorder = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_MOVEORDERSPROTOCOL"
    );
    let fileupload = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_UPLOADPROTOCOLORDER"
    );

    let UserRights = {
      pendingVisible: pending.UserGroupRights.rights,
      completeVisible: complete.UserGroupRights.rights,
      // assignedOrderVisible: assignedOrder.UserGroupRights.rights,
      orderByMeVisible: orderByMe.UserGroupRights.rights,
      orderToMeVisible: orderToMe.UserGroupRights.rights,
      // myOrderVisible: myOrder.UserGroupRights.rights,
      elnorderrights: elnorder.UserGroupRights.rights,
      elnordersave: elnorder.UserGroupRights.save,
      dynorderVisible: dynorder.UserGroupRights.rights,
      dynordersave: dynorder.UserGroupRights.save,
      folderrights: folder.UserGroupRights.rights,
      folderrightscreate: folder.UserGroupRights.save,
      foldereditvisible: folder.UserGroupRights.edit,
      folderedeletevisible: folder.UserGroupRights.del,
      moveordervisible: moveorder.UserGroupRights.rights,
      uploadrights: fileupload.UserGroupRights.rights,
    };
    return UserRights;
  };
  const [protocolrights] = React.useState<any>(updateuserrights(props.rights));
  // const [protocolrights, setProtocolrights] = React.useState<any>(updateuserrights(props.rights));
  const [protocolOrder, setProtocolOrder] = React.useState<any>({
    stopDisabled: false,
  });
  const [openedprotocolOrder, setOpenedProtocolOrder] = React.useState<any>({
    stopDisabled: false,
  });
  const [stateData, setStateData] = React.useState<DataModel[]>(
    formatData([], intl)
  );

  const [iscancelled, setIscancelled] = React.useState<boolean>(false);
  const [isupgradeopen, setisupgradeopen] = React.useState(false);
  const [stateCDFData, setStateCDFData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  // const [userrights, setUserrights] = React.useState<any>({});
  // const [clonedStateData, setclonedStateData] = React.useState<DataModel[]>(
  //   formatData([], intl)
  // );
  const [changedtodate, setchangedtodate] = React.useState<boolean>(false);
  const [radioCDFbtnenable, setradioCDFbtnenable] = React.useState<number>(4);
  const [panes, setPanes] = React.useState<PanesModel[]>(splitterPanes);
  const [addedfiles, setAddedfiles] = React.useState<any[]>([]);
  const [selectedFiles, setSelectedFiles] = React.useState<any[]>([]);
  const [isSelectAllFile, setIsSelectAllFile] = React.useState<boolean>(false);
  const [isSelectAllOrder, setIsSelectAllOrder] =
    React.useState<boolean>(false);

  const [SearchCriteriaType, setSearchCriteriaType] = useState<any>(0);
  const [selectedGridItem, setSelectedGridItem] = React.useState<DataModel>({});
  const [isgetorders, setIsgetorders] = React.useState<Boolean>(false);
  const [stopconstence, setStopconstence] = React.useState<Boolean>(true);
  const [protocolorderdatainit, setProtocolorderdatainit] =
    React.useState(undefined);
  const [auditRights] = React.useState(
    AuditTrailValidationOnScreen("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS")
  );
  const pendingelnorderfolder = {
    directorycode: -8,
    parentdircode: -6,
    dateCreated: convertDateFormat(
      new Date(
        currentDate !== undefined && currentDate !== null
          ? currentDate
          : new Date()
      ),
      intl
    ),
    dateModified: convertDateFormat(new Date(), intl),
    size: 124,
    path: `${"Protocol"}/${"Pending Orders"}/${"ELN Protocol Order"}`,
    directoryname: props.t("Orders.Protocolorders.IDS_LBL_ELNPROTO", {
      screenname:
        isMultitenant === 2
          ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
          : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER"),
    }),
    icon: convertExtensionToIcon("ELN Protocol Order", null),
    filefor: "EPO",
    items: [],
  };
  const [selectedTreeItem, setSelectedTreeItem] =
    React.useState<DataModel | null>(pendingelnorderfolder);
  const [selectedCDPTreeItem, setSelectedCDPTreeItem] =
    React.useState<DataModel | null>();
  const [gridSelection, setGridSelection] = React.useState<{
    [id: string]: boolean | number[];
  }>({});

  const [detailsData, setDetailsData] = React.useState<null | number | Object>(
    null
  );
  const [files, setFiles] = React.useState<UploadFileInfo[]>([]);
  const [contentView, setContentView] = React.useState<string | null>(
    localStorage.getItem("elnprotocolorderview") !== undefined &&
      localStorage.getItem("elnprotocolorderview") !== null
      ? localStorage.getItem("elnprotocolorderview")
      : "list"
  );
  const [contextMenuView, setContextMenuView] = React.useState<boolean>(false);
  const [menuOffSet, setMenuOffSet] = React.useState<Offset>({
    left: 0,
    top: 0,
  });
  const [editDialogView, setEditDialogView] = React.useState<boolean>(false);
  const [deleteDialogView, setDeleteDialogView] =
    React.useState<boolean>(false);
  const [moveDialogView, setMoveDialogView] = React.useState<boolean>(false);
  const [isMenuContext, setIsMenuContext] = React.useState<boolean>(false);
  const [adddialogVisible, setAddDialogVisible] =
    React.useState<boolean>(false);

  const [selectedOrders, setSelectedOrders] = React.useState<any[]>([]);
  const [isMultiSelectOrder, setIsMultiSelectOrder] =
    React.useState<boolean>(false);
  const [isMultiSelectFile, setIsMultiSelectFile] =
    React.useState<boolean>(false);
  const [isdashboardclick, setIsdashboardclick] =
    React.useState<boolean>(false);
  const [selectedFolders, setSelectedFolders] = React.useState<any[]>([]);
  const [isMultiSelectFolders, setIsMultiSelectFolders] =
    React.useState<boolean>(false);
  const protocoldaydiff = localStorage.getItem("protocolorderdatefilterdiff");
  let daydiff = 7;
  if (typeof protocoldaydiff === "string" && protocoldaydiff !== "NaN") {
    daydiff = parseInt(JSON.parse(protocoldaydiff));
  }
  const protocolorderfiltertype = localStorage.getItem(
    "protocolorderfiltertype"
  );
  let SelectAllFile: any = false;
  let AllSelectedFiles: any = [];
  let SelectAllOrder: any = false;
  let AllSelectedOrder: any = [];
  let filtertype = 2;
  if (typeof protocolorderfiltertype === "string") {
    filtertype = parseInt(JSON.parse(protocolorderfiltertype));
  }
  const [flitertest, setFlitertest] = useState<any>({
    testcode: -1,
    testname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }),
  });
  const [fliterproject, setFliterproject] = useState<any>({
    projectcode: -1,
    projectname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }),
  });
  const [SearchContentText, setSearchContentText] = useState<any>("");
  const [filterType, setfilterType] = React.useState(filtertype);
  // const [stateUserData, setStateUserData] = React.useState<DataModel>({});
  const [stateUserData] = React.useState<DataModel>({});
  // const td = new Date();
  // const fd = td.setFullYear(td.getFullYear() - 1);
  const userDefinedDate =
    sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" ||
      sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss" ||
      sessionStorage.userDefinedDate === "UTC Format"
      ? "YY/MM/DD HH:mm:ss"
      : sessionStorage.userDefinedDate;

  const [fromRange, setfromRange] = React.useState(
    filtertype === 1
      ? setDateAsuserDefined(
        new Date(
          new Date().setDate(new Date().setHours(0, 0, 0, 0)),
          sessionStorage.userDefinedDate
        )
      )
      : setDateAsuserDefined(
        new Date(new Date().setDate(new Date().getDate() - daydiff)),
        userDefinedDate
      )
  );
  const [toRange, settoRange] = React.useState(
    setDateAsuserDefined(new Date(), userDefinedDate)
  );
  const [protocoltype, setProtocoltype] = React.useState(-1);
  const [orderflag, setOrderflag] = React.useState(-1);
  const [isunshareopen, setIsunshareopen] = React.useState<boolean>(false);
  const [pullcontents, setPullcontents] = React.useState<boolean>(false);
  const [selectedUnsharedItem, setSelectedUnsharedItem] =
    React.useState<DataModel>({});
  let ELNurl = (window as any).appUrl.ELN;
  let deleteitem: any = [];

  const [servicecall, setServicecall] = React.useState<any>({
    ServiceToUrl: "",
    ServiceHeaderobject: {},
    ServiceMethodType: "POST",
    ServcieonSuccess: undefined,
    ServcieonFailure: undefined,
    ServiceTenant: undefined,
    Servicecontenttype: undefined,
  });
  const [Auditservicecall, setAuditservicecall] = React.useState<any>({
    AuditUrl: "",
    AuditObject: {},
    AuditPassfunction: undefined,
    AuditFailfunction: undefined,
    AuditCancelfunction: undefined,
    Auditfilefunction: false,
  });
  const projects = Getuserprojectfromsession();
  const workflow = Getprotocoluserworkflowfromsession();
  // const teamusers = Getteamusersfromsession();
  let itemperpage = 10;
  if (
    localStorage.getItem("Elnitemperpage") !== undefined &&
    localStorage.getItem("Elnitemperpage") !== null
  ) {
    let sheetcolumnsval: any = localStorage.getItem("Elnitemperpage");
    itemperpage = JSON.parse(sheetcolumnsval);
  }
  const [takeskip, setTakeskip] = React.useState<any>({
    skip: 0,
    take: itemperpage,
    group: [],
    collapsedIds: [],
  });

  const [protocolorderopen, setprotocolorderopen] =
    React.useState<boolean>(false);
  // const [protocolopenorder, setprotocolopenorder] = React.useState<any>();
  // const [isFiltered, setIsFiltered] = React.useState<boolean>(false);
  const [cancellorder, setCancellorder] = React.useState<boolean>(false);
  const [cancellorderitem, setCancellorderitem] = React.useState<any>("");
  const [dublicateorder, setDuplicateorder] = useState<boolean>(false);
  const [dublicateorderitem, setDublicateorderitem] = useState<any>("");
  let initialorders: any = null;
  const [testmaster, setTestmaster] = React.useState<any>([]);
  const [testdata, setTestData] = React.useState<any>([]);

  // const [fileviewfor, setFileviewfor] = React.useState<number>(1);
  const [fileviewfor] = React.useState<number>(1);

  const MyCustomCellActionforprotocol = (props: any) => (
    // <PendingViewCell1
    //   {...props}
    //   keyfield={"protocolordercode"}
    //   // onclick={this.onbuttonchecked}
    //   passbackorder={props.onOrderShared}
    // />
    <Suspense fallback={<div></div>}>
      <PendingprotocolorderViewCell
        {...props}
        activekey={
          selectedTreeItem !== null
            ? selectedTreeItem.filefor
            : selectedTreeItem
        }
        keyfield={"protocolordercode"}
        passbackorder={onOrderShared}
        openunsharelist={openunsharelist}
        onordercommonaction={onordercommonaction}
        // onclick={handleGridDoubleClick}
        stopautoregister={stopautoregister}
        onorderopen={handleOrderopenClick}
        ondeletefile={ondeletefile}
      />
    </Suspense>
  );

  let SelectedCDFvalue =
    selectedTreeItem === null || SelectedCDPTreeItem ? 5 : 4;
  const onradioCDFbtnclick = (event: any) => {
    if (parseInt(event.target.value) === 4) {
      setradioCDFbtnenable(4);
      // setSelectedCDPTreeItem(undefined)
      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      return 4;
    } else if (parseInt(event.target.value) === 5) {
      setradioCDFbtnenable(5);
      SelectedCDFvalue = 5;
      return 5;
    }
  };
  const ChoosePath = (data: any) => {
    let newArray = data.slice();
    // Elements to add
    let elementsToAdd = {
      directorycode: null,
      parentdircode: -1,
      dateCreated: convertDateFormat(
        new Date(
          currentDate !== undefined && currentDate !== null
            ? currentDate
            : new Date()
        ),
        intl
      ),
      dateModified: convertDateFormat(new Date(), intl),
      size: 124,
      path: "Home",
      directoryname: props.t("Templates.Sheettemplates.IDS_LBL_HOME"),
      icon: convertExtensionToIcon(props.t("Templates.Sheettemplates.IDS_LBL_HOME"), null),
      filefor: "HF",
      items: [], //projectitems,
    };
    newArray.unshift(elementsToAdd);
    setStateCDFData(
      newArray?.filter(
        (item: any) =>
          item.filefor === "PR" ||
          item.filefor === "DR" ||
          item.filefor === "SMM" ||
          item.filefor === "HF"
      )
    );
  };
  const openunsharelist = (item: any) => {
    setIsunshareopen(true);
    setSelectedUnsharedItem(item);
  };

  let protocolcolumns = undefined;
  if (
    localStorage.getItem("elnprotocolcolumns") !== undefined &&
    localStorage.getItem("elnprotocolcolumns") !== null
  ) {
    let protocolcolumnsval: any = localStorage.getItem("elnprotocolcolumns");
    protocolcolumns = JSON.parse(protocolcolumnsval);
  }

  const [columns, setColumns] = React.useState<any[]>([
    {
      field: "protoclordername",
      title: props.t("Orders.Protocolorders.IDS_LBL_ORDERID", {
        screenname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_TASK")
            : props.t("Dashboard.IDS_LBL_ORDER"),
      }),
      show: true,
      default: true,
      cell: NameCell,
      isprimary: true,
      showtoall: true,
    },
    {
      field: "dateCreated",
      title: props.t("Orders.Protocolorders.IDS_LBL_DATECREATE"),
      show: true,
      classNames: "date-block",
      default: true,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "dateCompleted",
      title: props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
      show: false,
      classNames: "date-block",
      default: true,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "dateModified",
      title: props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON"),
      show: protocolcolumns !== undefined &&
        protocolcolumns.find((obj: string) => obj === "modifieddate")
        ? true
        : false,
      classNames: "date-block",
      default: false,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "testname",
      title: props.t("Orders.Protocolorders.IDS_LBL_TASK"),
      show: true,
      default: true,
    },
    {
      field: "protocolmastername",
      title: props.t("Orders.Protocolorders.IDS_LBL_PROTOCOL"),
      show:
        protocolcolumns !== undefined &&
          protocolcolumns.find((obj: string) => obj === "protocolmastername")
          ? true
          : false,
      default: false,
    },
    {
      field: "projectname",
      title: props.t("Orders.Protocolorders.IDS_LBL_PROJECT"),
      show:
        protocolcolumns !== undefined &&
          protocolcolumns.find((obj: string) => obj === "projectname")
          ? true
          : false,
      default: false,
    },
    {
      field: "materialname",
      title: props.t("Logbook.IDS_LBL_MATERIAL"),
      show:
        protocolcolumns !== undefined &&
          protocolcolumns.find((obj: string) => obj === "materialname")
          ? true
          : false,
      default: false,
    },
    {
      field: "tle",
      title: props.t("Orders.Sheetorders.IDS_LBL_TITLE"),
      show:
        protocolcolumns !== undefined &&
          protocolcolumns.find((obj: string) => obj === "tle")
          ? true
          : false,
      default: false,
    },
    // {
    //   field: "repositoryitemname.repositoryitemname",
    //   title: props.t("Orders.Protocolorders.IDS_LBL_INVENTORY"),
    //   show:
    //     protocolcolumns !== undefined &&
    //       protocolcolumns.find((obj: string) => obj === "repositoryitemname.repositoryitemname")
    //       ? true : false
    //   ,
    //   default: false,
    // },
    {
      field: "keyword",
      title: props.t("Orders.Protocolorders.IDS_LBL_KEYWORD"),
      show:
        protocolcolumns !== undefined &&
          protocolcolumns.find((obj: string) => obj === "keyword")
          ? true
          : false,
      default: false,
    },
    {
      field: props.t("SheetView.ID_PROCESSORDER"),
      title: props.t("Orders.Protocolorders.IDS_LBL_ACTIONS"),
      width: "100px",
      show: true,
      default: true,
      cell: MyCustomCellActionforprotocol,
      headerCell: "actionheader",
      ismapulationcol: true,
    },

  ]);

  const [columnsForSplit, setColumnsForSplit] = React.useState<any[]>([
    {
      field: "directoryname",
      title: props.t("Orders.Protocolorders.IDS_LBL_ORDERID", {
        screenname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_TASK")
            : props.t("Dashboard.IDS_LBL_ORDER"),
      }),
      show: true,
      default: true,
      cell: NameCell,
      isprimary: true,
      showtoall: true,
    },
    {
      field: "dateCreated",
      title: props.t("Orders.Protocolorders.IDS_LBL_DATECREATE"),
      show: true,
      classNames: "date-block",
      default: true,
      cell: DateCreatedCell,
      showtoall: true,
    },
    {
      field: "testname",
      title: props.t("Orders.Protocolorders.IDS_LBL_TASK"),
      show: true,
      default: true,
    },
    {
      field: "protocolmastername",
      title: props.t("Orders.Protocolorders.IDS_LBL_PROTOCOL"),
      show:
        protocolcolumns !== undefined &&
          protocolcolumns.find((obj: string) => obj === "protocolmastername")
          ? true
          : false,
      default: false,
    }
  ]);

  const ongetfoldersuccess = (response: any, intl: any) => {
    // let users = response.users;
    setStopconstence(false);
    // let projects = response.projects;
    // let samples = response.samples;
    let tests = response.tests;
    // let sampletests = response.sampletests;
    let Userprojects = JSON.parse(sessionStorage.Userprojects);
    let directory = response.directory.filter((items: any) => ((items?.parentcodeondefaultfoder && Userprojects.filter((projectcode: any) => projectcode === items?.parentcodeondefaultfoder)?.length > 0) || (items?.parentcodeondefaultfoder === undefined) || (items?.parentcodeondefaultfoder % 1 !== 0)));
    // let directory = response.directory;
    // let Material_List = response.Material;
    // let Materialtest = response.Materialtest;
    // if (tests !== undefined) {

    // }
    let orders: DataModel[] = [];
    // let useritems: DataModel[] = [];
    // let pendingordersitems: DataModel[] = [];
    if (protocolrights.elnorderrights === true) {
      // pendingordersitems.push(pendingelnorderfolder);
      orders.push(pendingelnorderfolder);
    }
    if (protocolrights.dynorderVisible === true) {
      orders.push({
        directorycode: -9,
        parentdircode: -6,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"Pending Orders"}/${"Dynamic Protocol Order"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_DYNAMICPROTO", {
          screenname:
            isMultitenant === 2
              ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
              : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER"),
        }),
        icon: convertExtensionToIcon("Dynamic Protocol Order", null),
        filefor: "DPO",
        items: [],
      });
    }
    if (
      protocolrights.elnorderrights === true ||
      protocolrights.dynorderVisible === true
    ) {
      orders.push({
        directorycode: -6,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"Pending Orders"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_PENDINGPROTO", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Pending Orders", null),
        filefor: "PO",
        items: [],
        expanded: true,
      });
    }
    // let completedordersitems: DataModel[] = [];
    if (protocolrights.elnorderrights === true) {
      orders.push({
        directorycode: -10,
        parentdircode: -7,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"Completed Orders"}/${"ELN Protocol Order"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_ELNPROTO", {
          screenname:
            isMultitenant === 2
              ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
              : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER"),
        }),
        icon: convertExtensionToIcon("ELN Protocol Order", null),
        filefor: "ECO",
        items: [],
      });
      if (protocolrights.dynorderVisible === true) {
        orders.push({
          directorycode: -11,
          parentdircode: -7,
          dateCreated: convertDateFormat(
            new Date(
              currentDate !== undefined && currentDate !== null
                ? currentDate
                : new Date()
            ),
            intl
          ),
          dateModified: convertDateFormat(new Date(), intl),
          size: 124,
          path: `${"Protocol"}/${"Completed Orders"}/${"Dynamic Protocol Order"}`,
          directoryname: props.t("Orders.Protocolorders.IDS_LBL_DYNAMICPROTO", {
            screenname:
              isMultitenant === 2
                ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
                : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER"),
          }),
          icon: convertExtensionToIcon("Dynamic Protocol Order", null),
          filefor: "DCO",
          items: [],
        });
      }
    }
    if (
      protocolrights.elnorderrights === true ||
      protocolrights.dynorderVisible === true
    ) {
      orders.push({
        directorycode: -7,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"Completed Orders"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_COMPLETEDPROTO", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Completed Orders", null),
        filefor: "CO",
        items: [], //completedordersitems,
      });
    }

    orders.push({
      directorycode: -18,
      parentdircode: -1,
      dateCreated: convertDateFormat(
        new Date(
          currentDate !== undefined && currentDate !== null
            ? currentDate
            : new Date()
        ),
        intl
      ),
      dateModified: convertDateFormat(new Date(), intl),
      size: 124,
      path: `${"Protocol"}/${"Cancelled Orders"}`,
      directoryname: props.t("Orders.Protocolorders.IDS_LBL_CANCELLEDPROTO", {
        screenname:
          isMultitenant === 2
            ? props.t("Dashboard.IDS_LBL_TASKS")
            : props.t("Dashboard.IDS_LBL_ORDERS"),
      }),
      icon: convertExtensionToIcon("Cancelled Orders", null),
      filefor: "CAO",
      items: [], //completedordersitems,
    },
      {
        directorycode: -19,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Sheet"}/${"Rejected Orders"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_REJECTEDORDERS", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Rejected Orders", null),
        filefor: "RJO",
        items: [],
      }
    );
    if (sessionStorage.accouttype !== "1") {
      orders.push({
        directorycode: -12,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"Assigned Orders"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_ASSIGNEDORDER", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Assigned Orders", null),
        filefor: "ASO",
        items: [],
      });
    }
    if (sessionStorage.accouttype !== "1") {
      orders.push({
        directorycode: -13,
        parentdircode: -1,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"My Orders"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_MYORDERS", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("My Orders", null),
        filefor: "MYO",
        items: [],
      });
    }
    if (
      protocolrights.orderByMeVisible === true ||
      protocolrights.orderToMeVisible === true
    ) {
      if (sessionStorage.accouttype !== "1") {
        orders.push({
          directorycode: -14,
          parentdircode: -1,
          dateCreated: convertDateFormat(
            new Date(
              currentDate !== undefined && currentDate !== null
                ? currentDate
                : new Date()
            ),
            intl
          ),
          dateModified: convertDateFormat(new Date(), intl),
          size: 124,
          path: `${"Protocol"}/${"Shared Orders"}`,
          directoryname: props.t("Orders.Protocolorders.IDS_LBL_SHAREDORDERS", {
            screenname:
              isMultitenant === 2
                ? props.t("Dashboard.IDS_LBL_TASKS")
                : props.t("Dashboard.IDS_LBL_ORDERS"),
          }),
          icon: convertExtensionToIcon("Shared Orders", null),
          filefor: "SHO",
          items: [],
        });
      }
    }
    if (protocolrights.orderByMeVisible === true) {
      orders.push({
        directorycode: -15,
        parentdircode: -14,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"Orders Shared By Me"}`,
        directoryname: props.t("Orders.Protocolorders.IDS_LBL_SHAREDBYME", {
          screenname:
            isMultitenant === 2
              ? props.t("Dashboard.IDS_LBL_TASKS")
              : props.t("Dashboard.IDS_LBL_ORDERS"),
        }),
        icon: convertExtensionToIcon("Orders Shared By Me", null),
        filefor: "OSBM",
        items: [],
      });
    }
    if (protocolrights.orderToMeVisible === true) {
      orders.push({
        directorycode: -16,
        parentdircode: -14,
        dateCreated: convertDateFormat(
          new Date(
            currentDate !== undefined && currentDate !== null
              ? currentDate
              : new Date()
          ),
          intl
        ),
        dateModified: convertDateFormat(new Date(), intl),
        size: 124,
        path: `${"Protocol"}/${"Orders Shared To Me"}`,
        directoryname:
          isMultitenant === 2
            ? props.t("Orders.Sheetorders.IDS_LBL_ORDERSHAREDWITHME")
            : props.t("Orders.Protocolorders.IDS_LBL_SHAREDTOME"),
        icon: convertExtensionToIcon("Orders Shared To Me", null),
        filefor: "OSTM",
        items: [],
      });
    }

    if (directory !== null && directory !== undefined && directory.length > 0) {
      // let directories: DataModel[] = [];
      directory = directory.filter((items: any) => items.path !== undefined);
      directory.map((dic: any) => {
        orders.push({
          directorycode: dic.directorycode,
          parentdircode: dic.parentdircode,
          dateCreated: convertDateFormat(new Date(dic.dateCreated), intl),
          dateModified: convertDateFormat(new Date(dic.dateModified), intl),
          createdDate: dic.dateCreated,
          size: 124,
          path: dic.path,
          directoryname: dic.directoryname,
          parentcodeondefaultfoder: dic?.parentcodeondefaultfoder || null,
          icon: convertExtensionToIcon(dic.directoryname, null),
          filefor: "DR",
          viewoption: dic.viewoption,
          teamname: dic.teamname !== undefined ? dic.teamname : undefined,
          Created_By: dic?.createdby?.username ?? "",
          Modified_By: dic?.modifiedby?.username ?? "",
          foldermapping: dic?.foldermapping || "",
        });
        return dic;
      });
    }

    let groupeddata = groupBy(orders, "parentdircode");
    let data = groupeddata["-1"];
    let basepath = "Protocol";
    if (data !== undefined) {
      orders = formatData(
        formatserverData(data, groupeddata, intl, screen, basepath),
        intl
      );
    }

    if (
      props.isnotificationprocess?.Open_Type === "Globl_Search_Folder" ||
      props.isnotificationprocess?.Open_Type === "Activities_Folder"
    ) {
      let Allstate_Data = flattenHierarchy(JSON.parse(JSON.stringify(orders)));
      orders = expandPathInHierarchy(
        Allstate_Data,
        props.isnotificationprocess?.path,
        orders
      );
      let Notification_Data = props.isnotificationprocess;
      const pathSegments = Notification_Data?.path.split("/");
      const Fullpath = pathSegments.reduce(
        (Path: any, Items: any, index: any) => {
          if (index === 0 && Items === "ProtocolOrder") {
            Items = "Protocol";
          }
          Path = Path ? `${Path}/${Items}` : Items;
          return Path;
        },
        ""
      );

      if (props.isnotificationprocess?.Open_Type === "Activities_Folder") {
        let isFolderprecentonResponce = response.directory.some((items: any) => items.directorycode === props.isnotificationprocess?.directorycode);
        let afterFolderRemoveResponce = directory.some((items: any) => items.directorycode === props.isnotificationprocess?.directorycode);
        if (isFolderprecentonResponce && !afterFolderRemoveResponce) {
          props.alert.error(
            props.t("Orders.Protocolorders.IDS_LBL_MAPPEDFOLDER")
          );
        }
      }



      Notification_Data.path = Fullpath;
      const newTreeItem = searchTreeItem(orders, Notification_Data);
      setSelectedTreeItem(newTreeItem);
      setTimeout(() => {
        const elements = document.getElementsByClassName(
          "k-in k-state-selected"
        );
        if (elements.length > 0) {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }, 1000);
      props.onresetnotification();
    } else {
      if (
        selectedTreeItem !== undefined &&
        selectedTreeItem?.directorycode !== undefined &&
        selectedTreeItem?.filefor !== undefined
      ) {
        orders = expandparentfolder(
          orders,
          selectedTreeItem?.directorycode,
          intl,
          selectedTreeItem?.filefor,
          screen
        ).data;
      }
    }

    ChoosePath(orders);
    setStateData(orders);
    setSelectedCDPTreeItem(undefined);
    SelectedCDPTreeItem = undefined;
    SelectedCDFvalue = 4;
    initialorders = orders;
    setTestmaster(tests);
    testmasterdummy = tests;
    setIsgetorders(true);
    if (
      props.isnotificationprocess?.Open_Type === "Globl_Search_Folder" ||
      props.isnotificationprocess?.Open_Type === "Activities_Folder"
    ) {
      setPullcontents(true);
    }
  };

  useLayoutEffect(() => {
    if (!props.isnotifify) {
      const storedataforprotocolorder = store.getState().OpenprotocolordersDatas;
      if (storedataforprotocolorder?.protocolorderopen) {
        setprotocolorderopen(storedataforprotocolorder.protocolorderopen);
        setSelectedTreeItem(storedataforprotocolorder.selectedTreeItem);
        setIsdashboardclick(storedataforprotocolorder.isdashboardclick);
        setProtocolOrder(storedataforprotocolorder.protocolOrder);
      } else {
        if (
          protocolrights.elnorderrights === true &&
          props.isnotificationprocess?.Open_Type === undefined
        ) {
          let passObjDet4: any = {
            protocoltype: renderSwitch(pendingelnorderfolder.filefor),
            fromdate: GetutcDateaudi(GetutcDate(new Date(fromRange))),
            todate: GetutcDate(new Date(toRange)),
            lstproject: projects,
            lstelnprotocolworkflow: workflow,
            directorycode: pendingelnorderfolder.directorycode,
            orderflag:
              pendingelnorderfolder.filefor === "EPO" ||
                pendingelnorderfolder.filefor === "DPO"
                ? "N"
                : "R",
            filefor: pendingelnorderfolder.filefor,
            lsuserMaster: store.getState().Loggeduser,
          };
          if (SearchCriteriaType.value === 3) {
            passObjDet4.searchCriteriaType = SearchCriteriaType.value;
          }

          if (
            orderflag !== undefined &&
            orderflag !== -1 &&
            (pendingelnorderfolder.filefor === "ECO" ||
              pendingelnorderfolder.filefor === "DCO")
          ) {
            passObjDet4.orderflag = orderflag === 1 ? "N" : "R";
            if (orderflag === 3) {
              passObjDet4.rejected = 1;
            }
            if (orderflag !== undefined && orderflag === 3) {
              passObjDet4.approvelstatus = 3;
            } else if (orderflag !== undefined && orderflag === 2) {
              passObjDet4.approvelstatus = 1;
            }
          }
          if (fliterproject.projectcode !== -1) {
            passObjDet4.lsprojectmaster = fliterproject;
          }
          if (flitertest.testcode !== -1) {
            passObjDet4.testcode = flitertest.testcode;
          }
          passobjectdates = passObjDet4;
          passObjDet4.lstuserMaster = Getteamusersfromsession();
          if (Foldercontext?.Folders?.directory?.length > 0) {
            passObjDet4.lstdirectorycode = flattenAndExtractDirectoryCodes(JSON.parse(JSON.stringify(Foldercontext?.Folders?.directory)), true);
          }
          Servicecalls(
            "" + ELNurl + "/protocol/getusercodeandusername",
            { sitecode: parseInt(sessionStorage.Usersite) },
            (responce: any) => {
              Usermanster_List = responce;
              setServicecall({
                ServiceToUrl:
                  "" + ELNurl + "/Instrument/Getprotocolorderbyflaganduser",
                ServiceHeaderobject: passObjDet4,
                ServiceMethodType: "POST",
                ServcieonSuccess: ongetorderssuccess1.bind(this),
                ServcieonFailure: ongetordersfailure,
                ServiceTenant: undefined,
                Servicecontenttype: undefined,
              });
            },
            onfolderfailure
          );
        }
      }
    }
  }, [ELNurl]);

  // idle time out save
  useEffect(() => {
    if (props.idle_save === true) {
      setidlesave(props.idle_save);
      localStorage.removeItem("linkedorder");
      if (props.logoutforce) {
        props.logoutforce()
      }
    }
  }, [props.idle_save])

  //willunmount purpose
  useEffect(() => {
    document.title =
      isMultitenant === 2
        ? "Logilab ELN " +
        props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
        : props.t("ELNTitle.IDS_LBL_PROTOCOLTEMPLATE");
    selectedTreeItemRef.current = selectedTreeItem;
  }, [selectedTreeItem]);
  //last opened folder to store db purpose
  useEffect(() => {
    if (!props.isnotifify) {
      //for first order testname show state
      let passObjDet =
        store.getState().Loggeduser !== undefined &&
          store.getState().Loggeduser !== null &&
          Object.keys(store.getState().Loggeduser).length > 0
          ? store.getState().Loggeduser
          : {
            usercode: sessionStorage.User,
            username: sessionStorage.Username,
            lssitemaster: { sitecode: sessionStorage.Usersite },
          };

      Servicecalls(
        "" + ELNurl + "/File/Gettaskforordercreate",
        passObjDet,
        ongetmastersuccess,
        ongetmasterfailure
      );
      return () => {
        console.log({ kumu_wid: selectedTreeItemRef?.current });
        if (
          selectedTreeItemRef?.current !== undefined &&
          selectedTreeItemRef?.current !== null &&
          selectedTreeItemRef?.current.directorycode !== undefined &&
          (selectedTreeItemRef?.current?.filefor === "DR" ||
            selectedTreeItemRef?.current?.path?.includes("Protocol/Projects/"))
        ) {
          let lsActiveWidgets: any = {
            screenname: "Protocol_Folder",
            activityType: "Lastopen_Folder",
            userId: sessionStorage.User,
            activewidgetsdetailscode: selectedTreeItemRef?.current?.directorycode,
            Activewidgetsdetails:
              selectedTreeItemRef?.current?.directoryname || "",
            description: selectedTreeItemRef?.current?.path,
            parentcode: selectedTreeItemRef?.current?.parentdircode,
            sitecode: sessionStorage.Usersite
          };
          if (!Number.isInteger(selectedTreeItemRef?.current?.directorycode)) {
            var parts = selectedTreeItemRef?.current?.directorycode
              .toString()
              .split(".");
            lsActiveWidgets.folderdirfloatcode = parts[1];
          }
          Onsaveactivewidgetsdata(lsActiveWidgets);
        }
      };
    }
  }, [ELNurl, props.isnotifify]);
  useEffect(() => {
    if (
      (SearchContentText.SearchContentText !== undefined &&
        SearchCriteriaType.value === 3) ||
      (SearchContentText === "" && SearchCriteriaType.value === 1) ||
      pullcontents
    ) {
      // getordersforfolders(
      //   selectedTreeItem,
      //   selectedTreeItem,
      //   fromRange,
      //   toRange,
      //   protocoltype,
      //   SearchCriteriaType.value,
      //   orderflag,
      //   flitertest,
      //   fliterproject,
      // );
    } else if (
      Foldercontext.Folders !== undefined &&
      Foldercontext.isfolderresponse &&
      stopconstence
    ) {
      ongetfoldersuccess(Foldercontext.Folders, intl);
    } else if (protocolorderdatainit !== undefined && isgetorders) {
      orderdataforfolder = protocolorderdatainit;
      getfolderfiles(passobjectdates, undefined);
    } else if (
      props.isnotificationprocess !== undefined &&
      props.isnotificationprocess.protocolordercode !== undefined &&
      props.isnotificationprocess?.Open_Type === undefined
    ) {
      let Audit = AuditTrailValidation(
        "IDS_MDL_ORDERS",
        "IDS_SCN_PROTOCOLORDERS",
        "IDS_TSK_PROCESSPROTOCOL"
      );

      if (!Audit) {
        let protocolOrder = {
          ...props.isnotificationprocess,
          isprotocolprocess: true,
          stopDisabled: true
        };
        // setProtocolOrder(protocolOrder);
        // setprotocolorderopen(true);
      }

      handleOrderopenClick(null, props.isnotificationprocess);

    } else if (
      props.isnotificationprocess?.Open_Type === "Globl_Search_Folder" &&
      props.isnotificationprocess?.Issamp_Page
    ) {
      let Allstate_Data = flattenHierarchy(
        JSON.parse(JSON.stringify(stateData))
      );
      let orders = expandPathInHierarchy(
        Allstate_Data,
        props.isnotificationprocess?.path,
        stateData
      );
      const newTreeItem = searchTreeItem(orders, props.isnotificationprocess);
      setSelectedTreeItem(newTreeItem);
      props.onresetnotification();
      setStateData(orders);
      setTimeout(() => {
        setPullcontents(true);
      }, 100);
      setTimeout(() => {
        const elements = document.getElementsByClassName(
          "k-in k-state-selected"
        );
        if (elements.length > 0) {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }, 1000);
    }

    // return () => {
    //   if (protocolorderopen) {
    //     const payload = { protocolOrder, protocolorderopen, isdashboardclick, selectedTreeItem };
    //     store.dispatch(updatewithoutcloseprotocolorderdatas(payload));
    //   }
    // };
  }, [
    SearchContentText,
    Foldercontext,
    props.isnotificationprocess,
    stopconstence,
    protocolorderdatainit,
    isgetorders,
    pullcontents,
  ]);
  const ongetmastersuccess = (response: any) => {
    setTestData(response);
  };
  const ongetmasterfailure = (response: any) => {
    console.log(response);

  }

  const ongetorderssuccess1 = (response1: any, passeddata: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      let shareOrders: any = [];
      if (response1?.sharedmeorders !== undefined && response1?.sharedmeorders?.length > 0 &&
        response1?.sharedtome !== undefined && response1?.sharedtome?.length > 0
      ) {
        shareOrders = response1?.sharedmeorders?.map((ord: any) => {
          let s2me = response1.sharedtome.find((obj: any) => ord.pc === obj.shareprotocolordercode);
          if (s2me) {
            ord.sharetome = [s2me];
          }
          if (response1.protocolorders.findIndex((item: any) => item.pc === ord.pc) === -1) {
            response1.protocolorders.push(ord);
          }
          return ord;
        });
      }
      let response = response1.protocolorders;
      if (response !== undefined && response.length > 0) {
        // itemdata = response;
        let testmastervalues =
          testmasterdummy !== null ? testmasterdummy : testmaster;
        if (testmastervalues !== null) {
          response.map((item: any) => {
            item = convertprotocolshorthandtooriginal(item);
            let test = testmastervalues.filter(
              (items: any) => items[0] === item.testcode
            );
            let usermaster = Usermanster_List.filter(
              (items: any) => items.usercode === item?.createby
            );
            if (usermaster?.length > 0) {
              item.Createdby_Username = usermaster[0].username;
            }
            // Usermanster_List
            if (test.length > 0) {
              item.testname = test[0][2];
            }

            if (item.assignedto !== undefined && item.viewoption !== undefined && item.viewoption === 1) {
              //item.canuserprocess = true;
              if (parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode !== item.createby) {
                if (item.sentforapprovel !== undefined) {
                  if ((item.sentforapprovel && item.approvelaccept === undefined) || (item.sentforapprovel && item.approvelaccept !== "3")) {
                    item.canuserprocess = true;
                  } else {
                    item.canuserprocess = false;
                  }
                } else {
                  item.canuserprocess = false;
                }
              } else if (parseInt(props.sessionvalues.usercode) === item.assignedto.usercode && item.assignedto.usercode !== item.createby) {
                if (item.sentforapprovel !== undefined) {
                  if (item.approvelaccept === undefined) {
                    item.canuserprocess = false;
                  } else if (item.approvelaccept === "2") {
                    item.canuserprocess = true;
                  } else {
                    item.canuserprocess = false;
                  }
                } else {
                  item.canuserprocess = true;
                }
              } else if (parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode === item.createby) {
                item.canuserprocess = true;
              } else {
                response.canuserprocess = false;
              }
            }
            else if (item.lsprojectmaster === undefined && item.assignedto === undefined && item.viewoption !== undefined && item.viewoption === 1) {
              item.canuserprocess = true;
            }
            if (item?.sharetome !== undefined && item?.sharetome !== null) {
              item.canuserprocess = item?.sharetome?.[0]?.sharerights === 1 ? true : false;
            }

            return item;
          });
        }
      }
      // orderdataforfolder = response;
      setProtocolorderdatainit(response);
    }
  };
  const onAuditValidateError = (_response: any) => {

  };

  const onAuditValidateFailure = (_response: any) => {
    ($("#auditTrailModalProtocolview") as any).modal("hide");
  };

  // const ongetfolderfailure = (event: any) => { };
  // let split: SplitBtnItems[] = columns.map((col) => { if (col.show && !col.ismapulationcol) return { text: col.title, value: col.field }; return col }).filter(notUndefined => notUndefined !== undefined) as SplitBtnItems[];
  let split: SplitBtnItems[] = columnsForSplit.filter(
    (col) => col.show && !col.ismapulationcol
  );
  if (split.length > 0) {
    split = split.map((col: any) => {
      return { text: col.title, value: col.field };
    });
  }
  const [splitBtnItems, setsplitBtnItems] = React.useState<
    SplitBtnItems[] | undefined
  >(split);
  const initialLogic: "and" | "or" = "and";
  const [sortSelectedText, setsortSelectedText] = useState(split[0]?.text || "");

  const [stateContentData, setStateContentData] = React.useState<State>({
    sort: initialSort,
    filter: {
      logic: initialLogic,
      filters: [{ field: "path", operator: "contains", value: "" }],
    },
  });

  const [SearchValue, setSearchValue] = useState("");

  const updateFileDetailsData = React.useCallback(
    (selection: SelectedItemType) => {
      if (selection.path) {
        // const newSelectedItem = searchTreeItem(stateData, selection);
        setDetailsData(selection);
      } else if (!selection.path && Object.keys(selection).length) {
        setDetailsData(Object.keys(selection).length);
      } else {
        setDetailsData(null);
      }
    }, []
  );

  const ongetorderssuccessafterregister = (response1: any, passeddata: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {

      const Protocolupdate = (item: any) => {
        if (item?.lsprotocolmaster?.protocolmastername !== undefined && item?.lsprotocolmaster?.protocolmastername !== null && item?.lsprotocolmaster?.protocolmastername !== "" && item.templateversionno !== undefined && item.templateversionno !== null && item.templateversionno !== "") {
          item.protocolmastername = item?.lsprotocolmaster?.protocolmastername + "_v" + item.templateversionno;
        }
        if (item?.lsprojectmaster?.projectname !== undefined && item?.lsprojectmaster?.projectname !== null && item?.lsprojectmaster?.projectname !== "") {
          item.projectname = item?.lsprojectmaster?.projectname;
        }
        return item;
      }

      const uniqueProtocols = Array.from(
        new Map(
          response1.protocolorders.map((item: any) => [
            item.pc !== undefined ? item.pc : item.protocolordercode,
            item.pc !== undefined
              ? convertprotocolshorthandtooriginal(item)
              : ProtocolSequence(Protocolupdate(item))
          ])
        ).values()
      );

      response1.protocolorders = uniqueProtocols;
      response1.protocolorders.forEach((item: any) => {
        let testmastervalues = testdata?.length > 0 ? testdata : testmasterdummy !== null ? testmasterdummy : testmaster?.length > 0 ? testmaster : testmaster;
        let test = testmastervalues.filter((items: any) => items.testcode === item.testcode);
        if (test.length > 0) {
          item.testname = test[0].testname;
        }
        if (item?.tittle !== undefined && item?.tittle !== null) {
          item.tle = item.tittle;
        }
        if (item.assignedto !== undefined && item.viewoption !== undefined && item.viewoption === 1) {
          //item.canuserprocess = true;
          if (parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode !== item.createby) {
            if (item.sentforapprovel !== undefined) {
              if ((item.sentforapprovel && item.approvelaccept === undefined) || (item.sentforapprovel && item.approvelaccept !== "3")) {
                item.canuserprocess = true;
              } else {
                item.canuserprocess = false;
              }
            } else {
              item.canuserprocess = false;
            }
          } else if (parseInt(props.sessionvalues.usercode) === item.assignedto.usercode && item.assignedto.usercode !== item.createby) {
            if (item.sentforapprovel !== undefined) {
              if (item.approvelaccept === undefined) {
                item.canuserprocess = false;
              } else if (item.approvelaccept === "2") {
                item.canuserprocess = true;
              } else {
                item.canuserprocess = false;
              }
            } else {
              item.canuserprocess = true;
            }
          } else if (parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode === item.createby) {
            item.canuserprocess = true;
          } else {
            response.canuserprocess = false;
          }
        }
        else if (item.lsprojectmaster === undefined && item.assignedto === undefined && item.viewoption !== undefined && item.viewoption === 1) {
          item.canuserprocess = true;
        }


        else if (item.lsprojectmaster === undefined && item.viewoption !== undefined && (item.viewoption === 2 || item.viewoption === 3) &&
          item.createby !== undefined && item.createby === parseInt(sessionStorage.User)
        ) {
          item.canuserprocess = true;
        }
        if (
          item.assignedto !== undefined && (passeddata.filefor === "ASO" || passeddata.filefor === "MYO")
        ) {
          delete item.elnprotocolworkflow;
        }

        let usermaster = Usermanster_List.filter(
          (items: any) => items.usercode === item?.createby
        );
        if (usermaster?.length > 0) {
          item.Createdby_Username = usermaster[0].username;
        }
      });
      // let directorycode = passeddata.directorycode;
      // let itemdata = [];
      let response = response1.protocolorders;
      if (
        passeddata.searchCriteriaType !== undefined &&
        passeddata.searchCriteriaType === 3 &&
        response1.protocolordercodeslist !== undefined
      ) {
        let passObjDet: any = {
          ...userdetails(),
          ismultitenant: isMultitenant,
          sitecode: parseInt(sessionStorage.Usersite),
          protocolordercodelist: response1.protocolordercodeslist,
          directorycode: passeddata.directorycode,
          filefor: passeddata.filefor,
          searchcontent: SearchContentText.SearchContentText,
          lstelnprotocolworkflow: workflow,
        };
        if (protocoltype !== -1) {
          passObjDet.protocoltype = protocoltype;
        }
        setServicecall({
          ServiceToUrl: "" + ELNurl + "/protocol/getAllProtocolStepLst",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else {
        if (response !== undefined && response.length > 0) {
          // itemdata = response;
          let testmastervalues =
            testmasterdummy !== null ? testmasterdummy : testmaster;
          if (testmastervalues !== null) {
            response.map((item: any) => {
              let test = testmastervalues.filter(
                (items: any) => items[0] === item.testcode
              );
              if (test.length > 0) {
                item.testname = test[0][2];
              }
              return item;
            });
          }
          // activekey ----orderflag temp;
          if (
            (passeddata.filefor === "ECO" || passeddata.filefor === "DCO") &&
            passeddata.activekey === 2
          ) {
            response = response.filter(
              (itesm: any) =>
                itesm.orderflag !== undefined &&
                itesm.orderflag.trim() === "R" &&
                itesm.rejected !== 1
            );
          }
        }
        orderdataforfolder = response;
        getfolderfiles(passeddata, undefined);
      }
    }
  };

  const ongetorderssuccess = (response1: any, passeddata: any, orderobject: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {

      let iscolumnChanged = false;
      const updatedColumns = columns.map((col) => {
        const shouldUpdate =
          (col.field === "dateCompleted" && passeddata.filefor === "RJO") ||
          col.title === props.t("Orders.Sheetorders.IDS_LBL_DATEREJECTED");
        if (shouldUpdate) {
          iscolumnChanged = true;

          return {
            ...col,
            title:
              passeddata.filefor === "RJO"
                ? props.t("Orders.Sheetorders.IDS_LBL_DATEREJECTED")
                : props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
          };
        }
        return col;
      });

      if (passeddata.filefor === "RJO" || iscolumnChanged) {
        handleoncolumnchange(updatedColumns, splitBtnItems);
      }
      // response1.protocolorders = [
      //   ...new Map(
      //     response1.protocolorders.map((item: any) => [
      //       item.protocolordercode,
      //       convertprotocolshorthandtooriginal(item),
      //     ])
      //   ).values(),
      // ];


      // const uniqueProtocols = response1.protocolorders.reduce((accumulator: any, item: any) => {
      //   console.log("Current accumulator:", accumulator);
      //   console.log("Checking item:", item);
      //   const existing = accumulator.find((protocol: any) => protocol.pc === item.pc);
      //   if (!existing) {
      //     accumulator.push(convertprotocolshorthandtooriginal(item));
      //   }

      //   return accumulator;
      // }, []);

      //   const uniqueProtocols = Array.from(
      //     new Map(
      //         response1.protocolorders.map((item: any) => [item.pc, convertprotocolshorthandtooriginal(item)])
      //     ).values()
      // );
      const Protocolupdate = (item: any) => {
        if (item?.lsprotocolmaster?.protocolmastername !== undefined && item?.lsprotocolmaster?.protocolmastername !== null && item?.lsprotocolmaster?.protocolmastername !== "" && item.templateversionno !== undefined && item.templateversionno !== null && item.templateversionno !== "") {
          item.protocolmastername = item?.lsprotocolmaster?.protocolmastername + "_v" + item.templateversionno;
        }
        if (item?.lsprojectmaster?.projectname !== undefined && item?.lsprojectmaster?.projectname !== null && item?.lsprojectmaster?.projectname !== "") {
          item.projectname = item?.lsprojectmaster?.projectname;
        }
        return item;
      }
      // const uniqueProtocols = Array.from(
      //   new Map(
      //     response1.protocolorders.map((item: any) => [
      //       item.pc !== undefined ? item.pc : item.protocolordercode,

      //       item.pc !== undefined ? convertprotocolshorthandtooriginal(item) :ProtocolSequence(item)
      //     ])
      //   ).values()
      // );

      let shareOrders: any = [];
      if (response1?.sharedmeorders !== undefined && response1?.sharedmeorders?.length > 0 &&
        response1?.sharedtome !== undefined && response1?.sharedtome?.length > 0
      ) {
        shareOrders = response1?.sharedmeorders?.map((ord: any) => {
          let s2me = response1.sharedtome.find((obj: any) => ord.pc === obj.shareprotocolordercode);
          if (s2me) {
            ord.sharetome = [s2me];
          }
          if (response1.protocolorders.findIndex((item: any) => item.pc === ord.pc) === -1) {
            response1.protocolorders.push(ord);
          }
          return ord;
        });
      }

      const uniqueProtocols = Array.from(
        new Map(
          response1.protocolorders.map((item: any) => [
            item.pc !== undefined ? item.pc : item.protocolordercode,
            item.pc !== undefined
              ? convertprotocolshorthandtooriginal(item)
              : ProtocolSequence(Protocolupdate(item))
          ])
        ).values()
      );

      response1.protocolorders = uniqueProtocols;
      response1.protocolorders.forEach((item: any) => {
        let testmastervalues = testdata?.length > 0 ? testdata : testmasterdummy !== null ? testmasterdummy : testmaster?.length > 0 ? testmaster : testmaster;
        let test = testmastervalues.filter((items: any) => items.testcode === item.testcode);
        if (test.length > 0) {
          item.testname = test[0].testname;
        }
        if (item?.tittle !== undefined && item?.tittle !== null) {
          item.tle = item.tittle;
        }
        if (item.assignedto !== undefined && item.viewoption !== undefined && item.viewoption === 1) {
          //item.canuserprocess = true;
          if (parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode !== item.createby) {
            if (item.sentforapprovel !== undefined) {
              if ((item.sentforapprovel && item.approvelaccept === undefined) || (item.sentforapprovel && item.approvelaccept !== "3")) {
                item.canuserprocess = true;
              } else {
                item.canuserprocess = false;
              }
            } else {
              item.canuserprocess = false;
            }
          } else if (parseInt(props.sessionvalues.usercode) === item.assignedto.usercode && item.assignedto.usercode !== item.createby) {
            if (item.sentforapprovel !== undefined) {
              if (item.approvelaccept === undefined) {
                item.canuserprocess = false;
              } else if (item.approvelaccept === "2") {
                item.canuserprocess = true;
              } else {
                item.canuserprocess = false;
              }
            } else {
              item.canuserprocess = true;
            }
          } else if (parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode === item.createby) {
            item.canuserprocess = true;
          } else {
            response.canuserprocess = false;
          }
        }
        else if (item.lsprojectmaster === undefined && item.assignedto === undefined && item.viewoption !== undefined && item.viewoption === 1) {
          item.canuserprocess = true;
        }
        // else if (
        //   passeddata.filefor === "MYO"  && item.assignedto !== undefined && item.viewoption !== undefined &&item.viewoption === 1 
        //   ) {
        //     if( item.sentforapprovel!==undefined){
        //       if(item.approvelaccept === undefined){
        //         item.canuserprocess = false;
        //       }else if (item.approvelaccept==="2"){
        //         item.canuserprocess = true;
        //       }else{
        //         item.canuserprocess = false;
        //       }
        //     }else{
        //         item.canuserprocess = true;
        //     }
        // } 
        // else if(passeddata.filefor === "ASO"  && item.assignedto !== undefined && item.viewoption !== undefined &&item.viewoption === 1 ){
        //   if(item.sentforapprovel!==undefined){
        //     if((item.sentforapprovel && item.approvelaccept===undefined)|| item.sentforapprovel && item.approvelaccept !== "3"){
        //       item.canuserprocess = true;
        //     }else{
        //       item.canuserprocess = false;
        //     }
        //   }
        // }
        // else if(passeddata.filefor === "DR" && item.assignedto !== undefined){
        //   //item.canuserprocess = false;
        //   if(parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode !== item.createby){
        //         if(item.sentforapprovel!==undefined){
        //           if((item.sentforapprovel && item.approvelaccept===undefined)|| item.sentforapprovel && item.approvelaccept !== "3"){
        //             item.canuserprocess = true;
        //           }else{              
        //             item.canuserprocess = false;
        //           }
        //         }else{
        //           item.canuserprocess = false;
        //         }
        //       }else if (parseInt(props.sessionvalues.usercode) === item.assignedto.usercode && item.assignedto.usercode !== item.createby){
        //         if( item.sentforapprovel!==undefined){
        //           if(item.approvelaccept === undefined){
        //             item.canuserprocess = false;
        //           }else if (item.approvelaccept==="2"){
        //             item.canuserprocess = true;
        //           }else{
        //             item.canuserprocess = false;
        //           }
        //         }else{
        //             item.canuserprocess = true;
        //         }
        //       }else if(parseInt(props.sessionvalues.usercode) === item.createby && item.assignedto.usercode === item.createby){
        //         item.canuserprocess = true;
        //       }else{
        //         response.canuserprocess = false;
        //       }
        // }

        else if (item.lsprojectmaster === undefined && item.viewoption !== undefined && (item.viewoption === 2 || item.viewoption === 3) &&
          item.createby !== undefined && item.createby === parseInt(sessionStorage.User)
        ) {
          item.canuserprocess = true;
        }
        if (
          item.assignedto !== undefined && (passeddata.filefor === "ASO" || passeddata.filefor === "MYO")
        ) {
          delete item.elnprotocolworkflow;
        }

        // if (item?.elnprotocolworkflow && item?.elnprotocolworkflow?.elnprotocolworkflowgroupmap?.length > 0) {
        //   const userCanProcess = item.elnprotocolworkflow.elnprotocolworkflowgroupmap.some((wf: any) => {
        //     if (wf?.lsusergroup?.usergroupcode === Number(sessionStorage.multiusergroups)) {
        //       item.canuserprocess = true;
        //       item.cp = true;
        //       return true;
        //     }
        //     return false;
        //   });

        //   if (!userCanProcess) {
        //     item.canuserprocess = false;
        //     item.cp = false;
        //   }
        // }
        let usermaster = Usermanster_List.filter(
          (items: any) => items.usercode === item?.createby
        );
        if (usermaster?.length > 0) {
          item.Createdby_Username = usermaster[0].username;
        }
        if (item?.sharetome !== undefined && item?.sharetome !== null) {
          item.canuserprocess = item?.sharetome?.[0]?.sharerights === 1 ? true : false;
        }
      });
      // let directorycode = passeddata.directorycode;
      // let itemdata = [];
      let response = response1.protocolorders;
      if (
        passeddata.searchCriteriaType !== undefined &&
        passeddata.searchCriteriaType === 3 &&
        response1.protocolordercodeslist !== undefined
      ) {
        let passObjDet: any = {
          ...userdetails(),
          ismultitenant: isMultitenant,
          sitecode: parseInt(sessionStorage.Usersite),
          protocolordercodelist: response1.protocolordercodeslist,
          directorycode: passeddata.directorycode,
          filefor: passeddata.filefor,
          searchcontent: SearchContentText.SearchContentText,
          lstelnprotocolworkflow: workflow,
        };
        if (protocoltype !== -1) {
          passObjDet.protocoltype = protocoltype;
        }
        setServicecall({
          ServiceToUrl: "" + ELNurl + "/protocol/getAllProtocolStepLst",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else {
        if (response !== undefined && response.length > 0) {
          // itemdata = response;
          let testmastervalues =
            testmasterdummy !== null ? testmasterdummy : testmaster;
          if (testmastervalues !== null) {
            response.map((item: any) => {
              let test = testmastervalues.filter(
                (items: any) => items[0] === item.testcode
              );
              if (test.length > 0) {
                item.testname = test[0][2];
              }
              return item;
            });
          }
          // activekey ----orderflag temp;
          if (
            (passeddata.filefor === "ECO" || passeddata.filefor === "DCO") &&
            passeddata.activekey === 2
          ) {
            response = response.filter(
              (itesm: any) =>
                itesm.orderflag !== undefined &&
                itesm.orderflag.trim() === "R" &&
                itesm.rejected !== 1
            );
          }
        }
        orderdataforfolder = response;
        getfolderfiles(passeddata, orderobject);
      }
    }
  };

  const getfolderfiles = (directory: any, orderobject: any) => {
    // if (loadtime) {
    //   ongetfilessuccess([], {
    //     directorycode: directory.directorycode, filefor: directory.filefor,
    //     contentsearch: SearchContentText.SearchContentText
    //     , ismultitenant: isMultitenant,
    //     orderflag: orderflag !== undefined && orderflag !== -1 && orderflag === 1 ? "N" : "R",
    //     approvelstatus: orderflag !== undefined && orderflag === 3 ? 3 : "",
    //   })
    // } else {
    let todate = directory.todate !== undefined ? new Date(directory.todate) : toRange;
    let returndateobj = setdates(
      filterType,
      false,
      "protocolorderdatefilterdiff",
      todate,
      changedtodate
    );
    if (returndateobj !== undefined) {
      setfromRange(returndateobj.fromRange);
      settoRange(returndateobj.toRange);
    }

    setServicecall({
      ServiceToUrl: "" + ELNurl + "/Instrument/Getfilesforprotocolfolder",
      ServiceHeaderobject: {
        directorycode: directory.directorycode,
        filefor: directory.filefor,
        // contentsearchtype: searchCriteriaType.value,
        contentsearch: SearchContentText.SearchContentText,
        ismultitenant: isMultitenant,
        orderflag:
          orderflag !== undefined && orderflag !== -1 && orderflag === 1
            ? "N"
            : "R",
        approvelstatus: orderflag !== undefined && orderflag === 3 ? 3 : "",
        fromdate: GetutcDate(new Date(returndateobj?.fromRange)),
        todate: GetutcDate(new Date(returndateobj?.toRange)),
        lssitemaster: {
          sitecode: parseInt(sessionStorage.Usersite)
        },
      },
      ServiceMethodType: "POST",
      ServcieonSuccess: (response: any, data: any) => { ongetfilessuccess(response, data, orderobject) },
      ServcieonFailure: ongetfilesfailure,
      ServiceTenant: undefined,
      Servicecontenttype: undefined,
    });
    // }
  };

  const ongetfilessuccess = (response: any, passeddata: any, orderobject: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      let directorycode = passeddata.directorycode;
      let itemdata = [];
      if (response !== undefined && response.length > 0) {
        itemdata = response;
      }
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];

      let newdata = replaceallordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        orderdataforfolder !== undefined && orderdataforfolder.length > 0
          ? orderdataforfolder
          : [],
        passeddata.filefor,
        screen
      );

      newdata = addfileitemstoFolderwithfilefor(
        newdata,
        directorycode,
        intl,
        itemdata,
        passeddata.filefor,
        screen
      );

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        passeddata.filefor
      );

      if (orderobject) {

        let path;
        if (selectedtree && selectedtree.items) {
          selectedtree.items.map((data: any) => {
            if (data.order && data.order.protoclordername === orderobject.order.protoclordername) {
              path = data.path;
            }
          })
        }

        setDetailsData(orderobject);
        setSelectedGridItem(orderobject);
        if (path) {
          setGridSelection({
            [path]: true,
          });
        }

        setTimeout(() => {
          const elements = document.getElementsByClassName(
            "k-in k-state-selected"
          );
          if (elements.length > 0) {
            for (let i = 0; i < elements.length; i++) {
              const element = elements[i];
              element.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        }, 1000);
      }

      setSelectedTreeItem(selectedtree);
      // setSelectedTreeItemDuplicate(selectedtree);
      setStateData(newdata);
      if (Folderadd_Event === undefined) {
        setSelectedCDPTreeItem(undefined);
      } else {
        Folderadd_Event = undefined;
      }

      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      // setisOrderMismatched(false);
      // setsheetdatainitservice(false);
      // setsheetdatainit(undefined);
      // setIsLoader(false);
      setIsMultiSelectOrder(false);
      setIsMultiSelectFile(false);
      setIsMultiSelectFolders(false);
      setIsSelectAllFile(false);
      setIsSelectAllOrder(false);
    }
  };

  const ongetfilesfailure = (_response: any) => { };

  const ongetordersfailure = (_response: any) => { };

  const handleTreeItemClick = (event: any) => {
    let returndata = stateCDFData.map((item) => {
      const currentItem = { ...item };
      currentItem.expanded = false;
      currentItem.selected = false;
      return currentItem;
    });
    setStateCDFData(returndata);
    if (
      stateContentData !== undefined &&
      stateContentData?.sort?.length !== undefined &&
      stateContentData.sort.length > 0 &&
      stateContentData.sort[0].field === ""
    ) {
      setStateContentData({
        sort: initialSort,
        filter: {
          logic: initialLogic,
          filters: [{ field: "path", operator: "contains", value: "" }],
        },
      });
    }
    const newSelectedItem: DataModel = searchTreeItem(stateData, event.item);
    newSelectedItem.expanded = !event.item.expanded;
    // let returndateobj: any;
    let returndateobj = setdates(
      filterType,
      false,
      "protocolorderdatefilterdiff",
      toRange,
      changedtodate
    );
    //  let fromRange = returndateobj.fromRange;
    if (returndateobj !== undefined) {
      setfromRange(returndateobj.fromRange);
      console.log(GetutcDateaudi(returndateobj.fromRange));
      settoRange(returndateobj.toRange);
    }
    initialorders = null;
    getordersforfolders(
      event.item,
      newSelectedItem,
      fromRange,
      toRange,
      protocoltype,
      SearchCriteriaType.value,
      orderflag,
      flitertest,
      fliterproject,
      false
    );
    setSelectedTreeItem(newSelectedItem);
    setSelectedCDPTreeItem(undefined);
    setDetailsData(event.item);
    setSelectedGridItem({});
    setGridSelection({});
  };
  const handleCDPTreeItemClick = (event: TreeViewItemClickEvent) => {
    const newSelectedItem: DataModel = searchTreeItem(stateCDFData, event.item);
    newSelectedItem.expanded = !event.item.expanded;
    setSelectedCDPTreeItem(newSelectedItem);
    SelectedCDPTreeItem = newSelectedItem;
    // setDetailsData(event.item);
    setSelectedGridItem({});
    setGridSelection({});
  };

  const Commonpassobject = (
    item: any,
    newSelectedItem: any,
    fromdate: any,
    todate: any,
    protocoltype: any,
    searchcriteriaType: any,
    orderflag: any
  ) => {
    let passObjDet: any = {
      directorycode: newSelectedItem.directorycode,
      objuser: {
        fromdate: GetutcDate(new Date(GetutcDateaudi(new Date(fromdate)))),
        todate: GetutcDate(new Date(todate)),
      },
      filefor: item.filefor,
      createdby: store.getState().Loggeduser,
      protocoltype: protocoltype,
      lstelnprotocolworkflow: workflow,
      lsuserMaster:
        store.getState().Loggeduser !== undefined &&
          store.getState().Loggeduser !== null &&
          Object.keys(store.getState().Loggeduser).length > 0
          ? store.getState().Loggeduser
          : {
            usercode: localStorage.getItem("User"),
            username: localStorage.getItem("Username"),
            unifieduserid: localStorage.getItem("unifieduserid"),
          },
      sitemaster: { sitecode: sessionStorage.Usersite }
    };
    if (searchcriteriaType === 3) {
      passObjDet.searchCriteriaType = searchcriteriaType;
    }
    if (orderflag !== undefined && orderflag !== -1) {
      passObjDet.orderflag = orderflag === 1 ? "N" : "R";
      if (orderflag === 3) {
        passObjDet.rejected = 1;
      }
    }

    if (orderflag !== undefined && orderflag === 4) {
      passObjDet.orderflag = orderflag === 4 ? "N" : "R";
    }

    let usermasterobj = JSON.parse(sessionStorage.teamusercode);
    passObjDet.lstuserMaster = [];
    if (usermasterobj.length > 0) {
      passObjDet.lstuserMaster = usermasterobj;
    }

    return passObjDet;
  };

  const getordersforfolders: any = (
    item: any,
    newSelectedItem: any,
    fromdate: any,
    todate: any,
    protocoltype: any,
    searchcriteriaType: any,
    orderflag: any,
    flitertest: any,
    fliterproject: any,
    iscancelled: any
  ) => {
    if (item !== undefined && item !== null) {
      if (
        (item !== undefined &&
          item.directorycode === -13 &&
          item.filefor === "MYO") ||
        (item.directorycode === -12 && item.filefor === "ASO")
      ) {
        let lSlogilabprotocoldetail: any = {
          // loginuser: store.getState().Loggeduser,
          directorycode: item.directorycode,
          protocoltype: protocoltype,
          lstelnprotocolworkflow: workflow,
          orderflag: item.filefor === "MYO" ? "M" : "A",
          sitecode: sessionStorage.Usersite,
          fromdate: GetutcDate(new Date(fromdate)),
          todate: GetutcDate(new Date(todate)),
          lsuserMaster: { usercode: sessionStorage.User },
          assignedto: { usercode: sessionStorage.User },
          objuser: { multiusergroupcode: sessionStorage.multiusergroups },
        };
        let passObjDet: any = {};
        passObjDet.lSlogilabprotocoldetail = lSlogilabprotocoldetail;
        if (searchcriteriaType === 3) {
          passObjDet.lSlogilabprotocoldetail.searchCriteriaType =
            searchcriteriaType;
          passObjDet.searchCriteriaType = searchcriteriaType;
        }
        if (orderflag !== undefined && orderflag !== -1) {
          passObjDet.orderflag = orderflag === 1 ? "N" : "R";
          if (orderflag === 3) {
            passObjDet.rejected = 1;
          }
        }

        if (flitertest.testcode !== -1) {
          passObjDet.lSlogilabprotocoldetail.testcode = flitertest.testcode;
        }
        if (
          fliterproject.projectcode !== undefined &&
          fliterproject.projectcode !== -1
        ) {
          passObjDet.lSlogilabprotocoldetail.lsprojectmaster = fliterproject;
        }

        passObjDet.filefor = item.filefor;
        passObjDet.directorycode = item.directorycode;
        setServicecall({
          // ServiceToUrl: "" + ELNurl + "/Instrument/Getuserprotocolorders",
          ServiceToUrl:
            "" + ELNurl + "/protocol/Getprotocolordersonassignedandmyorders",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess,
          ServcieonFailure: (_response: any) => { },
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else if (
        (item !== undefined && item.filefor === "OSBM") ||
        item.filefor === "OSTM"
      ) {
        let passObjDet: any = {
          // loginuser: store.getState().Loggeduser,
          selecteduser: {
            usercode: sessionStorage.User,// item.directorycode,
            username: sessionStorage.Username, // item.directoryname,
            objuser: {
              fromdate: GetutcDate(new Date(fromdate)),
              todate: GetutcDate(new Date(todate)),
            },
            lssitemaster: {
              sitecode: sessionStorage.Usersite,
              sitename: sessionStorage.Usersitename,
            },
          },
          Unifieduserid: sessionStorage.unifieduserid,
          directorycode: item.directorycode,
          protocoltype: protocoltype,
          workflow: workflow,
          filefor: item.filefor,
        };
        if (orderflag !== undefined && orderflag !== -1) {
          passObjDet = {
            ...passObjDet,
            Orderflag: orderflag === 1 ? "N" : "R",
          };
        }
        if (searchcriteriaType === 3) {
          passObjDet.searchCriteriaType = searchcriteriaType;
        }

        if (fliterproject.projectcode !== -1) {
          passObjDet.lsprojectmaster = fliterproject;
        }
        if (flitertest.testcode !== -1) {
          passObjDet.testcode = flitertest.testcode;
        }

        setServicecall({
          ServiceToUrl: "" + ELNurl + "/protocol/Getprotocolordersonshared",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: onuserordersuccess,
          ServcieonFailure: (_response: any) => { },
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else if (item !== undefined && item.filefor === "DR") {
        let passObjDet: any = {};
        let URL_Servicecall: any = "";
        if (
          item?.parentcodeondefaultfoder !== undefined &&
          item.parentcodeondefaultfoder !== null &&
          item?.path.includes("Protocol/Projects/")
        ) {
          let directorycode = item?.parentcodeondefaultfoder
            .toString()
            .split(".");

          passObjDet = {
            protocoltype: protocoltype,
            fromdate: GetutcDate(new Date(fromdate)),
            todate: GetutcDate(new Date(todate)),
            lsprojectmaster: { projectcode: parseInt(directorycode[0]) },
            testcode: parseInt(directorycode[1]),
            directorycode: newSelectedItem.directorycode,
            filefor: item.filefor,
            lstelnprotocolworkflow: workflow,
            lsuserMaster: store.getState().Loggeduser,
          };
          if (searchcriteriaType === 3) {
            passObjDet.searchCriteriaType = searchcriteriaType;
          }
          if (orderflag !== undefined && orderflag !== -1) {
            passObjDet.orderflag = orderflag === 1 ? "N" : "R";
            if (orderflag === 3) {
              passObjDet.rejected = 1;
            }
            if (orderflag !== undefined && orderflag === 3) {
              passObjDet.approvelstatus = 3;
            } else if (orderflag !== undefined && orderflag === 2) {
              passObjDet.approvelstatus = 1;
            }
          }
          passObjDet.lsprotocolorderstructure = Commonpassobject(
            item,
            newSelectedItem,
            fromdate,
            todate,
            protocoltype,
            searchcriteriaType,
            orderflag
          );

          URL_Servicecall =
            "" + ELNurl + "/Instrument/Getprotocolordersonproject";
        } else if (
          item?.parentcodeondefaultfoder !== undefined &&
          item.parentcodeondefaultfoder !== null &&
          item?.path.includes("Protocol/Material/")
        ) {
          let directorycode = item?.parentcodeondefaultfoder
            .toString()
            .split(".");

          passObjDet = {
            protocoltype: protocoltype,
            fromdate: GetutcDate(new Date(fromdate)),
            todate: GetutcDate(new Date(todate)),
            elnmaterial: { nmaterialcode: directorycode[0] },
            testcode: directorycode[1],
            directorycode: newSelectedItem.directorycode,
            filefor: item.filefor,
            lstelnprotocolworkflow: workflow,
            lsuserMaster: store.getState().Loggeduser,
            lstproject: projects,
          };
          if (searchcriteriaType === 3) {
            passObjDet.searchCriteriaType = searchcriteriaType;
          }
          if (orderflag !== undefined && orderflag !== -1) {
            passObjDet.orderflag = orderflag === 1 ? "N" : "R";
            if (orderflag === 3) {
              passObjDet.rejected = 1;
            }
            if (orderflag !== undefined && orderflag === 3) {
              passObjDet.approvelstatus = 3;
            } else if (orderflag !== undefined && orderflag === 2) {
              passObjDet.approvelstatus = 1;
            }
          }
          passObjDet.lstuserMaster = Getteamusersfromsession();

          passObjDet.lsprotocolorderstructure = Commonpassobject(
            item,
            newSelectedItem,
            fromdate,
            todate,
            protocoltype,
            searchcriteriaType,
            orderflag
          );
          URL_Servicecall =
            "" + ELNurl + "/Instrument/Getprotocolordersonmaterial";
        } else {
          passObjDet = Commonpassobject(
            item,
            newSelectedItem,
            fromdate,
            todate,
            protocoltype,
            searchcriteriaType,
            orderflag
          );

          if (fliterproject.projectcode !== -1) {
            passObjDet.lsprojectmaster = fliterproject;
          }
          if (flitertest.testcode !== -1) {
            passObjDet.testcode = flitertest.testcode;
          }
          passObjDet.iscancelled = iscancelled;


          URL_Servicecall =
            "" + ELNurl + "/Instrument/Getprotocolordersondirectory";
        }

        console.log(passObjDet);
        setServicecall({
          ServiceToUrl: URL_Servicecall,
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess.bind(this),
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
      //  else if (item !== undefined && item.filefor === "TMP") {
      //   let directorycode = newSelectedItem.directorycode.toString().split(".");

      //   let passObjDet: any = {
      //     protocoltype: protocoltype,
      //     fromdate: GetutcDate(new Date(fromdate)),
      //     todate: GetutcDate(new Date(todate)),
      //     lsprojectmaster: { projectcode: parseInt(directorycode[0]) },
      //     testcode: parseInt(directorycode[1]),
      //     directorycode: newSelectedItem.directorycode,
      //     filefor: item.filefor,
      //     lstelnprotocolworkflow: workflow,
      //     lsuserMaster: store.getState().Loggeduser,
      //   };
      //   if (searchcriteriaType === 3) {
      //     passObjDet.searchCriteriaType = searchcriteriaType
      //   }
      //   if (orderflag !== undefined && orderflag !== -1) {
      //     passObjDet.orderflag = orderflag === 1 ? "N" : "R"
      //     if (orderflag === 3) {
      //       passObjDet.rejected = 1
      //     }
      //     if (orderflag !== undefined && orderflag === 3) {
      //       passObjDet.approvelstatus = 3
      //     } else if (orderflag !== undefined && orderflag === 2) {
      //       passObjDet.approvelstatus = 1
      //     }
      //   }
      //   setServicecall({
      //     ServiceToUrl: "" + ELNurl + "/Instrument/Getprotocolordersonproject",
      //     ServiceHeaderobject: passObjDet,
      //     ServiceMethodType: "POST",
      //     ServcieonSuccess: ongetorderssuccess.bind(this),
      //     ServcieonFailure: ongetordersfailure,
      //     ServiceTenant: undefined,
      //     Servicecontenttype: undefined,
      //   });
      // } else if (item !== undefined && item.filefor === "TMS") {
      //   let directorycode = newSelectedItem.directorycode.toString().split(".");

      //   let passObjDet3: any = {
      //     protocoltype: protocoltype,
      //     fromdate: GetutcDate(new Date(fromdate)),
      //     todate: GetutcDate(new Date(todate)),
      //     lssamplemaster: { samplecode: directorycode[0] },
      //     testcode: directorycode[1],
      //     directorycode: newSelectedItem.directorycode,
      //     filefor: item.filefor,
      //     lstelnprotocolworkflow: workflow,
      //     lsuserMaster: store.getState().Loggeduser,
      //   };
      //   if (searchcriteriaType === 3) {
      //     passObjDet3.searchCriteriaType = searchcriteriaType
      //   }
      //   if (orderflag !== undefined && orderflag !== -1) {
      //     passObjDet3.orderflag = orderflag === 1 ? "N" : "R";
      //     if (orderflag === 3) {
      //       passObjDet3.rejected = 1
      //     }
      //     if (orderflag !== undefined && orderflag === 3) {
      //       passObjDet3.approvelstatus = 3
      //     } else if (orderflag !== undefined && orderflag === 2) {
      //       passObjDet3.approvelstatus = 1
      //     }

      //   }
      //   setServicecall({
      //     ServiceToUrl: "" + ELNurl + "/Instrument/Getprotocolordersonsample",
      //     ServiceHeaderobject: passObjDet3,
      //     ServiceMethodType: "POST",
      //     ServcieonSuccess: ongetorderssuccess.bind(this),
      //     ServcieonFailure: ongetordersfailure,
      //     ServiceTenant: undefined,
      //     Servicecontenttype: undefined,
      //   });
      // }
      // else if (item !== undefined && item.filefor === "TMM") {
      //   let directorycode = newSelectedItem.directorycode.toString().split(".");

      //   let passObjDet3: any = {
      //     protocoltype: protocoltype,
      //     fromdate: GetutcDate(new Date(fromdate)),
      //     todate: GetutcDate(new Date(todate)),
      //     elnmaterial: { nmaterialcode: directorycode[0] },
      //     testcode: directorycode[1],
      //     directorycode: newSelectedItem.directorycode,
      //     filefor: item.filefor,
      //     lstelnprotocolworkflow: workflow,
      //     lsuserMaster: store.getState().Loggeduser,
      //     lstproject: projects,
      //   };
      //   if (searchcriteriaType === 3) {
      //     passObjDet3.searchCriteriaType = searchcriteriaType
      //   }
      //   if (orderflag !== undefined && orderflag !== -1) {
      //     passObjDet3.orderflag = orderflag === 1 ? "N" : "R";
      //     if (orderflag === 3) {
      //       passObjDet3.rejected = 1
      //     }
      //     if (orderflag !== undefined && orderflag === 3) {
      //       passObjDet3.approvelstatus = 3
      //     } else if (orderflag !== undefined && orderflag === 2) {
      //       passObjDet3.approvelstatus = 1
      //     }

      //   }
      //   passObjDet3.lstuserMaster = Getteamusersfromsession();
      //   setServicecall({
      //     ServiceToUrl: "" + ELNurl + "/Instrument/Getprotocolordersonmaterial",
      //     ServiceHeaderobject: passObjDet3,
      //     ServiceMethodType: "POST",
      //     ServcieonSuccess: ongetorderssuccess.bind(this),
      //     ServcieonFailure: ongetordersfailure,
      //     ServiceTenant: undefined,
      //     Servicecontenttype: undefined,
      //   });

      // }
      else if (item !== undefined && (item.filefor === "CAO" || item.filefor === "RJO")) {
        let passObjDet5: any = {
          protocoltype: protocoltype,
          fromdate: GetutcDateaudi(GetutcDate(new Date(fromdate))),
          todate: GetutcDate(new Date(todate)),
          lstproject: projects,
          lstelnprotocolworkflow: workflow,
          directorycode: newSelectedItem.directorycode,
          // orderflag:
          //   item.filefor === "EPO" || item.filefor === "DPO" ? "N" : "R",
          filefor: item.filefor,
          lsuserMaster: store.getState().Loggeduser,
        };
        passObjDet5.usernotify = Getteamusersfromsession();
        if (searchcriteriaType === 3) {
          passObjDet5.searchCriteriaType = searchcriteriaType;
        }

        if (orderflag !== undefined && orderflag !== -1) {
          if (orderflag === 3) {
            passObjDet5.rejected = 1;
            passObjDet5.approvelstatus = 3;
          } else {
            passObjDet5 = {
              ...passObjDet5,
              orderflag: orderflag === 1 ? "N" : "R",
            };
          }
        }
        if (fliterproject.projectcode !== -1) {
          passObjDet5.lsprojectmaster = fliterproject;
        }
        if (flitertest.testcode !== -1) {
          passObjDet5.testcode = flitertest.testcode;
        }
        passObjDet5.lstuserMaster = Getteamusersfromsession();
        let Url = item.filefor === "CAO" ? "/protocol/Getprotocolcancelledorders" : "/protocol/GetprotocolRejectededorders";
        setServicecall({
          ServiceToUrl: "" + ELNurl + Url,
          ServiceHeaderobject: passObjDet5,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess.bind(this),
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      } else if (
        item !== undefined &&
        (item.filefor === "EPO" ||
          item.filefor === "DPO" ||
          item.filefor === "ECO" ||
          // item.filefor === "RJO" ||
          item.filefor === "DCO")
        // (item.filefor === "PO" || item.filefor === "CO")
      ) {
        columns.map((col) => {
          if (item.filefor === "ECO" || item.filefor === "DCO") {
            if (col.field === "dateCompleted") {
              col.show = true;
            }
          } else {
            if (col.field === "dateCompleted") {
              col.show = false;
            }
          }
          return col;
        });

        let passObjDet4: any = {
          protocoltype: renderSwitch(item.filefor),
          fromdate: GetutcDateaudi(GetutcDate(new Date(fromdate))),
          todate: GetutcDate(new Date(todate)),
          lstproject: projects,
          lstelnprotocolworkflow: workflow,
          directorycode: newSelectedItem.directorycode,
          orderflag:
            item.filefor === "EPO" || item.filefor === "DPO" ? "N" : "R",
          filefor: item.filefor,
          lsuserMaster: store.getState().Loggeduser,
        };
        if (searchcriteriaType === 3) {
          passObjDet4.searchCriteriaType = searchcriteriaType;
        }

        if (item.filefor === "ECO" || item.filefor === "DCO" || item.filefor === "RJO") {
          passObjDet4.activekey = orderflag;
          passObjDet4.orderflag = "R";

          if (orderflag === 3) {
            passObjDet4.rejected = 1;
            passObjDet4.approvelstatus = 3;
          } else if (orderflag !== undefined && orderflag === 2) {
            passObjDet4.approvelstatus = 1;
          }
        }
        if (fliterproject.projectcode !== -1) {
          passObjDet4.lsprojectmaster = fliterproject;
        }
        if (flitertest.testcode !== -1) {
          passObjDet4.testcode = flitertest.testcode;
        }
        passObjDet4.lstdirectorycode = flattenAndExtractDirectoryCodes(JSON.parse(JSON.stringify(stateData)), false);
        passObjDet4.lstuserMaster = Getteamusersfromsession();
        setServicecall({
          ServiceToUrl:
            "" + ELNurl + "/Instrument/Getprotocolorderbyflaganduser",
          ServiceHeaderobject: passObjDet4,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetorderssuccess.bind(this),
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
    }
    columns.map((col) => {
      if (item?.filefor === "ECO" || item?.filefor === "DCO" || item.filefor === "RJO") {
        if (col.field === "dateCompleted") {
          col.show = true;
        }
      } else {
        if (col.field === "dateCompleted") {
          col.show = false;
        }
      }
      return col;
    });
    setPullcontents(false);
  };
  const renderSwitch = (type: string) => {
    switch (type) {
      case "EPO ":
        return 1;
      case "DPO":
        return 2;
      case "ECO":
        return 1;
      case "DCO":
        return 2;
      default:
        return 1;
    }
  };


  const flattenAndExtractDirectoryCodes = (stateDataobj: any, Isdirectfolder: boolean) => {
    const result: number[] = [];
    const traverse = (items: any[]) => {
      for (const currentValue of items) {
        if ((currentValue.filefor === "DR" && currentValue.directorycode !== undefined && currentValue.directorycode > 0 && !Isdirectfolder) || (Isdirectfolder && currentValue.directorycode !== undefined && currentValue.directorycode > 0)) {
          result.push(currentValue.directorycode);
        }
        if (currentValue.items) {
          traverse(currentValue.items);
        }
      }
    };
    traverse(stateDataobj);

    return result;
  };

  const onuserordersuccess = (response: any, passeddata: any) => {


    if (response.sharebyme !== undefined) {
      response.sharebyme.forEach((item: any) => {
        if (item.protocolorders && item.protocolorders.protoclordername) {
          item.protocolorders = ProtocolSequence(item.protocolorders);
          item.protocolorders.canuserprocess = response?.workflow && response?.workflow?.length > 0 ? true : false;
        }
      });
    } else if (response.sharetome !== undefined) {
      response.sharetome.forEach((item: any) => {
        if (item.protocolorders && item.protocolorders.protoclordername) {
          item.protocolorders = ProtocolSequence(item.protocolorders);
          item.protocolorders.lstelnprotocolworkflow = (response?.workflow?.length > 0) ? response.workflow : [];
          item.protocolorders.canuserprocess = item.sharerights === 1 && item.protocolorders?.canuserprocess ? true : false;
        }
      });
    }

    console.log(response);
    let assignedorder: any = [];
    let sharedorder =
      (response.sharebyme !== null && response.sharebyme) !== undefined
        ? response.sharebyme
        : [];
    let sharetomeorder =
      response.sharetome !== null && response.sharetome !== undefined
        ? response.sharetome
        : [];

    if (
      passeddata.searchCriteriaType !== undefined &&
      passeddata.searchCriteriaType === 3 &&
      response.protocolordercodeslist !== undefined
    ) {
      let passObjDet: any = {
        ...userdetails(),
        ismultitenant: isMultitenant,
        sitecode: parseInt(sessionStorage.Usersite),
        protocolordercodelist: response.protocolordercodeslist,
        directorycode: passeddata.directorycode,
        filefor: passeddata.filefor,
        searchcontent: SearchContentText.SearchContentText,
        lstelnprotocolworkflow: workflow,
      };
      if (passeddata.filefor === "OSBM") {
        passObjDet.OSBM = "OSBM";
      } else {
        passObjDet.OSTM = "OSTM";
      }
      if (protocoltype !== -1) {
        passObjDet.protocoltype = protocoltype;
      }
      setServicecall({
        ServiceToUrl: "" + ELNurl + "/protocol/getAllProtocolStepLst",
        ServiceHeaderobject: passObjDet,
        ServiceMethodType: "POST",
        ServcieonSuccess: onuserordersuccess,
        ServcieonFailure: ongetordersfailure,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
      });
    } else {
      if (sharedorder !== undefined && sharedorder.length > 0) {
        sharedorder = groupBy(sharedorder, "shareprotocolordercode");
        sharedorder = Object.keys(sharedorder).map(function (key) {
          let order = sharedorder[key][0].protocolorders;
          order.protocolmastername =
            order.lsprotocolmaster !== undefined
              ? order.lsprotocolmaster.protocolmastername
              : undefined;
          order.samplename =
            order.lssamplemaster !== undefined
              ? order.lssamplemaster.samplename
              : undefined;
          order.projectname =
            order.lsprojectmaster !== undefined
              ? order.lsprojectmaster.projectname
              : undefined;
          let testmastervalues =
            testmasterdummy !== null ? testmasterdummy : testmaster;
          if (testmastervalues !== null) {
            let test = testmastervalues.filter(
              (items: any) => items[0] === order.testcode
            );
            if (test.length > 0) {
              order.testname = test[0][2];
            }
          }
          let shares: any = [];
          sharedorder[key].map((share: any) => {
            share.sharedonDate = convertDateFormat(
              convertUTCDateToLocalDate(new Date(share.sharedon)),
              intl
            );
            delete share.protocolorders;
            shares.push(share);
            return share;
          });
          order.sharebyme = shares;
          return order;
        });

        assignedorder = assignedorder.concat(sharedorder);
      }

      if (sharetomeorder !== undefined && sharetomeorder.length > 0) {
        sharetomeorder = groupBy(sharetomeorder, "shareprotocolordercode");
        sharetomeorder = Object.keys(sharetomeorder).map(function (key) {
          let order = sharetomeorder[key][0].protocolorders;
          let shares: any = [];
          sharetomeorder[key].map((share: any) => {
            share.sharedonDate = convertDateFormat(
              convertUTCDateToLocalDate(new Date(share.sharedon)),
              intl
            );
            delete share.protocolorders;
            shares.push(share);
            return share;
          });
          if (sharetomeorder[key][0].sharerights !== undefined && sharetomeorder[key][0].sharerights === 0) order.canuserprocess = false;
          order.sharetome = shares;
          return order;
        });

        assignedorder = assignedorder.concat(sharetomeorder);
      }
      let itemdata = [];
      if (assignedorder !== undefined && assignedorder.length > 0) {
        itemdata = assignedorder;
        if (testmaster !== null) {
          itemdata = itemdata.map((item: any) => {
            let test = testmaster.filter(
              (items: any) => items[0] === item.testcode
            );
            if (test.length > 0) {
              item.testname = test[0][2];
            }
            return item;
          });
        }
      }
      // let directorycode = response.directorycode;
      // let newData = replaceallordertoFolderwithfilefor(
      //   stateData,
      //   directorycode,
      //   intl,
      //   assignedorder,
      //   // "UR",
      //   passeddata.filefor,
      //   screen
      // );
      // let selectedtree = getDirectoryOncodeandfilefor(
      //   newData,
      //   directorycode,
      //   passeddata.filefor,
      // );
      // setSelectedTreeItem(selectedtree);
      // setStateData(newData);
      orderdataforfolder = itemdata;
      getfolderfiles(passeddata, undefined);
    }
  };

  const handleSplitterChange = (event: SplitterOnChangeEvent) => {
    setPanes(event.newState);
  };

  const handleSelectionChange = (event: GridRowClickEvent, skipdata: any) => {
    // if (contentView === "grid" && click >= 2) {
    //   handleGridDoubleClick(event, skipdata);
    // }
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }
    setSelectedGridItem(event.dataItem);
    updateFileDetailsData(event.dataItem);
    if (event.dataItem.path) {
      const key = event.dataItem["path"].toString();
      setGridSelection({ [key]: true });
    }
  };

  const handleMultipleSelection = (event: any, skipdata: any) => {
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }
    const newSelection = getSelectedState({
      event,
      selectedState: gridSelection,
      dataItemKey: DATA_ITEM_KEY,
    });

    setGridSelection(newSelection);
    updateFileDetailsData(newSelection);
  };

  const handleSortChange = (event: SortChangeEvent, skipdata: any) => {
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }
    const newSortedData = clone(stateContentData);

    if (event.direction === "asc" || event.direction === "desc") {
      newSortedData.sort[0].dir = event.direction;
    }

    if (event.item) {
      newSortedData.sort[0].field = event.item.value;
    }

    if (event.sort) {
      newSortedData.sort = event.sort;
    }
    if (event?.direction === undefined) {
      setsortSelectedText(event.item.text || "");
    }
    setStateContentData(newSortedData);
  };

  const handleGridDoubleClick = (
    event: GridRowDoubleClickEvent,
    skipdata: any
  ) => {
    if (skipdata !== undefined) {
      setTakeskip(skipdata);
    }
    const itemType = convertExtensionToIcon(event.dataItem.path, null);
    if (itemType?.type === props.t("Header.IDS_LBL_FOLDERS")) {
      if (selectedTreeItem) {
        selectedTreeItem.expanded = true;
      }

      const newSelectedItem = searchTreeItem(stateData, event.dataItem);
      newSelectedItem.expanded = true;
      setSelectedTreeItem(newSelectedItem);
      initialorders = null;
      getordersforfolders(
        event.dataItem,
        newSelectedItem,
        fromRange,
        toRange,
        protocoltype,
        SearchCriteriaType.value,
        orderflag,
        flitertest,
        fliterproject,
        false
      );
    } else if (
      event.dataItem !== undefined &&
      event.dataItem.order !== undefined &&
      event.dataItem.order.ordercancell === undefined
    ) {
      handleOrderopenClick(null, event.dataItem.order);
      // handleOrderopenClickfirst(null, event.dataItem.order);
    } else if (
      event.dataItem !== undefined &&
      event.dataItem.order !== undefined &&
      event.dataItem.order.ordercancell !== undefined &&
      event.dataItem.order.ordercancell === 1
    ) {
      props.alert.error(
        props.t("Orders.Protocolorders.IDS_LBL_CANCELLORDEROPEN")
      );
    }
  };

  const handleMultiSelectClick = (event: any, item: any) => {
    let itemindex = selectedOrders.findIndex(
      (obj) => obj.protocolordercode === item.protocolordercode
    );
    if (itemindex > -1) {
      selectedOrders.splice(itemindex, 1);
    } else {
      selectedOrders.push(item);
    }
  };
  const Auditcancel = () => {
    ($("#auditTrailModalProtocolview") as any).modal("hide");
    const fileduids = files.map(function (file) {
      return file["uid"];
    });
    const screen = "protocol";
    Servicecalls(
      "" + ELNurl + "/Instrument/onDeleteforCancel/" + screen,
      fileduids,
      ondeletefileCancelSuccess.bind(this),
      ondeletefileCancelFailure.bind(this)
    );
    setFiles([]);
  };
  const ondeletefileCancelSuccess = () => { };
  const ondeletefileCancelFailure = () => { };
  const handlecancelClick = (event: any) => {
    SelectedCDFvalue = 4;
    setSelectedCDPTreeItem(undefined);
    let returndata = stateCDFData.map((item) => {
      const currentItem = { ...item };
      currentItem.expanded = false;
      currentItem.selected = false;
      return currentItem;
    });
    setStateCDFData(returndata);
  };


  const handleexportClick = (evet: any) => {
    if ((excelExportRef.current !== null && contentView === "grid") || (contentView === "list")) {
      // if (contentView === "list") {
      let item = selectedTreeItem && selectedTreeItem.items
        ? process(
          selectedTreeItem.items.map((item: any) => ({
            ...item,
            [SELECTED_FIELD]: gridSelection[idGetter(item)],
          })),
          stateContentData
        )
        : !selectedTreeItem
          ? process(
            stateData.map((item) => ({
              ...item,
              [SELECTED_FIELD]: gridSelection[idGetter(item)],
            })),
            stateContentData
          )
          : null;
      const dateFields = ['dateCompleted', 'dateCreated', 'dateModified'];

      excelExportRef.current = {
        allResult: {
          data: (item?.data || []).reduce((acc, items) => {
            if (!items?.order) return acc;
            const order = { ...items.order };
            for (const field of dateFields) {
              if (items[field] !== undefined) {
                order[field] = items[field];
              }
            }
            return [...acc, order];
          }, []),
          columns,
        },
      };
      // }
      gridDtatExportToolBar(evet, excelExportRef, "Protocol Orders", contentView);
    }
  }

  const handleExcelExport = (excelExportRefobj: any, allResult: any) => {
    if (excelExportRefobj.current !== null) {
      excelExportRef = excelExportRefobj;
      excelExportRef.current.allResult = allResult;
    }
  };

  const handleNewFolderClick = (event: any) => {
    Folderadd_Event = event;
    let newData = props.sessionvalues;
    newData.directoryname = event.value;
    newData.viewoption = event.folderplace;
    newData.sitemaster = { sitecode: sessionStorage.Usersite };
    newData.createdby = { usercode: sessionStorage.User };
    // newData.teamcode = event.projectteamcode !== undefined ? event.projectteamcode.teamcode : undefined;
    let Selected_Treeitems =
      Isview_Constence && Object.keys(selectedGridItem).length > 0
        ? selectedGridItem
        : SelectedCDFvalue === 5 && selectedCDPTreeItem
          ? selectedCDPTreeItem
          : selectedTreeItem;
    if (Selected_Treeitems) {
      if (
        (Selected_Treeitems !== undefined &&
          Selected_Treeitems.filefor === "DR") ||
        Selected_Treeitems.filefor === "TMP" ||
        Selected_Treeitems.filefor === "TMS" ||
        Selected_Treeitems.filefor === "TMM"
      ) {
        let parts = Selected_Treeitems?.directorycode?.toString().split(".");
        if (parts?.length === 2) {
          newData.parentdircode = parts[0];
          newData.floatvalues = parts[1];
        } else {
          newData.parentdircode = Selected_Treeitems.directorycode;
        }
      } else {
        newData.parentdircode = stateData[0].parentdircode;
      }
    } else {
      newData.parentdircode = stateData[0].parentdircode;
    }

    if (
      Object.keys(event?.FOlder_Type).length > 0 &&
      Object.keys(event?.Onselected_Foldertype).length > 0
    ) {
      const folderTypeCode = event.FOlder_Type.code;
      if (folderTypeCode !== 0) {
        const folderMapValues =
          folderTypeCode === 1
            ? event.Onselected_Foldertype.projectname
            : folderTypeCode === 2
              ? event.Onselected_Foldertype.testname
              : event.Onselected_Foldertype.matname;

        newData.foldermapping = `${event.FOlder_Type.Folder_Type} - ${folderMapValues}`;

        if (event.Onselected_Foldertype?.projectcode !== undefined) {
          newData.parentcodeondefaultfoder = event.Onselected_Foldertype?.projectcode
        }
      } else {
        newData.foldermapping = `${event.FOlder_Type.Folder_Type}`;
      }
    }

    Servicecalls(
      "" + ELNurl + "/Instrument/Insertdirectoryonprotocol",
      newData,
      onfoldersuccess,
      onfolderfailure
    );
  };

  const onfoldersuccess = (response: any, event: any) => {
    let validData = response.response.status;
    let newData = props.sessionvalues;
    response.parentdircode = response.parentdircode + "." + event.floatvalues;
    // response.floatvalues = event.floatvalues;
    newData.sitemaster = { sitecode: sessionStorage.Usersite };
    newData.createdby = { usercode: sessionStorage.User };
    newData.objmanualaudit = Manualauditobject("Create", "Protocol Orders");
    let Selected_Treeitems =
      Isview_Constence && Object.keys(selectedGridItem).length > 0
        ? selectedGridItem
        : SelectedCDFvalue === 5 && selectedCDPTreeItem
          ? selectedCDPTreeItem
          : selectedTreeItem;
    if (validData) {
      if (
        Selected_Treeitems &&
        (Selected_Treeitems?.filefor === "DR" ||
          Selected_Treeitems.filefor === "TMP" ||
          Selected_Treeitems.filefor === "TMS" ||
          Selected_Treeitems.filefor === "TMM")
      ) {
        newData = getFolderToSave(
          stateData,
          Selected_Treeitems,
          intl,
          response.directoryname,
          "ProtocolOrder",
          response
        );
      } else {
        newData = getFolderToSave(
          stateData,
          null,
          intl,
          response.directoryname,
          "ProtocolOrder",
          response
        );
      }
      let Audit = AuditTrailValidation(
        "IDS_MDL_ORDERS",
        "IDS_SCN_PROTOCOLORDERS",
        "IDS_TSK_NEWFOLDER"
      );
      newData.parentdircode = event.parentdircode;
      newData.floatvalues = event.floatvalues;
      if (Audit) {
        ($("#auditTrailModalProtocolview") as any).modal("show");
        newData.objmanualaudit = Manualauditobject("create", "Protocol Orders");
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/Instrument/Insertnewdirectoryonprotocol",
          AuditObject: newData,
          AuditPassfunction: oninsertfoldersuccess,
          AuditFailfunction: oninsertfolderfailure,
        });
      } else {
        Servicecalls(
          "" + ELNurl + "/Instrument/Insertnewdirectoryonprotocol",
          newData,
          oninsertfoldersuccess,
          oninsertfolderfailure
        );
      }
    } else {
      props.alert.error(props.t("Orders.Protocolorders.IDS_MSG_FOLDEREXIST"));
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "warning",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_FOLDEREXIST", {
            folder: response.directoryname,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
  };

  const onfolderfailure = (_response: any) => { };

  const oninsertfoldersuccess = (response: any) => {
    if (response.floatvalues !== undefined) {
      response.parentdircode = parseFloat(
        response.parentdircode + "." + response.floatvalues
      );
    }
    ($("#auditTrailModalProtocolview") as any).modal("hide");
    props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FOLDERADDED"));
    let newData;
    if (response !== undefined) {
      response.icon = convertExtensionToIcon(response.directoryname, null);
      response.dateCreated = convertDateFormat(
        new Date(response.dateCreated),
        intl
      );
      // response.dateModified = convertDateFormat(
      //   new Date(response.dateCreated),
      //   intl
      // );
      response.filefor = "DR";
      response.Created_By = sessionStorage.Username;
    }
    let Selected_Treeitems =
      Isview_Constence && Object.keys(selectedGridItem).length > 0
        ? selectedGridItem
        : SelectedCDFvalue === 5 && selectedCDPTreeItem
          ? selectedCDPTreeItem
          : selectedTreeItem;
    if (
      Selected_Treeitems &&
      (Selected_Treeitems?.filefor === "DR" ||
        Selected_Treeitems.filefor === "TMP" ||
        Selected_Treeitems.filefor === "TMS" ||
        Selected_Treeitems.filefor === "TMM")
    ) {
      newData = addFolderonObj(stateData, Selected_Treeitems, intl, response);

      // if (selectedtree?.directorycode && selectedtree?.filefor)
      //   setSelectedTreeItem(getDirectoryOncodeandfilefor(newdata, selectedtree?.directorycode, selectedtree?.filefor));

      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "create",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_WITHINANOTHERFOLDER", {
            user: sessionStorage.Username,
            folder2: response.directoryname,
            folder1: Selected_Treeitems.directoryname,
            visible:
              response.viewoption === 1
                ? "Site"
                : response.viewoption === 2
                  ? "Only me"
                  : "Project Team",
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    } else {
      newData = addFolderonObj(stateData, null, intl, response);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "create",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_REQADDNEWFOLDER", {
            user: sessionStorage.Username,
            folder: response.directoryname,
            visible:
              response.viewoption === 1
                ? "Site"
                : response.viewoption === 2
                  ? "Only me"
                  : "Project Team",
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    // setStateData(newData);
    const newTreeItem = searchTreeItem(newData, response);
    setSelectedTreeItem(newTreeItem);
    let Allstate_Data = flattenHierarchy(JSON.parse(JSON.stringify(newData)));
    let Statevalues_update: DataModel[] = expandPathInHierarchy(
      Allstate_Data,
      response.path,
      newData
    );
    setStateData(Statevalues_update);
    if (Folderadd_Event?.Enable_Newfolder !== undefined) {
      setSelectedCDPTreeItem(newTreeItem);
      SelectedCDPTreeItem = newTreeItem;
    } else {
      setSelectedCDPTreeItem(undefined);
      SelectedCDPTreeItem = undefined;
    }
    setSelectedCDPTreeItem(undefined);
    SelectedCDPTreeItem = undefined;
    SelectedCDFvalue = 4;
    setDetailsData(response);
    ChoosePath(Statevalues_update);
    setPullcontents(true);
    // setStateCDFData(newData?.filter((item: any) => item.filefor === "PR" || item.filefor === "DR" || item.filefor === "SMM"))
    Isview_Constence = false;
  };

  const oninsertfolderfailure = (_response: any) => { };

  const handleRegisterOrder = (response: any) => {
    let selectprotocolOrderData = response.selectprotocolOrderData;
    let selectedtest = response.selectTestData;
    let SelectedProtocol = response.SelectedProtocol;
    let selectedproject = response.selectProjectData;
    let selectedsample = response.selectSampleData;
    let selectedrepository = response.selectRepoData;
    let selectedrepositorydata = response.selectRepodataData;
    let selectedworkflow = response.selectWflowData;
    let selectedkeyword = response.selectOrderKey;
    let selectedfolder = response.selectFolderData;
    let selectassigneduser = response.selectassigneduser;
    let viewoption = response.viewoption;
    let selectedMaterial = response.selectMaterial;
    let selectedMaterialInventory = response.selectMaterialInventory;
    let duedate = response.duedate;
    let cautiondate = response.cautiondate;
    let period = response.period;
    let Repeat = response.Repeat;
    let Interval = response.Interval !== undefined ? response.Interval : null;
    let timespan = response.timespan;
    let autocreatedate = response.autocreatedate;
    let Autoregister_Count = response?.Autoregister_Count;
    let selectedprojectteam = response?.selectedprojectteam;
    let teamselected = response?.selectedprojectteam.length > 0 ? true : false;
    // let teamcode = response.projectteamcode !== undefined ? response.projectteamcode.teamcode : undefined
    // if (selectedfolder !== undefined && selectedfolder !== null && response.orderdisplaytype === 4) {
    //     setSelectedTreeItem(selectedfolder);
    //     setDetailsData(selectedfolder);
    //     setSelectedGridItem({});
    //     setGridSelection({});
    // }

    // let silentaudit = Silentauditobject(
    //   "warning",
    //   "Protocol Orders",
    //   props.t("Orders.Protocolorders.IDS_MSG_PROTOALERT")
    // );
    let sequence = getsequenceoncode(2);
    let passObjDet: any = {
      testcode:
        selectedtest !== undefined && selectedtest !== null
          ? selectedtest.testcode
          : null,
      lstestmasterlocal: selectedtest !== undefined && selectedtest !== null ? selectedtest : null,
      sitecode: sessionStorage.Usersite,
      sample:
        selectedsample !== undefined && selectedsample !== null
          ? selectedsample
          : null,
      lsprojectmaster: selectedproject,
      protocoltype: selectprotocolOrderData.type,
      lsprotocolmaster: SelectedProtocol,
      templateversionno: SelectedProtocol?.approved !== undefined && SelectedProtocol?.approved === 1 ? (SelectedProtocol?.versionno) : (SelectedProtocol?.versionno - 1),// SelectedProtocol?.versionno ? SelectedProtocol?.versionno : 1,
      testname:
        selectedtest !== undefined && selectedtest !== null
          ? selectedtest.testname
          : null,
      lsfile: SelectedProtocol,
      keyword: selectedkeyword,
      tittle: response.selectOrdertittle,
      ismultitenant: isMultitenant,
      createdtimestamp: GetutcDate(new Date()),
      // objsilentaudit: silentaudit,
      createdbyusername: sessionStorage.Username,
      objmanualaudit: Manualauditobject("insert", "Protocol Orders"),
      objuser: { multiusergroupcode: sessionStorage.multiusergroups },
      multiusergroupcode: sessionStorage.multiusergroups,
      createby: sessionStorage.User,
      lsuserMaster: store.getState().Loggeduser,
      lsrepositories: !isPremiumTenant ? selectedrepository : null,
      lsrepositoriesdata: !isPremiumTenant ? selectedrepositorydata : null,
      elnmaterial: selectedMaterial?.matcode !== undefined ? { nmaterialcode: selectedMaterial?.matcode, smaterialname: selectedMaterial.matname } : null,
      elnmaterialinventory: isPremiumTenant ? selectedMaterialInventory : null,
      lstelnprotocolworkflow: workflow,
      assignedto:
        selectedworkflow !== null &&
          selectedworkflow !== undefined &&
          selectedworkflow.usercode !== null &&
          selectedworkflow.usercode > 0
          ? selectedworkflow
          : null,
      directorycode:
        selectedfolder === undefined || selectedfolder === null
          ? null
          : selectedfolder.directorycode,
      orderdisplaytype: response.orderdisplaytype,
      viewoption:
        selectedproject !== undefined && selectedproject !== null
          ? 1
          : viewoption,
      content:
        selectprotocolOrderData.type === 2
          ? JSON.stringify(protocolordercontent)
          : "",
      duedate: GetutcDate(duedate),
      cautiondate: GetutcDate(cautiondate),
      period: period !== undefined ? period.name : "",
      repeat: Repeat,
      lsprotocolselectedTeam: selectedprojectteam,
      teamselected: teamselected,
      isclone: false,
      sequenceid: sequence && formsequenceformatview(JSON.parse(sequence.sqf), sequence.sep, "g", {
        projectname: selectedproject && selectedproject.projectname ? selectedproject.projectname : "",
        projectcode: selectedproject && selectedproject.projectid ? selectedproject.projectid : ""
        , task: selectedtest && selectedtest.testname ? selectedtest.testname : "",
        ordertype: getprotocolordertype(parseInt(selectprotocolOrderData.type))
      })
    };

    if (Repeat) {
      passObjDet.autoregistercount = Autoregister_Count;
    }

    passObjDet.lsautoregisterorder =
      Repeat === true
        ? {
          repeat: Repeat,
          interval: Interval,
          timespan: timespan !== undefined ? timespan.name : "",
          //screen: "Protocol_Order",
          autocreatedate: autocreatedate,
          ismultitenant: isMultitenant,
          isautoreg: false,
        }
        : null;

    if (passObjDet.lsautoregisterorder !== null) {
      passObjDet.lsautoregisterorder.screen = "Protocol_Order";
    }

    passObjDet.sitecode = sessionStorage.Usersite;

    if (selectassigneduser !== undefined) {
      passObjDet.assignedto =
        selectassigneduser !== null &&
          selectassigneduser !== undefined &&
          selectassigneduser.usercode !== null &&
          selectassigneduser.usercode > 0
          ? selectassigneduser
          : null;
    }
    // passObjDet.keyword = selectedkeyword;

    // if (viewoption === 3) {
    //   passObjDet.teamcode = teamcode
    // }
    passObjDet.lsActiveWidgets = {
      screenname: "Protocol_Order",
      activityType: "Insert",
      userId: sessionStorage.User,
    };
    passObjDet.isDefault = protocoldefaultcheck();

    let Audit = AuditTrailValidation(
      "IDS_MDL_ORDERS",
      "IDS_SCN_PROTOCOLORDERS",
      "IDS_TSK_REGPROTOCOL"
    );
    let ordersuccess = false;
    if (response.selectWflowData !== undefined) {
      ordersuccess = true;
    }
    if (Audit) {
      ($("#auditTrailModalProtocolview") as any).modal("show");
      passObjDet.objmanualaudit = Manualauditobject(
        "registered",
        "Protocol Orders"
      );

      setAuditservicecall({
        AuditUrl: "" + ELNurl + "/protocol/addProtocolOrder",
        AuditObject: passObjDet,
        AuditPassfunction: oninsertordersuccess.bind(
          this,
          ordersuccess,
          selectedfolder
        ),
        AuditFailfunction: oninsertorderfailure.bind(this),
      });
    } else {
      Servicecalls(
        "" + ELNurl + "/protocol/addProtocolOrder",
        passObjDet,
        oninsertordersuccess.bind(this, ordersuccess, selectedfolder),
        oninsertorderfailure.bind(this)
      );
    }
  };

  const expandPathInHierarchy = (
    stateDataobj: any,
    path: any,
    stateData: any
  ) => {
    const pathSegments = path.split("/");
    let currentLevel = stateDataobj;
    const Fullpath = pathSegments.reduce(
      (Path: any, Items: any, index: any) => {
        if (index === 0 && Items === "ProtocolOrder") {
          Items = "Protocol";
        }
        Path = Path ? `${Path}/${Items}` : Items;
        const matchingFolder = currentLevel.find(
          (folder: any) => folder.path === Path
        );
        if (matchingFolder) {
          let State_updateddata = Onsetfolderexpande(
            stateData,
            matchingFolder?.directorycode,
            screen
          );
          stateData = State_updateddata;
        }
        return Path;
      },
      ""
    );
    return stateData;
  };

  const flattenHierarchy = (stateDataobj: any) => {
    return stateDataobj?.reduce((result: any[], currentValue: any) => {
      result.push(currentValue);
      if (currentValue.items) {
        result = result.concat(flattenHierarchy(currentValue.items));
      }
      return result;
    }, []);
  };

  const onaddProtocolOrderafterfirstofterSuccess = (_response: any) => {
    console.log("first servide");
  };
  const onaddProtocolOrderafterSuccess = (selectedfolderobj: any) => {
    console.log("second servide");
    console.log(selectedfolderobj?.filefor);

    if (
      selectedfolderobj.directorycode !== undefined &&
      selectedfolderobj.filefor !== undefined &&
      selectedfolderobj.filefor === "DR"
    ) {
      let directorycode = selectedfolderobj.directorycode;

      /** newly created order alone missing , that's y added 1min by taking clone */
      // const toDate = new Date(toRange);
      const toDate = new Date(toRange instanceof Date ? toRange.getTime() : new Date(toRange).getTime());
      toDate.setMinutes(toDate.getMinutes() + 1);

      let passObjDet: any = {
        directorycode: directorycode,
        objuser: {
          fromdate: GetutcDate(new Date(fromRange)),
          // todate: GetutcDate(new Date(toRange)),
          todate: GetutcDate(new Date(toDate)),
        },
        createdby: store.getState().Loggeduser,
        protocoltype: protocoltype,
        lstelnprotocolworkflow: workflow,
        lsuserMaster:
          store.getState().Loggeduser !== undefined &&
            store.getState().Loggeduser !== null &&
            Object.keys(store.getState().Loggeduser).length > 0
            ? store.getState().Loggeduser
            : {
              usercode: localStorage.getItem("User"),
              username: localStorage.getItem("Username"),
              unifieduserid: localStorage.getItem("unifieduserid"),
            },
        sitemaster: { sitecode: parseInt(sessionStorage.Usersite) },
        filefor: selectedfolderobj.filefor
      };
      if (SearchCriteriaType.value === 3) {
        passObjDet.searchCriteriaType = SearchCriteriaType.value;
      }
      if (orderflag !== undefined && orderflag !== -1) {
        passObjDet.orderflag = orderflag === 1 ? "N" : "R";
        if (orderflag === 3) {
          passObjDet.rejected = 1;
        }
      }
      let usermasterobj = JSON.parse(sessionStorage.teamusercode);
      passObjDet.lstuserMaster = [];
      if (usermasterobj.length > 0) {
        passObjDet.lstuserMaster = usermasterobj;
      }

      if (fliterproject.projectcode !== -1) {
        passObjDet.lsprojectmaster = fliterproject;
      }
      if (flitertest.testcode !== -1) {
        passObjDet.testcode = flitertest.testcode;
      }

      passObjDet.iscancelled = iscancelled;

      Servicecalls(
        "" + ELNurl + "/Instrument/Getprotocolordersondirectory",
        passObjDet,
        // ongetorderssuccessafterregister,
        ongetorderssuccess,
        ongetordersfailure
      );
    }

  };
  const onaddProtocolOrderafterfirstofterFaliure = (_response: any) => { };
  const onaddProtocolOrderafterFaliure = (_response: any) => { };

  const updateTransaction = (response: any) => {
    // let passobj = {
    //   // protocolorderstepcode: this.state.protocolToBeEdited.protocolorderstepcode,
    //   protocolordercode: this.state.SelectedData.protocolordercode,
    //   createby: { usercode: sessionStorage.User },
    //   stependdate: GetutcDate(new Date()),
    //   action: this.props.t("Templates.Protocoltemplates.IDS_LBL_PROCESSORDER", {
    //     batchid: this.state.SelectedData.protoclordername,
    //     Processed: "Closed",
    //     user2: sessionStorage.Username
    //   }),
    //   viewoption: 2
    // }

    let passobj = {
      protocolordercode: response.AddedProtocol.protocolordercode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Orders.Sheetorders.IDS_AUDIT_AUTOREGISTERSTART", {
        batchid: response.AddedProtocol.protoclordername,
      }),
      viewoption: 2,
    };
    Servicecalls(
      "" + ELNurl + "/protocol/updatetransactionhistory",
      passobj,
      (res: any) => { },
      (res: any) => { }
    );
  };

  const oninsertordersuccess = (
    _ordersuccess: any,
    selectedfolderobj: any,
    response: any
  ) => {
    //for refresh issue
    let dup_response = { ...response.AddedProtocol };
    let shortnedres = ProtocolSequence(dup_response);
    response.AddedProtocol.protoclordername = shortnedres.protoclordername;

    ($("#auditTrailModalProtocolview") as any).modal("hide");

    console.log(response);
    if (
      response.AddedProtocol.lsautoregister !== undefined &&
      response.AddedProtocol.lsautoregister !== null
    ) {
      console.log(response);
      updateTransaction(response);
    }

    if (!response?.AddedProtocol?.canuserprocess && response?.AddedProtocol?.lsprojectmaster === undefined) {
      response.AddedProtocol.canuserprocess = true;
    }

    if (response !== undefined) {

      if (response.AddedProtocol?.isclone) {
        setDuplicateorder(false);
        props.alert.success(
          props.t("Orders.Protocolorders.IDS_MSG_ELNPROTOCOLORDERCLONESUCCESS", {
            orderid: response.AddedProtocol.protoclordername,
            screenname:
              isMultitenant === 2
                ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
                : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERS"),
            param: "",
          })
        )
        const { protoclordername, protocolordercode, versionno } = dublicateorderitem;
        let passObjDet1 = {
          objsilentaudit: Silentauditobject(
            "cloned",
            "Protocol Orders",
            props.t("Orders.Protocolorders.IDS_AUDIT_CLONEPROTOCOLORDERS", {
              oldorderid: protoclordername,
              version: versionno,
              screenName: "Protocol Order",
              neworderid: response.AddedProtocol.protoclordername,
              user: store.getState().Loggeduser.username,
            })
          ),
        };
        Servicecalls(
          "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet1,
          onAuditValidateError.bind(this),
          onAuditValidateFailure.bind(this)
        );

        // "IDS_MSG_ORDERCLONE": "order {batchid1} was cloned from {Originalbatchid} v {version} by {user}",
        //     "IDS_MSG_ORDERCLONEORIGINAL": "Order {Originalbatchid} v {version} was cloned  and registered as a new protocol order {batchid1} by {user}",
        const clonedOrderCode = response.AddedProtocol.protoclordername; // new cloned order ID
        const currentUser = sessionStorage.User;
        const currentUsername = sessionStorage.Username;
        const passObjDet: any[] = [0, 1].map((index) => {
          const isOriginal = index === 0;
          return {
            protocolordercode: isOriginal ? protocolordercode : response?.AddedProtocol?.protocolordercode,
            createby: { usercode: currentUser },
            stepstartdate: GetutcDate(new Date()),
            action: props.t(isOriginal ? "Templates.Protocoltemplates.IDS_MSG_ORDERCLONEORIGINAL" : "Templates.Protocoltemplates.IDS_MSG_ORDERCLONE", {
              Originalbatchid: protoclordername,
              batchid1: clonedOrderCode,
              user: currentUsername,
              version: versionno || 1
            }),
            viewoption: 6,
          };
        });
        Servicecalls(
          "" + ELNurl + "/protocol/updateTransactionHistoryList",
          passObjDet,
          ongetordersfailure,
          ongetordersfailure
        );

      } else {
        response.AddedProtocol.protocoltype === 1
          ? props.alert.success(
            props.t("Orders.Protocolorders.IDS_MSG_ELNPROTOCOLORDERSUCCESS", {
              orderid: response.AddedProtocol.protoclordername,
              screenname:
                isMultitenant === 2
                  ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
                  : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERS"),
              param: "",
            })
          )
          : props.alert.success(
            props.t(
              "Orders.Protocolorders.IDS_AUDIT_DYNAMICPROTOCOLORDERSUCCESS",
              {
                orderid: response.AddedProtocol.protoclordername,
                screenname:
                  isMultitenant === 2
                    ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
                    : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERS"),
                param: "",
              }
            )
          );
        if (response.AddedProtocol.protocoltype === 1) {
          let passObjDet1 = {
            objsilentaudit: Silentauditobject(
              "registered",
              "Protocol Orders",
              props.t("Orders.Protocolorders.IDS_AUDIT_INSERTPROTOCOLORDERS", {
                orderid: response.AddedProtocol.protoclordername,
                user: store.getState().Loggeduser.username,
                screenName: "ELN Protocol Order",
                visible:
                  response.AddedProtocol.viewoption === 1
                    ? "Site"
                    : response.AddedProtocol.viewoption === 2
                      ? "Only me"
                      : response.AddedProtocol.viewoption === 3
                        ? "Project Team"
                        : "",
              })
            ),
          };
          Servicecalls(
            "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet1,
            onAuditValidateError.bind(this),
            onAuditValidateFailure.bind(this)
          );
        } else if (response.AddedProtocol.protocoltype === 2) {
          let passObjDet1 = {
            objsilentaudit: Silentauditobject(
              "registered",
              "Protocol Orders",
              props.t("Orders.Protocolorders.IDS_AUDIT_INSERTPROTOCOLORDERS", {
                orderid: response.AddedProtocol.protoclordername,
                user: store.getState().Loggeduser.username,
                screenName: "Dynamic Protocol Order",
                visible:
                  response.AddedProtocol.viewoption === 1
                    ? "Site"
                    : response.AddedProtocol.viewoption === 2
                      ? "Only me"
                      : response.AddedProtocol.viewoption === 3
                        ? "Project Team"
                        : "",
              })
            ),
          };
          Servicecalls(
            "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet1,
            onAuditValidateError.bind(this),
            onAuditValidateFailure.bind(this)
          );
        }
      }
      let passObjDet = {};
      if (
        response.AddedProtocol.assignedto !== undefined &&
        response.AddedProtocol.assignedto.userstatus === "Locked"
      ) {
        passObjDet = {
          objsilentaudit: Silentauditobject(
            "assign",
            "Protocol Orders",
            props.t("Orders.Protocolorders.IDS_AUDIT_PROTOCOLASSIGNTOUSER", {
              screen: orderTypeforprotocol(response.AddedProtocol.protocoltype),
              user1: response.AddedProtocol.protoclordername,
              user2: response.AddedProtocol.assignedto.username,
              user: store.getState().Loggeduser.username,
            })
          ),
        };
        Servicecalls(
          "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          onAuditValidateError.bind(this),
          onAuditValidateFailure.bind(this)
        );
      }
      let passobj = response.AddedProtocol;
      passobj.fromdate = new Date(fromRange);
      passobj.lsuserMaster = { usercode: sessionStorage.User };
      passobj.ismultitenant = isMultitenant;
      passobj.todate = new Date();
      if (passobj.protocoltype === 1) {
        var copyinfo = [];
        if (isMultitenant === 1 || isMultitenant === 2) {
          copyinfo = passobj.cloudLsLogilabprotocolstepInfo;
        } else {
          copyinfo = passobj.lsLogilabprotocolstepInfo;
        }
        if (copyinfo !== undefined) {
          copyinfo = copyinfo.map((item: any) => {
            var info: any = "";
            if (isMultitenant === 1 || isMultitenant === 2) {
              if (
                item.id !== undefined &&
                item.lsprotocolstepInfo === undefined
              ) {
                item.lsprotocolstepInfo = JSON.stringify("<p><br></p>");
              }
              info = JSON.parse(item.lsprotocolstepInfo);
              if (info.protocolstepinfo !== undefined) {
                info = info.protocolstepinfo;
              }
            } else {
              if (item.id !== undefined && item.content === undefined) {
                item.content = JSON.stringify("<p><br></p>");
              }
              info = JSON.parse(item.content);
              if (info.protocolstepinfo !== undefined) {
                info = info.protocolstepinfo;
              }
            }
            const parser = new DOMParser();
            info = info.replaceAll(
              'hidden="" hiddenmode="register"',
              'hiddenmode="register"'
            );
            const doc = parser.parseFromString(info, "text/html");
            //constent freeze
            // Find all elements that are not <span> with class 'restrict-edit'
            // const elementsToChange = Array.from(doc.body.querySelectorAll('*:not(.restrict-edit):not(td):not(td :not(yourChildTagHere)):not(td :not(img):not(a):not(span)):not(tr):not(table):not(tbody)'));
            const elementsToChange = Array.from(
              doc.body.querySelectorAll("*:not(.restrict-edit")
            );
            elementsToChange.forEach((element: any) => {
              // element.contentEditable = false;
              // element.classList.add('prevent-select');
              if (
                element.className === "timer-delete btn btn-link prevent-select"
              ) {
                element.style.display = "none";
              }
            });
            // const elementsToChangecontentedittru = Array.from(doc.body.querySelectorAll('td'));
            // elementsToChangecontentedittru.forEach((element: any) => {
            //   element.contentEditable = true;
            // });
            info = doc.body.innerHTML;
            // info =
            //   "<div disabled='true' class='prevent-select' > " +
            //   info.substring(0, info.length) +
            //   "</div>";
            // info = "<p><br></p>" + info.substring(0, info.length) + "<p><br></p>";
            info = JSON.stringify({ protocolstepinfo: info });
            if (isMultitenant === 1 || isMultitenant === 2) {
              item.lsprotocolstepInfo = info;
            } else {
              item.content = info;
            }
            return item;
          });
          if (isMultitenant === 1 || isMultitenant === 2) {
            passobj.CloudLsLogilabprotocolstepInfo = copyinfo;
          } else {
            passobj.LsLogilabprotocolstepInfo = copyinfo;
          }
        }
      } else {
        delete passobj.cloudLsLogilabprotocolstepInfo;
        delete passobj.lsLogilabprotocolstepInfo;
      }
      setTimeout(() => {
        Servicecalls(
          "" + ELNurl + "/protocol/addProtocolOrderafterfirstofter",
          passobj,
          onaddProtocolOrderafterfirstofterSuccess,
          onaddProtocolOrderafterfirstofterFaliure
        );
      }, 0);
      if (selectedfolderobj) {
        Servicecalls(
          "" + ELNurl + "/protocol/addProtocolOrderafter",
          passobj,
          onaddProtocolOrderafterSuccess(selectedfolderobj),
          onaddProtocolOrderafterFaliure
        );
      }

    }

    if (
      response.AddedProtocol !== undefined &&
      response.AddedProtocol.orderdisplaytype !== undefined &&
      response.AddedProtocol.orderdisplaytype !== null
    ) {
      let selectedtree = selectedTreeItem;
      let testmastervalues =
        testmasterdummy !== null ? testmasterdummy : testmaster;
      let test = testmastervalues.filter(
        (items: any) => items[0] === response.AddedProtocol.testcode
      );
      if (response?.AddedProtocol?.lsprotocolmaster?.protocolmastername) {
        response.AddedProtocol.lsprotocolmaster.protocolmastername = response.AddedProtocol.lsprotocolmaster.protocolmastername.replace(/_v\d+$/i, "")

      }
      let orderobject = {
        dateCreated: convertDateFormat(
          new Date(response.AddedProtocol.createdtimestamp) || null,
          intl
        ),
        dateModified: convertDateFormat(
          new Date(response.AddedProtocol.createdtimestamp) || null,
          intl
        ),
        dateCompleted:
          response.completedtimestamp !== undefined
            ? convertDateFormat(
              convertUTCDateToLocalDate(
                new Date(response.completedtimestamp)
              ) || null,
              intl
            )
            : null,
        size: 124,
        icon: convertExtensionToIcon(
          response.AddedProtocol.protoclordername + ".ord",
          response.AddedProtocol.orderflag !== undefined &&
            response.AddedProtocol.orderflag.trim() === "R"
            ? "#54c518"
            : "#e16733"
        ),
        items: [],

        path: `${selectedtree?.path}/${response.AddedProtocol.protoclordername + ".ord"
          }`,
        directorycode: response.AddedProtocol.protocolordercode,
        parentdircode:
          response.AddedProtocol.orderdisplaytype === 3
            ? selectedtree?.directorycode
            : response.AddedProtocol.orderdisplaytype === 1 &&
              response.AddedProtocol.lsprojectmaster !== undefined &&
              response.AddedProtocol.lsprojectmaster !== null &&
              response.AddedProtocol.testcode !== undefined
              ? parseFloat(
                response.AddedProtocol.lsprojectmaster.projectcode +
                "." +
                response.AddedProtocol.testcode
              )
              : response.AddedProtocol.orderdisplaytype === 2 &&
                response.AddedProtocol.lssamplemaster !== undefined &&
                response.AddedProtocol.lssamplemaster !== null &&
                response.AddedProtocol.testcode !== undefined
                ? parseFloat(
                  response.AddedProtocol.lssamplemaster.samplecode +
                  "." +
                  response.AddedProtocol.testcode
                )
                : selectedtree?.directorycode,
        directoryname: response.AddedProtocol.protoclordername,
        order: response.AddedProtocol,
        link: generateLink(response.protocolordercode, "Protocol"),
        filefor: selectedtree?.filefor,
        projectname:
          response.AddedProtocol.lsprojectmaster !== undefined
            ? response.AddedProtocol.lsprojectmaster.projectname
            : undefined,
        protocolmastername:
          response.AddedProtocol.lsprotocolmaster !== undefined
            ? response.AddedProtocol.lsprotocolmaster.protocolmastername?.includes("_v") ? response.AddedProtocol.lsprotocolmaster.protocolmastername?.replace(/_v\d+$/i, "") : response.AddedProtocol.lsprotocolmaster.protocolmastername + "_v" + response.AddedProtocol.templateversionno || 1   //  response.AddedProtocol.lsprotocolmaster.protocolmastername
            : undefined,
        samplename:
          response.AddedProtocol.lssamplemaster !== undefined
            ? response.AddedProtocol.lssamplemaster.samplename
            : undefined,
        // testname: response?.AddedProtocol?.testname ?? test[0] ? test[0][2] : undefined,
        testname: response?.AddedProtocol?.testname ?? (test[0] ? test[0][2] : undefined),
      };
      if (
        response.AddedProtocol.assignedto &&
        response.AddedProtocol.assignedto !== null
      ) {
        if (
          response.AddedProtocol.assignedto.usercode ===
          parseInt(sessionStorage.User)
        ) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -13, "MYO");
        } else {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -12, "ASO");
        }
      } else if (
        (response.AddedProtocol.orderdisplaytype === 1 &&
          response.AddedProtocol.lsprojectmaster !== undefined &&
          response.AddedProtocol.lsprojectmaster !== null &&
          (response.AddedProtocol.directorycode === undefined ||
            response.AddedProtocol.directorycode === null)) ||
        (response.AddedProtocol.orderdisplaytype === 2 &&
          response.AddedProtocol.elnmaterial !== undefined &&
          response.AddedProtocol.elnmaterial !== null &&
          (response.AddedProtocol.directorycode === undefined ||
            response.AddedProtocol.directorycode === null))
      ) {
        if (response.AddedProtocol.protocoltype === 1) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -8, "EPO");
        } else if (response.AddedProtocol.protocoltype === 2) {
          selectedtree = getDirectoryOncodeandfilefor(stateData, -9, "DPO");
        }
      } else {
        selectedtree = getDirectoryOncodeandfilefor(
          stateData,
          response.AddedProtocol.directorycode,
          "DR"
        );

        let fromDate: any;
        let toDate: any;
        let returndateobj: any = setdates(
          filterType,
          false,
          "protocolorderdatefilterdiff",
          toRange,
          changedtodate
        );
        if (returndateobj !== undefined && filterType !== 1) {
          fromDate = returndateobj.fromRange;
          toDate = returndateobj.toRange;
        } else {
          fromDate = new Date(fromRange);
          fromDate.setHours(0, 0, 0);
          toDate = new Date(fromRange);
          toDate.setHours(23, 59, 59, 999);
        }

        let passObjDet = Commonpassobject(
          selectedtree,
          selectedtree,
          fromDate,
          toDate,
          protocoltype,
          SearchCriteriaType.value,
          orderflag
        );

        if (fliterproject.projectcode !== -1) {
          passObjDet.lsprojectmaster = fliterproject;
        }
        if (flitertest.testcode !== -1) {
          passObjDet.testcode = flitertest.testcode;
        }
        passObjDet.iscancelled = iscancelled;

        Servicecalls("" + ELNurl + "/Instrument/Getprotocolordersondirectory", passObjDet,
          (response: any, data: any) => { ongetorderssuccess(response, data, orderobject) }, ongetordersfailure
        );

      }

      response.AddedProtocol.tn = response?.AddedProtocol?.testname ?? (test[0] ? test[0][2] : undefined);


      let newdata = addFolderonObj(stateData, selectedtree, intl, orderobject);
      newdata = addprojectinsidetask(
        newdata,
        null,
        intl,
        response.AddedProtocol,
        "PR",
        screen
      );

      if (selectedtree?.directorycode && selectedtree?.filefor)
        setSelectedTreeItem(
          getDirectoryOncodeandfilefor(
            newdata,
            selectedtree?.directorycode,
            selectedtree?.filefor
          )
        );
      let Allstate_Data = flattenHierarchy(JSON.parse(JSON.stringify(newdata)));
      let Statevalues_update: DataModel[] = expandPathInHierarchy(
        Allstate_Data,
        selectedtree?.path,
        stateData
      );
      setStateData(Statevalues_update);
      setSelectedCDPTreeItem(undefined);
      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      // setStateData(newdata);
      columns.map((col) => {
        if (
          selectedTreeItem?.filefor === "ECO" ||
          selectedTreeItem?.filefor === "DCO"
        ) {
          if (col.field === "dateCompleted") {
            col.show = false;
          }
        }
        return col;
      });
      setDetailsData(orderobject);
      setSelectedGridItem(orderobject);
      setDuplicateorder(false);
      setDublicateorderitem("");
      setGridSelection({
        [`${selectedtree?.path}/${response.AddedProtocol.protoclordername + ".ord"
          }`]: true,
      });

      settoRange(new Date());
      //setPullcontents(true);
    }

    props.props.alert.success(props.t("Common.ID_ORDER", { param: "" }));
  };

  const oninsertorderfailure = (_response: any) => { };

  const handleSearchChange = (event: InputChangeEvent) => {
    // let eventPath = "";
    if (event.value !== undefined && event.value !== "") {
      // if (selectedTreeItem?.items) {
      //   const curPath = getFolderPath(selectedTreeItem.items[0].path);
      //   eventPath = `${curPath}/${event.value}`;
      // } else if (stateData && stateData.length > 0) {
      //   const curPath = getFolderPath(stateData[0].path);
      //   eventPath = `${curPath}/${event.value}`;
      // }

      setStateContentData({
        ...stateContentData,
        filter: {
          logic: initialLogic,
          filters: [
            { field: "path", operator: "contains", value: event.value },
          ],
        },
      });
      setSearchValue(event.value);
    } else {
      setStateContentData({
        sort: initialSort,
        filter: {
          logic: initialLogic,
          filters: [{ field: "path", operator: "contains", value: "" }],
        },
      });
      setSearchValue("");
    }
  };

  const handleSwitchChange = (event: AppSwitchChangeEvent) => {
    const newPanes: PanesModel[] = panes.slice(0);
    if (event.value) {
      newPanes[2].size = "30%";
      setPanes(newPanes);
    } else {
      newPanes[2].size = "0%";
      setPanes(newPanes);
    }
  };

  const handleViewChange = (event: ViewChangeEvent) => {
    if (event.viewValue.gridView) {
      setContentView("grid");
      localStorage.setItem("elnprotocolorderview", "grid");
    }
    if (event.viewValue.listView) {
      setContentView("list");
      localStorage.setItem("elnprotocolorderview", "list");
    }
  };

  const handleFileChange = (event: any) => {
    let files = event.event.affectedFiles;
    let size = 200 * 1024 * 1024;
    // let err = [];
    if (files.length !== 0) {
      for (var x = 0; x < files.length; x++) {
        if (files[x].size > size && isMultitenant === 2) {
          // err[x] = props.alert.error("Maximum upload size limit reached. Upgrade to upload files larger than 200 MB.");
          setisupgradeopen(true);
        } else {
          if (
            event &&
            event.event &&
            event.event.affectedFiles &&
            event.event.affectedFiles.length > 0 &&
            event.event.affectedFiles[0].status === 4 &&
            event.event.response &&
            event.event.response.status === 200 &&
            event.event.response.response &&
            event.event.response.response.res &&
            !event.event.response.response.res.status &&
            event.event.response.response.uid
          ) {

            let uid = event.event.response.response.uid;
            if (event.files) {
              let files = event.files.filter((file: any) => file.uid !== uid);
              setFiles(files);
            }

            props.alert.error(
              props.t(
                event.event.affectedFiles[0].name +
                " file already exists in the directory"
              )
            );
          } else {
            if (event.files) {
              setFiles(event.files);
            }
          }
        }
      }
    } else {
      setFiles([]);
    }
  };

  const handleClearFileList = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (event) {
      setFiles([]);
    }
  };

  const handleUploadComplete = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ishomeupload: boolean,
    click: string
  ) => {
    if (files && files.length > 0) {
      let fileduids = files.map(function (file) {
        return file["uid"];
      });
      // var lastItem = files.slice(-1).pop();

      // let passObjDet = {
      //   objsilentaudit: Silentauditobject(
      //     "upload",
      //     "Protocol Orders",
      //     props.t("Orders.Protocolorders.IDS_AUDIT_FOLDERFILEUPLOAD", {
      //       file: lastItem?.name,
      //       user: store.getState().Loggeduser.username
      //     })
      //   ),

      // };

      // Servicecalls(
      //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      //   passObjDet,
      //   onAuditValidateError.bind(this),
      //   onAuditValidateFailure.bind(this)
      // );
      if (!ishomeupload) {
        if (click !== "close") {
          let Audit = AuditTrailValidation(
            "IDS_MDL_ORDERS",
            "IDS_SCN_PROTOCOLORDERS",
            "IDS_TSK_UPLOAD"
          );
          let passobject = {};
          passobject = {
            objmanualaudit: Manualauditobject("upload", "Protocol Orders"),
            fileduids: fileduids,
          };
          if (Audit) {
            ($("#auditTrailModalProtocolview") as any).modal("show");
            setAuditservicecall({
              AuditUrl:
                "" + ELNurl + "/Instrument/Getaddedprotocolfilesforfolder",
              AuditObject: passobject,
              AuditPassfunction: onSuccess.bind(this),
              AuditFailfunction: onAuditValidateFailure.bind(this),
              Auditcancel: Auditcancel.bind(this),
              Auditfilefunction: true,
            });
          } else {
            if (click === "close") {
              Auditcancel();
            } else {
              Servicecalls(
                "" + ELNurl + "/Instrument/Getaddedprotocolfilesforfolder",
                fileduids,
                onSuccess.bind(this),
                onaddFailure.bind(this)
              );
            }
          }
        } else {
          Auditcancel();
        }
      } else if (ishomeupload) {
        setFiles([]);
      }
    }
  };

  const onSuccess = (response: any) => {
    props.alert.success(
      props.t("Orders.Sheetorders.IDS_LBL_FILEUPLOADSUCCESS", { param: "" })
    );
    ($("#auditTrailModalProtocolview") as any).modal("hide");
    let passObjDet;
    if (response.length > 0) {
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "upload",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_FOLDERFILEUPLOAD", {
            file: response[0].filename,
            user: store.getState().Loggeduser.username,
          })
        ),
      };

      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    setAuditservicecall({
      AuditUrl: "",
      AuditObject: {},
      AuditPassfunction: undefined,
      AuditFailfunction: undefined,
      AuditCancelfunction: undefined,
      Auditfilefunction: false,
    });
    const newData: DataModel | any = addDataItem(
      stateData,
      selectedCDPTreeItem ? selectedCDPTreeItem : selectedTreeItem,
      response,
      intl
    );
    if (selectedCDPTreeItem) {
      setSelectedTreeItem(selectedCDPTreeItem);
      ChoosePath(newData);
      // setStateCDFData(newData?.filter((item: any) => item.filefor === "PR" || item.filefor === "DR" || item.filefor === "SMM"));
      getordersforfolders(
        selectedCDPTreeItem,
        selectedCDPTreeItem,
        fromRange,
        toRange,
        protocoltype,
        SearchCriteriaType.value,
        orderflag,
        flitertest,
        fliterproject,
        false
      );
    } else {
      setStateData(newData);
    }

    setFiles([]);

    // Servicecalls("" + ELNurl + "/Instrument/Getaddedprotocolfilesforfolder", response,
    //   onaddSuccess.bind(this), onaddFailure.bind(this));
    // setAuditservicecall({
    //   AuditUrl: "" + ELNurl + "/Instrument/Getaddedprotocolfilesforfolder",
    //   AuditObject: response,
    //   AuditPassfunction: onaddSuccess,
    //   AuditFailfunction: onaddFailure,

    // })
    // Servicecalls(
    //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
    //   passObjDet,
    //   onAuditValidateError.bind(this),
    //   onAuditValidateFailure.bind(this)
    // );
  };
  // const onaddSuccess = (response: any) => {
  //   ($('#auditTrailModalProtocolview') as any).modal("hide")
  //   setAuditservicecall({
  //     AuditUrl: "",
  //     AuditObject: {},
  //     AuditPassfunction: undefined,
  //     AuditFailfunction: undefined,
  //     AuditCancelfunction: undefined,
  //     Auditfilefunction: false,
  //   });
  //   const newData: DataModel | any = addDataItem(
  //     stateData,
  //     selectedTreeItem,
  //     response,
  //     intl
  //   );

  //   setStateData(newData);
  //   setFiles([]);

  // }

  const onaddFailure = (_response: any) => { };

  const handleBreadcrumbSelection = (event: any) => {
    setSelectedGridItem({});
    setGridSelection({});

    if (!event.nativeEvent.keyCode) {
      let returndateobj = setdates(
        filterType,
        false,
        "protocolorderdatefilterdiff",
        toRange,
        changedtodate
      );
      if (returndateobj !== undefined) {
        setfromRange(returndateobj.fromRange);
        settoRange(returndateobj.toRange);
      }
      if (event.target !== undefined) {
        sateorderdummy =
          stateData !== undefined && stateData !== null && stateData.length > 0
            ? stateData
            : initialorders !== null
              ? initialorders
              : [];
      }
      const newItem = searchTreeItemonpath(stateData, { path: event.id });
      setSelectedTreeItem(newItem);
      if (newItem === undefined
        // && event.id !== "Protocol" && event.id !== "ProtocolOrder"
      ) {
        let passObjDet1: any = {
          protocoltype: protocoltype,
          directorycode: -1,
          objuser: {
            fromdate: GetutcDate(new Date(returndateobj.fromRange)),
            todate: GetutcDate(new Date(returndateobj.toRange)),
          },
          filefor: "DR",
          createdby: store.getState().Loggeduser,
          lsuserMaster:
            store.getState().Loggeduser !== undefined &&
              store.getState().Loggeduser !== null &&
              Object.keys(store.getState().Loggeduser).length > 0
              ? store.getState().Loggeduser
              : {
                usercode: localStorage.getItem("User"),
                username: localStorage.getItem("Username"),
                unifieduserid: localStorage.getItem("unifieduserid"),
              },
          lstelnprotocolworkflow: workflow,
          sitemaster: { sitecode: sessionStorage.Usersite }
        };
        let usermasterobj = JSON.parse(sessionStorage.teamusercode);
        passObjDet1.lstuserMaster = usermasterobj;

        if (fliterproject.projectcode !== -1) {
          passObjDet1.lsprojectmaster = fliterproject;
        }
        if (flitertest.testcode !== -1) {
          passObjDet1.testcode = flitertest.testcode;
        }

        if (orderflag !== undefined && orderflag !== -1) {
          passObjDet1.orderflag = orderflag === 1 ? "N" : "R";
          if (orderflag === 3) {
            passObjDet1.rejected = 1;
          }
        }

        if (fliterproject.projectcode !== -1) {
          passObjDet1.lsprojectmaster = fliterproject;
        }
        if (flitertest.testcode !== -1) {
          passObjDet1.testcode = flitertest.testcode;
        }
        passObjDet1.iscancelled = iscancelled;

        setServicecall({
          ServiceToUrl:
            "" + ELNurl + "/Instrument/Getprotocolordersondirectory",
          ServiceHeaderobject: passObjDet1,
          ServiceMethodType: "POST",
          ServcieonSuccess: ongetordersuccesshome.bind(this),
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
    }
    if (event.nativeEvent.keyCode === 13) {
      const newItem = searchTreeItemonpath(stateData, { path: event.id });
      setSelectedTreeItem(newItem);
    }
  };

  const ongetordersuccesshome = (response: any, passeddata: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      if (response.protocolorders.length > 0) {
        response.protocolorders.forEach((item: any) => {
          if (item.orderflag.trim() === "N") {
            item.canuserprocess = true;
          }
        });
      }
      orderdataforfolder = response.protocolorders;
      setServicecall({
        ServiceToUrl: "" + ELNurl + "/Instrument/Getfilesforprotocolfolder",
        ServiceHeaderobject: {
          directorycode: -1,
          filefor: "DR",
          // contentsearchtype: searchCriteriaType.value,
          contentsearch: SearchContentText.SearchContentText,
          ismultitenant: isMultitenant,
          orderflag:
            orderflag !== undefined && orderflag !== -1 && orderflag === 1
              ? "N"
              : "R",
          approvelstatus: orderflag !== undefined && orderflag === 3 ? 3 : "",
          fromdate: GetutcDate(new Date(passeddata.objuser.fromdate)),
          todate: GetutcDate(new Date(passeddata.objuser.todate)),
          lssitemaster: {
            sitecode: parseInt(sessionStorage.Usersite)
          },
        },
        ServiceMethodType: "POST",
        ServcieonSuccess: (response: any, data: any) => { ongetfilessuccesshome(response, data) },
        ServcieonFailure: ongetfilesfailure,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
      });
    }
  };

  const ongetfilessuccesshome = (response: any, passeddata: any) => {
    if (
      passeddata !== undefined &&
      passeddata?.directorycode !== undefined &&
      passeddata.filefor !== undefined
    ) {
      // setIsLoader(true);
      let directorycode = passeddata.directorycode;
      let itemdata = [];
      if (response !== undefined && response.length > 0) {
        itemdata = response;
      }
      let folderdata = sateorderdummy;

      let newdata = replaceallordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        orderdataforfolder !== undefined && orderdataforfolder.length > 0
          ? orderdataforfolder
          : [],
        passeddata.filefor,
        screen
      );
      newdata = addorderitemsforhomebutton(
        newdata,
        directorycode,
        intl,
        orderdataforfolder !== undefined && orderdataforfolder.length > 0
          ? orderdataforfolder
          : [],
        passeddata.filefor,
        screen
      );
      newdata = addfileitemsforhomebutton(
        newdata,
        directorycode,
        intl,
        itemdata,
        passeddata.filefor,
        screen
      );

      setStateData(newdata);
      setSelectedCDPTreeItem(undefined);
      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      // setsheetdatainitservice(false);
      // setsheetdatainit(undefined);
      // setIsLoader(false);
      sateorderdummy = [];
    }

    setStateContentData({
      sort: [
        {
          field: "",
          dir: "desc",
        },
      ],
      filter: {
        logic: initialLogic,
        filters: [{ field: "path", operator: "contains", value: "" }],
      },
    });
  };

  const ondeletedirectorysuccess = (response: any, passobj: any) => {
    ($("#auditTrailModalProtocolview") as any).modal("hide");
    if (
      deleteitem === undefined ||
      deleteitem === null ||
      Object.keys(deleteitem).length <= 0 ||
      response === undefined ||
      response === null ||
      response.length <= 0
    )
      return;

    props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FOLDERDELETE"));
    let deletedfolderindex = response.findIndex(
      (obj: { parentdircode: number }) => obj.parentdircode === -2
    );

    if (deletedfolderindex > -1) {
      const curItem = deleteitem;
      const movetodirectory = getDirectoryOncode(
        stateData,
        response[deletedfolderindex].dircodetomove
      );

      let updatedData = removeDataItem(stateData, curItem);
      let statedataclone = JSON.parse(JSON.stringify(stateData));

      for (let ind = 0; ind < response.length; ind++) {
        if (response[ind].parentdircode !== -2) {
          response[ind].icon = convertExtensionToIcon(
            response[ind].directoryname,
            null
          );
          // response[ind].dateCreated = convertDateFormat(
          //   convertUTCDateToLocalDate(new Date(response[ind].dateCreated)),
          //   intl
          // );
          // response[ind].dateModified = convertDateFormat(
          //   convertUTCDateToLocalDate(new Date(response[ind].dateModified)),
          //   intl
          // );
          let movedirectory = getDirectoryOncode(
            statedataclone,
            response[ind].parentdircode
          );
          let directorytomove = getDirectoryOncode(
            statedataclone,
            response[ind].directorycode
          );
          directorytomove.path = movedirectory.path;
          updatedData = addFolderonObj(
            updatedData,
            movedirectory,
            intl,
            directorytomove
          );
        } else {
          // updatedData = removeDataItem(updatedData, response[ind]);
        }
      }
      statedataclone = updatedData;
      setSelectedTreeItem(searchTreeItem(updatedData, movetodirectory));
      // setStateData(updatedData);
      sateorderdummy = updatedData;
      ChoosePath(updatedData);
      setSelectedCDPTreeItem(undefined);
      SelectedCDPTreeItem = undefined;
      SelectedCDFvalue = 4;
      // setSelectedFolders([]);
      setDeleteDialogView(false);
      setIsMultiSelectFolders(false);
      let id = { id: "ProtocolOrder", nativeEvent: { try: "try" } };
      // setTimeout(() => {
      handleBreadcrumbSelection(id);
      // }, 50);
    }
  };

  const ondeletedirectoryfaliure = (_response: any) => { };

  const handleDialogClick = (event: any) => {
    if (event.type === "cancel add") {
      SelectedCDFvalue = 4;
      setSelectedCDPTreeItem(undefined);

      let returndata = stateCDFData.map((item) => {
        const currentItem = { ...item };
        currentItem.expanded = false;
        currentItem.selected = false;
        return currentItem;
      });
      setStateCDFData(returndata);
      setAddDialogVisible(false);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "cancel",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_REQCANCELNEWFOLDER", {
            user: sessionStorage.Username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (event.type === "cancel rename") {
      setEditDialogView(false);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "cancel",
          "Protocol Orders",
          props.t("FOLDER.IDS_AUDIT_REQCANCELRENAME", {
            user: sessionStorage.Username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (event.type === "cancel delete") {
      setDeleteDialogView(false);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "cancel",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_REQCANCELDELETE", {
            user: sessionStorage.Username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (event.type === "cancel") {
      setMoveDialogView(false);
    }

    const curItem: DataModel | null = Object.keys(selectedGridItem).length
      ? selectedGridItem
      : SelectedCDFvalue === 5 && selectedCDPTreeItem !== undefined
        ? selectedCDPTreeItem
        : selectedTreeItem;
    if (!curItem) {
      return;
    }

    if (
      event.type === "delete" &&
      isMultiSelectFolders === true &&
      isMultiSelectFile === false
    ) {
      let movedircode = event.directoryToMove;
      let directorytomove = getDirectoryOncode(stateData, movedircode);
      let data = getAllFolderFromMultiItem(
        // [event.directoryToDelete],
        // event.directoryToDelete,
        selectedFolders,
        selectedFolders,
        movedircode,
        event.keepfolderstructure,
        directorytomove
      );
      deleteitem = selectedFolders;
      let directories = data.directries;

      if (directories[0].dircodetomove === undefined) {
        directories[0].dircodetomove = -1;
      }
      directories = directories.map((items: any) => {
        if (event.selectedItem.parentdircode !== -1 && movedircode === -1) {
          items.dircodetomove = event.selectedItem.parentdircode;
        } else {
          items.dircodetomove = movedircode;
        }

        return items;
      })

      if (auditRights.IDS_TSK_FOLDERDEL) {
        directories[0].objmanualaudit = Manualauditobject(
          "delete",
          "Protocol Orders"
        );
        ($("#auditTrailModalProtocolview") as any).modal("show");
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/Instrument/Deletedirectoriesonprotocol",
          AuditObject: directories,
          AuditPassfunction: ondeletemultidirectorysuccess,
          AuditFailfunction: ondeletedirectoryfaliure,
        });
      } else {
        Servicecalls(
          "" + ELNurl + "/Instrument/Deletedirectoriesonprotocol",
          directories,
          ondeletemultidirectorysuccess,
          ondeletedirectoryfaliure
        );
      }
    }
    if (
      event.type === "delete" &&
      isMultiSelectFolders === false &&
      isMultiSelectFile === false
    ) {
      let movedircode = event.directoryToMove;
      let directorytomove = getDirectoryOncode(stateData, movedircode);
      let data = getAllFolderFromItem(
        [event.directoryToDelete],
        event.directoryToDelete,
        movedircode,
        event.keepfolderstructure,
        directorytomove
      );
      deleteitem = curItem;
      let directories: any = data.directries;
      // let passobj = JSON.parse(JSON.stringify(directories));
      if (directories.length > 0) {
        // directories = directories.map((items: any) => {
        //   items.dateCreated = undefined;
        //   items.dateModified = undefined;
        //   return items;
        // });
      }
      if (directories[0].dircodetomove === undefined) {
        directories[0].dircodetomove = -1;
      }
      directories = directories.map((items: any) => {
        if (event.selectedItem.parentdircode !== -1 && movedircode === -1) {
          items.dircodetomove = event.selectedItem.parentdircode;
        } else {
          items.dircodetomove = movedircode;
        }

        return items;
      })
      if (auditRights.IDS_TSK_FOLDERDEL) {
        directories[0].objmanualaudit = Manualauditobject(
          "delete",
          "Protocol Orders"
        );
        ($("#auditTrailModalProtocolview") as any).modal("show");
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/Instrument/Deletedirectoriesonprotocol",
          AuditObject: directories,
          AuditPassfunction: ondeletedirectorysuccess,
          AuditFailfunction: ondeletedirectoryfaliure,
        });
      } else {
        setServicecall({
          ServiceToUrl: "" + ELNurl + "/Instrument/Deletedirectoriesonprotocol",
          ServiceHeaderobject: directories,
          ServiceMethodType: "POST",
          ServcieonSuccess: ondeletedirectorysuccess,
          ServcieonFailure: (_response: any) => { },
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }

      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "delete",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_REQFOLDERDELETED", {
            user: sessionStorage.Username,
            folder: curItem.directoryname,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (event.type === "delete" && isMultiSelectFile === true) {
      console.log(selectedFiles);
      console.log(AllSelectedFiles);
      let filedeleteurl =
        selectedTreeItem !== undefined && selectedTreeItem !== null
          ? ELNurl +
          "/Instrument/deletemultifilesforfolder/" +
          selectedTreeItem.directorycode +
          "/" +
          selectedTreeItem.filefor +
          "/" +
          sessionStorage.getItem("tenantid") +
          "/" +
          isMultitenant +
          "/" +
          sessionStorage.getItem("User") +
          "/" +
          sessionStorage.getItem("Usersite") +
          "/" +
          new Date() +
          "/" +
          fileviewfor
          : ELNurl +
          "/Instrument/deletemultifilesforfolder/" +
          -1 +
          "/" +
          "DR" +
          "/" +
          sessionStorage.getItem("tenantid") +
          "/" +
          isMultitenant +
          "/" +
          sessionStorage.getItem("User") +
          "/" +
          sessionStorage.getItem("Usersite") +
          "/" +
          new Date() +
          "/" +
          fileviewfor;

      console.log(stateData);
      setDetailsData(null);
      setServicecall({
        ServiceToUrl: filedeleteurl,
        ServiceHeaderobject:
          selectedFiles.length === 0
            ? AllSelectedFiles !== undefined
              ? AllSelectedFiles
              : selectedFiles
            : selectedFiles,
        ServiceMethodType: "POST",
        ServcieonSuccess: ondeletemultifileSuccess,
        ServcieonFailure: ondeletefileFailure,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
        ServcieProcessbar: true,
      });
    }

    if (event.type === "rename") {
      const folderPath = getFolderPath(event.path);
      const newPath = `${folderPath}/${event.value}`;
      const existingItem = searchTreeItem(stateData, { path: newPath });
      if (!existingItem) {
        const updatedData = editDataItem(stateData, curItem, newPath, intl);
        setSelectedTreeItem(searchTreeItem(updatedData, { path: newPath }));
        // setSelectedTreeItemDuplicate(searchTreeItem(updatedData, { path: newPath }));
        setStateData(updatedData);
        let directory = {
          directoryname: event.value,
          directorycode: curItem.directorycode,
          parentdircode: curItem.parentdircode,
          path: newPath,
          modifiedby: { usercode: Number(sessionStorage.User) },
          dateModified: new Date(),
        };
        Servicecalls(
          "" + ELNurl + "/Instrument/Movedirectoryonprotocolorder",
          directory,
          onrenamesuccess.bind(this, event, curItem),
          onrenamefailure.bind(this)
        );
      } else {
        props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FOLDEREXIST"));
      }
      // (_response: any) => { }

      setEditDialogView(false);
    }

    if (event.type === "add" || event.type === "save") {
      setAddDialogVisible(false);
      handleNewFolderClick(event);
    }
  };

  const onrenamesuccess = (curItem: any, event: any, response: any) => {

    let directorycode = response.directorycode;
    let selecteditem = getDirectoryOncode(stateData, directorycode);
    let selectedfolder = getDirectoryOncode(stateData, response.parentdircode);
    selecteditem.directoryname = response.directoryname;
    selecteditem.dateModified = convertDateFormat(
      convertUTCDateToLocalDate(new Date(response.dateModified)),
      intl
    );
    selecteditem.Modified_By = response?.modifiedby?.username ?? sessionStorage.Username;

    // let newData = removeItem(stateData, selecteditem);
    // let basePath;

    // if (selectedfolder && Object.keys(selectedfolder).length !== 0) {
    //   basePath = `${selectedfolder.path}`;
    //   newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
    // } else {
    //   basePath = selecteditem.path.substring(0, selecteditem.path.lastIndexOf("/"));
    //   newData = addFolderonObj(newData, null, intl, selecteditem);
    // }
    let basePath;
    if (selectedfolder && Object.keys(selectedfolder).length !== 0) {
      basePath = `${selectedfolder.path}`;
    } else {
      basePath = selecteditem.path.substring(0, selecteditem.path.lastIndexOf("/"));
    }
    let newData = replaceItem(stateData, selecteditem, basePath);

    selecteditem.path = `${basePath}/${selecteditem.directoryname}`;
    const newTreeItem = searchTreeItem(newData, selecteditem);
    setSelectedTreeItem(newTreeItem);
    setSelectedCDPTreeItem(newTreeItem);
    setSelectedGridItem(selecteditem);
    setDetailsData(selecteditem);
    setStateData(newData);

    let passObjDet = {
      objsilentaudit: Silentauditobject(
        "edit",
        "Protocol Orders",
        props.t("Orders.Protocolorders.IDS_AUDIT_REQCHANGEFOLDERNAME", {
          user: sessionStorage.Username,
          from: curItem.directoryname,
          to: event.value,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );
    // if (response !== undefined && response.response.status === false) {

    //   props.alert.error(
    //     props.t("Orders.Sheetorders.IDS_MSG_FOLDEREXIST")
    //   );
    // }
    // else {
    // const folderPath = getFolderPath(event.path);
    // const newPath = `${folderPath}/${event.value}`;

    // const existingItem = searchTreeItem(stateData, { path: newPath });
    // if (!existingItem) {
    //   const updatedData = editDataItem(stateData, curItem, newPath, intl);
    //   setSelectedTreeItem(searchTreeItem(updatedData, { path: newPath }));
    //   setStateData(updatedData);
    // }
    props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_FOLDERRENAME"));
    // }
  };

  const onrenamefailure = (response: any) => { };
  const ondeletemultidirectorysuccess = (response: any) => {
    ($("#auditTrailModalProtocolview") as any).modal("hide");
    if (
      deleteitem === undefined ||
      deleteitem === null ||
      Object.keys(deleteitem).length <= 0 ||
      response === undefined ||
      response === null ||
      response.length <= 0
    )
      return;

    // let deletedfolderindex = response.findIndex(
    //   (obj: { parentdircode: number }) => obj.parentdircode === -2
    // );
    let deletedfolderindex: any = [];
    response.map((resitem: any, index: any) => {
      if (resitem.parentdircode === -2) {
        deletedfolderindex.push(index);
      }

      return resitem;
    });

    // if (deletedfolderindex > -1) {
    let updatedData: any = [];

    let statedataclone: any = [];
    let movetodirectory: any = {};
    let newlyupdateddata: any = [];

    deletedfolderindex.forEach((folderitemindex: any) => {
      deleteitem.forEach((item: any) => {
        // const curItem = deleteitem;
        const curItem = item;
        movetodirectory = getDirectoryOncode(
          stateData,
          response[folderitemindex].dircodetomove
        );

        if (newlyupdateddata.length === 0) {
          updatedData = removeDataItem(stateData, curItem);
          statedataclone = stateData;
        } else {
          updatedData = removeDataItem(newlyupdateddata, curItem);
        }

        //  for (let ind = 0; ind < response.length; ind++) {
        if (response[folderitemindex].parentdircode !== -2) {
          response[folderitemindex].icon = convertExtensionToIcon(
            response[folderitemindex].directoryname,
            null
          );
          // response[folderitemindex].dateCreated = response[folderitemindex].dateCreated;
          // response[folderitemindex].dateModified = response[folderitemindex].dateModified;
          // response[folderitemindex].dateCreated = convertDateFormat(
          //   convertUTCDateToLocalDate(new Date(response[folderitemindex].dateCreated)),
          //   intl
          // );
          // response[folderitemindex].dateModified = convertDateFormat(
          //   convertUTCDateToLocalDate(new Date(response[folderitemindex].dateModified)),
          //   intl
          // );
          let movedirectory = getDirectoryOncode(
            statedataclone,
            response[folderitemindex].parentdircode
          );
          let directorytomove = getDirectoryOncode(
            statedataclone,
            response[folderitemindex].directorycode
          );
          directorytomove.path = movedirectory.path;
          updatedData = addFolderonObj(
            updatedData,
            movedirectory,
            intl,
            directorytomove
          );
          statedataclone = updatedData;
        } else {
          //  updatedData = removeDataItem(updatedData, response[ind]);
          newlyupdateddata = updatedData;
        }
        //   }
      });
    });
    setSelectedTreeItem(searchTreeItem(updatedData, movetodirectory));
    // setStateData(updatedData);
    sateorderdummy = updatedData;
    // setSelectedFolders([]);
    setDeleteDialogView(false);
    // setPullcontents(true);
    setIsMultiSelectFolders(false);
    let id = { id: "ProtocolOrder", nativeEvent: { try: "try" } };
    handleBreadcrumbSelection(id);
    props.alert.success(props.t("Orders.Sheetorders.IDS_MULTIFOLDERDELETE"));

    //  }
  };

  const onMoveItemSuccess = (response: any) => {
    let directorycode = response.directorycode;
    let selecteditem =
      response.protocolordercode !== undefined
        ? getDirectoryOnName(stateData, response.protoclordername)
        : // ? getDirectoryOnName(stateData, response.protocolordercode)
        getDirectoryOncode(stateData, directorycode);
    let selectedfolder =
      response.protocolordercode !== undefined
        ? getDirectoryOncode(stateData, directorycode)
        : getDirectoryOncode(stateData, response.parentdircode);

    selecteditem.directoryname = response.directoryname;
    let newData = removeItem(stateData, selecteditem);
    let SelectedFolderCd = selectedCDPTreeItem;
    SelectedFolderCd = response.batchcode !== undefined
      ? getDirectoryOncode(stateCDFData, directorycode)
      : getDirectoryOncode(stateCDFData, response.parentdircode);
    let stateCDFDatanew = removeItem(stateCDFData, selecteditem);
    if (SelectedFolderCd) {
      if (selecteditem.order !== undefined) {
        selecteditem.path = `${SelectedFolderCd.path}/${selecteditem.directoryname + ".ord"
          }`;
      } else {
        selecteditem.path = `${SelectedFolderCd.path}/${selecteditem.directoryname}`;
      }
      stateCDFDatanew = response.directoryname
        ? addFolderonObj(stateCDFDatanew, SelectedFolderCd, intl, selecteditem)
        : stateCDFDatanew;
      const newTreeItem = searchTreeItem(stateCDFDatanew, stateCDFDatanew);
      setSelectedCDPTreeItem(newTreeItem);
    } else {
      stateCDFDatanew = addFolderonObj(stateCDFDatanew, null, intl, selecteditem);
    }

    if (selectedfolder) {
      if (selecteditem.order !== undefined) {
        selecteditem.directoryname = selecteditem.directoryname
          ? selecteditem.directoryname
          : selecteditem.order.protoclordername;
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname + ".ord"
          }`;
      } else {
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname}`;
      }
      newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
      const newTreeItem = searchTreeItem(newData, selectedfolder);
      setSelectedTreeItem(newTreeItem);
    } else {
      newData = addFolderonObj(newData, null, intl, selecteditem);
    }
    setStateCDFData((stateCDFData) => Object.assign([], stateCDFData, stateCDFDatanew));
    setStateData(newData);
    let passObjDet = {};
    if (selecteditem.directoryname !== undefined) {
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "Move",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_REQFOLDERMOVED", {
            user: sessionStorage.Username,
            folder: selecteditem.directoryname,
            folder2: selectedfolder?.directoryname,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    } else {
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "update",
          "Protocol Orders",
          props.t("Orders.Sheetorders.IDS_AUDIT_ORDERMOVED", {
            orderid: response.protoclordername,
            folderselect: selectedfolder?.directoryname,
            fromfolder: selectedTreeItem?.directoryname,
            user: store.getState().Loggeduser.username,
          })
        ),
      };
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
    if (selecteditem.directoryname === undefined) {
      props.alert.success(
        props.t("Orders.Protocolorders.IDS_MSG_PROTOCOLORDERMOVE", {
          batchid: response.protoclordername,
        })
      );
    } else {
      props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FOLDERMOVE"));
    }
    const passObjDetMove: any = [{
      protocolordercode: response.protocolordercode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      viewoption: 2,
      orderobjects: JSON.stringify({
        protocolordercode: response.protocolordercode,
        protoclordername: response?.protoclordername,
        action: "OrderMoved",
        OrderPreviousFolder: selectedTreeItem?.directoryname,
        OrderNewFolder: selectedfolder?.directoryname,

      })
    }]
    ProtocolOrderTransactionDataUpdate(passObjDetMove);
    setMoveDialogView(false);
  };

  const onMultiMoveItemSuccess = (response: any) => {
    ($("#auditTrailModalProtocolview") as any).modal("hide");
    setMoveDialogView(false);
    setIsSelectAllFile(false);
    setIsSelectAllOrder(false);

    if (response === undefined || response.length <= 0) return;
    let directorycode = response[0].directorycode;
    let newData = stateData;
    let filefor;
    // let selectedfolder = selectedTreeItem;
    let auditArray = [];
    let selectedfolder: any = selectedTreeItem;
    for (let ind = 0; ind < response.length; ind++) {
      // let selecteditem = getDirectoryOnName(newData, response[ind].protoclordername);
      let selecteditem = getDirectoryOnName(
        newData,
        response[ind].protocolordercode
      );
      selectedfolder = getDirectoryOncode(newData, directorycode);
      filefor = selectedfolder.filefor;
      newData = removeItem(newData, selecteditem);

      if (selectedfolder) {
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname + ".ord"
          }`;
        //   newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
        const newTreeItem = searchTreeItem(newData, selectedfolder);
        setSelectedTreeItem(newTreeItem);

        auditArray.push(
          Silentauditobject(
            "update",
            "Protocol Orders",
            props.t("Orders.Protocolorders.IDS_AUDIT_ORDERMOVEDONMULTI", {
              orderid: response[0].protoclordername,
              folderselect: selectedfolder?.directoryname,
              user: store.getState().Loggeduser.username,
            })
          )
        );
      } else {
        // newData = addFolderonObj(newData, null, intl, selecteditem);
      }
    }

    props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_ORDEREDMOVED"));
    getordersforfolders(
      {
        directorycode: directorycode,
        filefor: "DR"
      },
      {
        directorycode: directorycode,
        filefor: "DR"
      },
      fromRange,
      toRange,
      protocoltype,
      SearchCriteriaType.value,
      orderflag,
      flitertest,
      fliterproject
    );
    setStateData(newData);

    setMoveDialogView(false);
    setIsMultiSelectOrder(false);
    setSelectedOrders([]);
    let passObj: any = {
      directorycode: directorycode,
      objuser: {
        fromdate: GetutcDate(new Date(fromRange)),
        todate: GetutcDate(new Date(toRange)),
      },
      filefor: filefor,
      createdby: store.getState().Loggeduser,
      protocoltype: protocoltype,
      //lstuserMaster : Getteamusersfromsession(),
      lsuserMaster:
        store.getState().Loggeduser !== undefined &&
          store.getState().Loggeduser !== null &&
          Object.keys(store.getState().Loggeduser).length > 0
          ? store.getState().Loggeduser
          : {
            usercode: localStorage.getItem("User"),
            username: localStorage.getItem("Username"),
            unifieduserid: localStorage.getItem("unifieduserid"),
          },
    };

    if (fliterproject.projectcode !== -1) {
      passObj.lsprojectmaster = fliterproject;
    }
    if (flitertest.testcode !== -1) {
      passObj.testcode = flitertest.testcode;
    }
    passObj.iscancelled = iscancelled;

    Servicecalls(
      "" + ELNurl + "/Instrument/Getprotocolordersondirectory",
      passObj,
      ongetorderssuccess,
      ongetordersfailure
    );

    if (auditArray.length > 0) {
      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandlerlist",
        auditArray,
        () => { },
        () => { }
      );
    }

    const passObjDetMove: any = response.reduce((acc: any, item: any) => {
      acc.push({
        protocolordercode: item.protocolordercode,
        createby: { usercode: sessionStorage.User },
        stepstartdate: GetutcDate(new Date()),
        viewoption: 2,
        orderobjects: JSON.stringify({
          protocolordercode: item.protocolordercode,
          protoclordername: item?.protoclordername,
          action: "OrderMoved",
          OrderPreviousFolder: selectedTreeItem?.directoryname,
          OrderNewFolder: selectedfolder?.directoryname,
        })
      })
      return acc
    }, [])

    ProtocolOrderTransactionDataUpdate(passObjDetMove);

    // let passObjDet = {
    //   objsilentaudit: Silentauditobject(
    //     "Move",
    //     "Protocol Orders",
    //     props.t("Orders.Protocolorders.IDS_AUDIT_ORDERMOVED", {
    //       // orderid: response[0].batchid,
    //       //folderselect: selectedfolder?.directoryname,
    //       //fromfolder: selectedTreeItem?.directoryname,
    //       user: store.getState().Loggeduser.username,

    //     })
    //   ),

    // };
    // Servicecalls(
    //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
    //   passObjDet,
    //   onAuditValidateError.bind(this),
    //   onAuditValidateFailure.bind(this)
    // );
  };

  const onMoveItemFailure = (_response: any) => { };
  const onMultiMoveFileSuccess = (response: any) => {
    //props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_FILESMOVEDSUCCESS"));
    if (response === undefined || response.length <= 0) return;
    let directorycode = response[0].directorycode;
    let newData = stateData;
    let selectedfolder = selectedTreeItem;
    for (let ind = 0; ind < response.length; ind++) {
      let selecteditem = getDirectoryOnName(newData, response[ind].filename);
      selectedfolder = getDirectoryOncode(newData, directorycode);

      newData = removeItem(newData, selecteditem);

      if (selectedfolder) {
        selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname}`;
        newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
        const newTreeItem = searchTreeItem(newData, selectedfolder);
        setSelectedTreeItem(newTreeItem);
        let passObjDet = {
          objsilentaudit: Silentauditobject(
            "Move",
            "Protocol Orders",
            props.t("Orders.Sheetorders.IDS_AUDIT_FILEMOVED", {
              user: props.sessionvalues.username,
              filename: response[ind].filename,
              folder: selectedfolder?.directoryname,
            })
          ),
        };

        Servicecalls(
          "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          onAuditValidateError.bind(this),
          onAuditValidateFailure.bind(this)
        );
      } else {
        newData = addFolderonObj(newData, null, intl, selecteditem);
      }
    }
    props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FILEMOVED"));
    setStateData(newData);

    setMoveDialogView(false);
    setIsMultiSelectFile(false);
    setIsSelectAllFile(false);
    setIsSelectAllOrder(false);
    setSelectedFiles([]);
    getordersforfolders(
      selectedTreeItem,
      selectedTreeItem,
      fromRange,
      toRange,
      protocoltype,
      SearchCriteriaType.value,
      orderflag,
      flitertest,
      fliterproject,
      false
    );
  };

  const onMoveFileFailure = (_response: any) => { };

  const onMultiMoveFolderSuccess = (response: any) => {
    if (response === undefined || response.length <= 0) return;
    props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FOLDERMOVE"));
    for (let ind = 0; ind < response.length; ind++) {
      // let movetofolder = getDirectoryOncode(stateData, response[ind].directoryname);
      let movetofolder = getDirectoryOncode(
        stateData,
        response[0].parentdircode
      );
      let newData = Movemultifolders(stateData, response, movetofolder);
      movetofolder = getDirectoryOncode(newData, response[0].parentdircode);
      setStateData(newData);
      setSelectedTreeItem(movetofolder);
      setMoveDialogView(false);
      setIsMultiSelectFolders(false);
      setSelectedFolders([]);
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "Move",
          "Protocol Orders",
          props.t("Orders.Protocolorders.IDS_AUDIT_PROTOCOLFOLDERMOVED", {
            user: props.sessionvalues.username,
            folder1: response[ind].directoryname,
            folder2: movetofolder.directoryname,
          })
        ),
      };

      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        onAuditValidateError.bind(this),
        onAuditValidateFailure.bind(this)
      );
    }
  };

  const onMoveFolderFailure = (_response: any) => { };

  const onMoveFileSuccess = (response: any) => {
    let directorycode = response.directorycode;
    let selecteditem =
      response.folderfilecode !== undefined
        ? getDirectoryOnName(stateData, response.filename)
        : getDirectoryOncode(stateData, directorycode);
    let selectedfolder =
      response.folderfilecode !== undefined
        ? getDirectoryOncode(stateData, directorycode)
        : getDirectoryOncode(stateData, response.parentdircode);

    selecteditem.directoryname = response.filename;
    let newData = removeItem(stateData, selecteditem);

    if (selectedfolder) {
      selecteditem.path = `${selectedfolder.path}/${selecteditem.directoryname}`;
      newData = addFolderonObj(newData, selectedfolder, intl, selecteditem);
      const newTreeItem = searchTreeItem(newData, selectedfolder);
      setSelectedTreeItem(newTreeItem);
    } else {
      newData = addFolderonObj(newData, null, intl, selecteditem);
    }
    setStateData(newData);
    let passObjDet = {
      objsilentaudit: Silentauditobject(
        "Move",
        "Protocol Orders",
        props.t("Orders.Sheetorders.IDS_AUDIT_REQFILEMOVED", {
          user: sessionStorage.Username,
          file: selecteditem.directoryname,
          file2: selectedfolder.directoryname,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );
    props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FILEMOVED"));
    setMoveDialogView(false);
  };

  const updatestateorderdata = (res: any) => {
    console.log(res);
    res = ProtocolSequence(res);
    console.log(stateData);

    if (stateData.length > 0) {
      let responseorder: any = [];
      responseorder.push(res);
      let folderdata = stateData !== undefined && stateData !== null &&
        stateData.length > 0 ? stateData : initialorders !== null ? initialorders : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      let newdata = replaceonechangeorderordertoFolderwithfilefor(
        folderdata, directorycode, intl,
        responseorder !== undefined && responseorder.length > 0 ? responseorder : [],
        filefor, screen
      );
      console.log(newdata);

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        filefor
      );
      setSelectedTreeItem(selectedtree);
      setStateData(newdata);
    }

  }
  const handlemoveDialogClick = (event: any) => {
    if (event.selectedfolder === undefined) {
      event.selectedfolder = { directorycode: -1, path: "ProtocolOrder" };
    }

    let selectedfolder = event.selectedfolder;
    let selecteditem = event.selecteditem;

    if (
      event.selectedfolder !== null &&
      selectedfolder.directorycode !== selecteditem.parentdircode
    ) {
      let passData = {
        directoryname: selecteditem.directoryname,
        parentdircode: selectedfolder.directorycode,
      };

      Servicecalls(
        "" + ELNurl + "/Instrument/getMoveDirectoryonprotocolorder",
        passData,
        (response: any) => {
          selecteditem.directoryname = response.directoryname;
          if (
            isMultiSelectOrder &&
            selectedOrders !== undefined &&
            selectedOrders.length > 0
          ) {
            let orders: any = selectedOrders.map((obj) => {
              obj.directorycode = selectedfolder.directorycode;
              obj.objmanualaudit = Manualauditobject("Move", "Protocol Orders");
              return obj;
            });
            let Audit = AuditTrailValidation("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS", "IDS_TSK_MOVEORDERPROTOCOL");

            if (Audit) {
              ($("#auditTrailModalProtocolview") as any).modal("show");
              setAuditservicecall({
                AuditUrl:
                  "" + ELNurl + "/Instrument/UpdateFolderforprotocolorders",
                AuditObject: orders,
                AuditPassfunction: onMultiMoveItemSuccess.bind(this),
                AuditFailfunction: onMoveItemFailure.bind(this),
              });
            } else {
              Servicecalls(
                "" + ELNurl + "/Instrument/UpdateFolderforprotocolorders",
                orders,
                onMultiMoveItemSuccess,
                onMoveItemFailure
              );
            }
          } else if (
            isMultiSelectFile &&
            selectedFiles !== undefined &&
            selectedFiles.length > 0
          ) {
            let files = selectedFiles.map((obj) => {
              obj.directorycode = selectedfolder.directorycode;
              return obj;
            });
            Servicecalls(
              "" + ELNurl + "/Instrument/UpdateprotocolFolderforfiles",
              files,
              onMultiMoveFileSuccess,
              onMoveFileFailure
            );
          } else if (
            isMultiSelectFolders &&
            selectedFolders !== undefined &&
            selectedFolders.length > 0
          ) {
            let folders = selectedFolders.map((obj) => {
              return {
                path: selectedfolder.path + "/" + obj.directoryname,
                parentdircode: selectedfolder.directorycode,
                directorycode: obj.directorycode,
              };
            });
            Servicecalls(
              "" + ELNurl + "/Instrument/Updateprotocolparentforfolder",
              folders,
              onMultiMoveFolderSuccess,
              onMoveFolderFailure
            );
          } else {
            if (selecteditem.order !== undefined) {
              let order = selecteditem !== undefined ? selecteditem.order : {};

              order.directorycode = selectedfolder.directorycode;

              // Servicecalls(
              //   "" + ELNurl + "/Instrument/UpdatesingleFolderforprotocolorder",
              //   order,
              //   onMoveItemSuccess,
              //   onMoveItemFailure
              // );
              let Audit = AuditTrailValidation(
                "IDS_MDL_ORDERS",
                "IDS_SCN_PROTOCOLORDERS",
                "IDS_TSK_MOVEORDERPROTOCOL"
              );
              if (Audit) {
                ($("#auditTrailModalProtocolview") as any).modal("show");
                setAuditservicecall({
                  AuditUrl:
                    "" + ELNurl + "/Instrument/UpdatesingleFolderforprotocolorder",
                  AuditObject: order,
                  AuditPassfunction: onMoveItemSuccess.bind(this),
                  AuditFailfunction: onMoveItemFailure.bind(this),
                });
              } else {
                Servicecalls(
                  "" + ELNurl + "/Instrument/UpdatesingleFolderforprotocolorder",
                  order,
                  onMoveItemSuccess,
                  onMoveItemFailure
                );
              }
            } else if (selecteditem.file !== undefined) {
              let order = selecteditem !== undefined ? selecteditem.file : {};

              order.directorycode = selectedfolder.directorycode;

              Servicecalls(
                "" + ELNurl + "/Instrument/UpdateprotocolFolderforfile",
                order,
                onMoveFileSuccess,
                onMoveFileFailure
              );
            } else {
              let currentpath = `${selectedfolder.path}/${selecteditem.directoryname}`;
              let directory = {
                directoryname: selecteditem.directoryname,
                directorycode: selecteditem.directorycode,
                parentdircode: selectedfolder.directorycode,
                path: currentpath,
                modifiedby: { usercode: Number(sessionStorage.User) },
                dateModified: new Date(),
              };
              Servicecalls(
                "" + ELNurl + "/Instrument/Movedirectoryonprotocolorder",
                directory,
                onMoveItemSuccess,
                onMoveItemFailure
              );
            }
          }
        },
        (_response: any) => { }
      );
    } else {
      props.alert.error(props.t("Orders.Protocolorders.IDS_MSG_FOLDERNOTMOVE"));
    }
  };

  const handleListItemClick = (event: any) => {
    let newSelectedGridItem = { selected: true, [event.dataItem.path]: true };
    if (event.dataItem.path) {
      newSelectedGridItem = event.dataItem;
      newSelectedGridItem[event.dataItem.path] = true;
      newSelectedGridItem.selected = true;

      setSelectedGridItem(newSelectedGridItem);

      if (event.dataItem.path) {
        const key = event.dataItem.path.toString();
        setGridSelection({ [key]: true });
        //   setSelectedTreeItem(newSelectedGridItem);
      }
    }

    if (event.tree) {
      const newSelectedTreeItem: DataModel = searchTreeItem(
        stateData,
        newSelectedGridItem
      );
      setSelectedTreeItem(newSelectedTreeItem);
    }
    updateFileDetailsData(newSelectedGridItem);

    if (event?.dataItem?.order?.viewoption && event?.dataItem?.order?.viewoption === 3) {
      let passObjDet = {
        protocolordercode: event.dataItem.order.protocolordercode
      }
      Servicecalls("" + ELNurl + "/Instrument/Getprotoselectedteam", passObjDet, (res: any) => {
        if (res !== undefined) {
          console.log(res);
          const updatedOrder = {
            ...event.dataItem.order,
            lsselectedTeam: res,
          };

          const updatedGridItem = {
            ...event.dataItem,
            order: updatedOrder,
          };

          let teamNameString: any = [];
          res.map((items: any, index: number) => {
            teamNameString.push(items?.userteam?.teamname);
            return true;
          });
          const result: any = `(${teamNameString.join(",")})`;
          sessionStorage.setItem("selectedteamname", result);
          updateFileDetailsData(updatedGridItem);
        }
      }, () => { });
    }

    let directorycode = event.dataItem.directorycode;

    if (
      directorycode !== undefined &&
      event.dataItem.filefor !== undefined &&
      event.dataItem.filefor === "DR"
    ) {
      let passObjDet: any = {
        directorycode: directorycode,
        objuser: {
          fromdate: GetutcDate(new Date(fromRange)),
          todate: GetutcDate(new Date(toRange)),
        },
        // filefor: event.dataItem.filefor,
        createdby: store.getState().Loggeduser,
        protocoltype: protocoltype,
        lstelnprotocolworkflow: workflow,
        lsuserMaster:
          store.getState().Loggeduser !== undefined &&
            store.getState().Loggeduser !== null &&
            Object.keys(store.getState().Loggeduser).length > 0
            ? store.getState().Loggeduser
            : {
              usercode: localStorage.getItem("User"),
              username: localStorage.getItem("Username"),
              unifieduserid: localStorage.getItem("unifieduserid"),
            },
        sitemaster: { sitecode: parseInt(sessionStorage.Usersite) },
      };
      if (SearchCriteriaType.value === 3) {
        passObjDet.searchCriteriaType = SearchCriteriaType.value;
      }
      if (orderflag !== undefined && orderflag !== -1) {
        passObjDet.orderflag = orderflag === 1 ? "N" : "R";
        if (orderflag === 3) {
          passObjDet.rejected = 1;
        }
      }
      let usermasterobj = JSON.parse(sessionStorage.teamusercode);
      passObjDet.lstuserMaster = [];
      if (usermasterobj.length > 0) {
        passObjDet.lstuserMaster = usermasterobj;
      }

      if (fliterproject.projectcode !== -1) {
        passObjDet.lsprojectmaster = fliterproject;
      }
      if (flitertest.testcode !== -1) {
        passObjDet.testcode = flitertest.testcode;
      }

      passObjDet.iscancelled = iscancelled;

      Servicecalls(
        "" + ELNurl + "/Instrument/Getprotocolordersondirectory",
        passObjDet,
        ongetorderssuccess,
        ongetordersfailure
      );
    }
  };

  const handleOrderopenClick = (event: any, item: any) => {

    let dup_item = { ...item };
    let seq = ProtocolSequence(dup_item);
    item.protoclordername = seq.protoclordername;

    let passObjDet: any = {
      protocolordercode: item.protocolordercode,
      lockeduser: sessionStorage.User,
      lockedusername: sessionStorage.Username,
      comment: "Order_Lock",
      activeuser: Number(sessionStorage.getItem("activeUserId")),
      ismultitenant: isMultitenant
    };

    let passobj: any = {
      protocolordercode: item.protocolordercode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Templates.Protocoltemplates.IDS_LBL_PROCESSORDER", {
        batchid: item.protoclordername,
        Processed: item.canuserprocess && !(item?.sharetome?.[0]?.sharerights === 0)
          ? "Processed" : "Open",
        user2: sessionStorage.Username,
      }),
      viewoption: 2,
      orderobjects: JSON.stringify({
        protocolordercode: item.protocolordercode,
        protoclordername: item?.protoclordername,
        action: "OrderOpen",
        opentype: item.canuserprocess && !(item?.sharetome?.[0]?.sharerights === 0)
          ? "Processed" : "Open",
        ...item.testname && { testname: item.testname },
      })
    };
    let Audit = AuditTrailValidation(
      "IDS_MDL_ORDERS",
      "IDS_SCN_PROTOCOLORDERS",
      "IDS_TSK_PROCESSPROTOCOL"
    );

    if (Audit) {
      ($("#auditTrailModalProtocolview") as any).modal("show");
      if (item.approved === 1) {
        passObjDet.objmanualaudit = Manualauditobject(
          "open",
          "Protocol Orders"
        );
      } else {
        passObjDet.objmanualaudit = Manualauditobject(
          "process protocol",
          "Protocol Orders"
        );
      }
      setAuditservicecall({
        AuditUrl: "" + ELNurl + "/protocol/LockUnlockprotocolorders",
        AuditObject: passObjDet,
        AuditPassfunction: (responce: any) => {
          if (responce.comment === "IDS_SAME_USER_OPEN") {
            props.alert.error(
              props.t("Orders.Sheetorders.IDS_MSG_ORDERALRESDYOPENED")
            );
            navigatetodashboardonlock();
          } else {
            Servicecalls(
              "" + ELNurl + "/protocol/updatetransactionhistory",
              passobj,
              (_res: any) => {
                setProtocolOrder((protocolOrder: any) => ({
                  ...item,
                  isprotocolprocess: true,
                  stopDisabled: true,
                  lstelnprotocolworkflow: workflow,
                  lockeduser: responce.lockeduser,
                  lockedusername: responce.lockedusername,
                  orderstarted: responce.orderstarted,
                  orderstartedby: responce.orderstartedby,
                  orderstartedon: responce.orderstartedon,
                  lsprotocolmaster: responce?.lsprotocolmaster,
                  elnprotocolworkflow: responce?.elnprotocolworkflow,
                  lssitemaster: responce?.lssitemaster,
                  protoclordername: item.protoclordername,
                  lsprojectmaster: responce?.lsprojectmaster,
                  canuserprocess: item?.canuserprocess === undefined ? workflow?.some(item => item.workflowcode === responce?.elnprotocolworkflow.workflowcode) : item?.canuserprocess,
                  approvelaccept: responce?.approvelaccept,
                  orderflag: responce?.orderflag
                }));
                setprotocolorderopen(true);
                const protocolorderopen = true;
                const protocolOrder = {
                  ...item,
                  isprotocolprocess: true,
                  stopDisabled: true,
                  lstelnprotocolworkflow: workflow,
                  lockeduser: responce.lockeduser,
                  lockedusername: responce.lockedusername,
                  lsprotocolmaster: responce?.lsprotocolmaster,
                  elnprotocolworkflow: responce?.elnprotocolworkflow,
                  lssitemaster: responce?.lssitemaster,
                  protoclordername: item.protoclordername,
                  orderflag: responce?.orderflag
                };
                const payload = {
                  protocolOrder,
                  protocolorderopen,
                  isdashboardclick,
                  selectedTreeItem,
                };
                store.dispatch(updatewithoutcloseprotocolorderdatas(payload));
                ($("#auditTrailModalProtocolview") as any).modal("hide");

                if (item.approved === 1) {
                  let passObjDet1 = {
                    objsilentaudit: Silentauditobject(
                      "open",
                      "Protocol Orders",

                      props.t(
                        "Orders.Protocolorders.IDS_AUDIT_OPENPROTOCOL",
                        {
                          batchid: item.protoclordername,
                          screen: orderTypeforprotocol(item.protocoltype),
                          Processed: item.canuserprocess && item.approved === 1
                            && item?.sharetome?.[0]?.sharerights === 0
                            ? "Opened"
                            : "Processed",
                          user: sessionStorage.Username,
                        }
                      )
                    ),
                  };
                  Servicecalls(
                    "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
                    passObjDet1,
                    onAuditValidateError.bind(this),
                    onAuditValidateFailure.bind(this)
                  );
                } else {
                  let passObjDet1 = {
                    objsilentaudit: Silentauditobject(
                      "process protocol",
                      "Protocol Orders",

                      props.t(
                        "Orders.Protocolorders.IDS_AUDIT_PROCESSORDER",
                        {
                          batchid: item.protoclordername,
                          screen: orderTypeforprotocol(item.protocoltype),
                          Processed: item.canuserprocess && !(item?.sharetome?.[0]?.sharerights === 0)
                            ? "Processed"
                            : "Opened",
                          user: sessionStorage.Username,
                        }
                      )
                    ),
                  };
                  Servicecalls(
                    "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
                    passObjDet1,
                    onAuditValidateError.bind(this),
                    onAuditValidateFailure.bind(this)
                  );
                }
              },
              ongetordersfailure.bind(this)
            );
          }
        },
        AuditFailfunction: ongetordersfailure.bind(this),
        AuditCancelfunction: () => {
          if (props.notificationpreviouspath) {
            history.push(props.notificationpreviouspath);
          }
        }
      });
    } else {
      setServicecall({
        ServiceToUrl: ELNurl + "/protocol/LockUnlockprotocolorders",
        ServiceHeaderobject: passObjDet,
        ServiceMethodType: "POST",
        ServcieonSuccess: (responce: any) => {

          if (responce.comment === "IDS_SAME_USER_OPEN" && responce.approvelstatus !== 3 && responce?.ordercancell !== undefined) {
            props.alert.error(
              props.t("Orders.Sheetorders.IDS_MSG_ORDERALRESDYOPENED")
            );
            navigatetodashboardonlock();
          } else {
            setProtocolOrder((protocolOrder: any) => ({
              ...item,
              ...responce,
              isprotocolprocess: true,
              stopDisabled: true,
              lstelnprotocolworkflow: workflow,
              lockeduser: responce.lockeduser,
              lockedusername: responce.lockedusername,
              orderstarted: responce.orderstarted,
              orderstartedby: responce.orderstartedby,
              orderstartedon: responce.orderstartedon,
              protoclordername: item.protoclordername,
              lsprojectmaster: responce?.lsprojectmaster,
              canuserprocess: item?.canuserprocess === undefined ? workflow?.some(item => item.workflowcode === responce?.elnprotocolworkflow.workflowcode) : item?.canuserprocess,
              approvelaccept: responce?.approvelaccept,
              orderflag: responce?.orderflag
            }));
            setprotocolorderopen(true);
            const protocolorderopen = true;
            const protocolOrder = {
              ...item,
              ...responce,
              lockeduser: responce.lockeduser,
              lssitemaster: responce?.lssitemaster,
              isprotocolprocess: true,
              stopDisabled: true,
              lstelnprotocolworkflow: workflow,
              lockedusername: responce.lockedusername,
              protoclordername: item.protoclordername,
              orderflag: responce?.orderflag
            };
            const payload = {
              protocolOrder,
              protocolorderopen,
              isdashboardclick,
              selectedTreeItem,
            };
            store.dispatch(updatewithoutcloseprotocolorderdatas(payload));
            console.log(store.getState().OpenprotocolordersDatas);
            Servicecalls(
              "" + ELNurl + "/protocol/updatetransactionhistory",
              passobj,
              ongetordersfailure,
              ongetordersfailure
            );
          }
        },
        ServcieonFailure: onAuditValidateFailure.bind(this),
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
      });
    }

    setOpenedProtocolOrder(item);
  };

  const Updateorderapprovalstatus = (res: any) => {

    if (stateData.length > 0) {
      let responseorder: any = [];
      responseorder.push(res);
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      let newdata = replaceonechangeorderordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        responseorder !== undefined && responseorder.length > 0
          ? responseorder
          : [],
        filefor,
        screen
      );
      console.log(newdata);

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        filefor
      );
      setSelectedTreeItem(selectedtree);

      if (res.approvelaccept === "3") {

        let Openedprotocol_Order = protocolOrder;
        Openedprotocol_Order.approvelaccept = res.approvelaccept;
        Openedprotocol_Order.approved = res.approved;
        Openedprotocol_Order.rejected = res.rejected;
        setProtocolOrder(Openedprotocol_Order);

      } else {

        let Openedprotocol_Order = protocolOrder;
        Openedprotocol_Order.approvelaccept = res.approvelaccept;
        setProtocolOrder(Openedprotocol_Order);

      }


      console.log(protocolOrder);
      setStateData(newdata);
      setprotocolorderopen(true);
      //setprotocolorderopen(res);
    }
  };

  const handleMultiSelectFileClick = (event: any, item: any) => {
    let itemindex = selectedFiles.findIndex(
      (obj) => obj.folderfilecode === item.folderfilecode
    );
    if (itemindex > -1) {
      selectedFiles.splice(itemindex, 1);
    } else {
      selectedFiles.push(item);
    }

    setSelectedFiles([...selectedFiles]);
  };

  const handleContextMenuView = (event: ContextMenuEvent) => {
    setMenuOffSet({ left: event.event.clientX, top: event.event.clientY });
    let returndata = stateCDFData.map((item) => {
      const currentItem = { ...item };
      currentItem.expanded = false;
      currentItem.selected = false;
      return currentItem;
    });
    setStateCDFData(returndata);
    deletefolderevents = event?.tree ? true : false;
    if (
      event.dataItem !== undefined &&
      event.dataItem !== null &&
      ((event.dataItem.filefor !== undefined &&
        (event.dataItem.filefor === "DR" ||
          event.dataItem.filefor === "TMP" ||
          event.dataItem.filefor === "TMM")) ||
        event.dataItem.order !== undefined)
    ) {
      if (
        event.dataItem.order !== undefined &&
        event.dataItem.order.ordercancell !== undefined
      ) {
        setIsMenuContext(false);
        setContextMenuView(false);
      } else {
        setContextMenuView(true);

        setIsMenuContext(false);
        handleListItemClick(event);
      }
    } else if (
      event.dataItem !== undefined &&
      event.dataItem !== null &&
      (event.dataItem.filefor !== undefined ||
        event.dataItem.file !== undefined)
    ) {
      setContextMenuView(true);

      setIsMenuContext(false);
      handleListItemClick(event);
    } else {
      setIsMenuContext(true);
    }

    if (event.dataItem?.Isview_Constence) {
      Isview_Constence = event.dataItem?.Isview_Constence;
    } else if (Isview_Constence) {
      Isview_Constence = false;
    }
  };

  const handleContextMenuClick = (event: ContextMenuEvent, item: any) => {
    if (item !== undefined && item.order !== undefined) {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "openorder"
      ) {
        handleOrderopenClick(null, item.order);
        // handleOrderopenClickfirst(null, item.order);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "moveorder"
      ) {
        setMoveDialogView(true);
      }
    } else if (item !== undefined && item.file !== undefined) {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "movefiles"
      ) {
        setMoveDialogView(true);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "deletefiles"
      ) {
        ondeletefile(item.file);
      }
    } else if (item !== undefined && item.menuselected) {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "selectmultiorders"
      ) {
        setIsMultiSelectOrder(true);
        setSelectedOrders([]);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "selectmultifiles"
      ) {
        setIsMultiSelectFile(true);
        setSelectedFiles([]);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "selectmultifolders"
      ) {
        setIsMultiSelectFolders(true);
        setSelectedFolders([]);
      }
    } else {
      if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "createfolder"
      ) {
        setAddDialogVisible(true);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "renamefolder"
      ) {
        setEditDialogView(true);
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "deletefolder"
      ) {
        if (
          selectedTreeItem !== undefined &&
          selectedTreeItem !== null &&
          selectedTreeItem.parentdircode === -1
        ) {
          let issingleparent = stateData.findIndex(
            (obj) =>
              obj.parentdircode === -1 &&
              obj.directorycode !== selectedTreeItem?.directorycode
          );
          if (issingleparent <= -1) {
            props.alert.error("The system should have atleast one directory.");
          } else {
            setDeleteDialogView(true);
          }
        } else {
          setDeleteDialogView(true);
        }
      } else if (
        event.item &&
        event.item.data &&
        event.item.data.key &&
        event.item.data.key === "movefolder"
      ) {
        setMoveDialogView(true);
      }
    }
  };

  const handleDialogClose = () => {
    setDeleteDialogView(false);
    setEditDialogView(false);
    setMoveDialogView(false);
    setAddDialogVisible(false);
  };

  const handleorderonclose = () => {

    let protocolOrdercopy = ProtocolSequence(protocolOrder);

    let element: any = document.getElementsByClassName(
      "rc-tabs-nav-list tabremove"
    );

    if (element.item(0) !== null && element.item(0) !== undefined) {
      element.item(0).classList.remove("tabremove");
    }

    setprotocolorderopen(false);
    store.dispatch(updatewithoutcloseprotocolorderdatas({}));
    setIsdashboardclick(false);
    if (props.onopen !== undefined) {
      props.onopen(undefined, false);
    }

    console.log(openedprotocolOrder);

    setProtocolOrder((protocolOrder: any) => ({
      ...protocolOrder,
      stopDisabled: false,
      lstelnprotocolworkflow: workflow,
      protoclordername: protocolOrdercopy.protoclordername
    }));

    navigatetodashboardonlock();

  };

  const navigatetodashboardonlock = () => {
    if (props.notificationpreviouspath) {
      let passobj = {
        protocolordercode: protocolOrder.protocolordercode,
        createby: { usercode: sessionStorage.User }, stependdate: GetutcDate(new Date()),
        action: props.t("Templates.Protocoltemplates.IDS_LBL_PROCESSORDER", {
          batchid: openedprotocolOrder.protoclordername, Processed: "Closed",
          user2: sessionStorage.Username
        }), viewoption: 2,
        orderobjects: JSON.stringify({
          protocolordercode: protocolOrder.protocolordercode,
          protoclordername: openedprotocolOrder.protoclordername,
          action: "OrderClose",
          opentype: "Closed"
        })
      }

      Servicecalls(ELNurl + "/protocol/updatetransactionhistory",
        passobj, () => { }, () => { });
      if (protocolOrder?.lockeduser === Number(sessionStorage.User)) {
        let passObjDet = {
          protocolordercode: openedprotocolOrder?.protocolordercode,
          lockeduser: sessionStorage.User,
          lockedusername: sessionStorage.Username,
          comment: "Order_Unlock",
          activeuser: Number(sessionStorage.getItem('activeUserId')),
          ismultitenant: isMultitenant
        }
        Servicecalls(ELNurl + "/protocol/LockUnlockprotocolorders",
          passObjDet, () => { }, () => { });
      }
      history.push(props.notificationpreviouspath);
    }
  }

  const onworkflowupdate = (response: any) => {
    let responseorder = [];
    responseorder.push(response);
    let folderdata =
      stateData !== undefined && stateData !== null && stateData.length > 0
        ? stateData
        : initialorders !== null
          ? initialorders
          : [];
    let directorycode: any =
      selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
    let filefor: any =
      selectedTreeItem !== null ? selectedTreeItem.filefor : "";
    let newdata = replaceonechangeorderordertoFolderwithfilefor(
      folderdata,
      directorycode,
      intl,
      responseorder !== undefined && responseorder.length > 0
        ? responseorder
        : [],
      filefor,
      screen
    );

    let selectedtree = getDirectoryOncodeandfilefor(
      newdata,
      directorycode,
      filefor
    );
    setSelectedTreeItem(selectedtree);
    setStateData(newdata);
    let protocolOrder = {
      ...response,
      isprotocolprocess: true,
      // KenodclassName: "clsdisplayblock",
      // orderDetailsclassName: "clsDisplaynone",
      stopDisabled: true,
      lstelnprotocolworkflow: workflow,
      toallowapprove: false,
      tocheckcontentsaveornot: false,
    };

    setProtocolOrder(protocolOrder);
    const protocolorderopen: any = true;
    const payload = {
      protocolOrder,
      protocolorderopen,
      isdashboardclick,
      selectedTreeItem,
    };
    store.dispatch(updatewithoutcloseprotocolorderdatas(payload));
    if (
      selectedGridItem !== undefined &&
      selectedGridItem.order !== undefined &&
      selectedGridItem.order.elnprotocolworkflow !== undefined &&
      response !== undefined &&
      response.elnprotocolworkflow !== undefined
    ) {
      let selectedGridItemobj: any = selectedGridItem;
      selectedGridItemobj.order.elnprotocolworkflow =
        response.elnprotocolworkflow;
      setSelectedGridItem(selectedGridItemobj);
      updateFileDetailsData(selectedGridItemobj);
    }
  };
  // const SaveSheetwithData = () => {
  //   setProtocolOrder((protocolOrder: any) => ({
  //     ...protocolOrder,
  //     MenuOption: 2,
  //     saveSheet: true,
  //     issave: false,
  //   }));
  // };

  const handleCloseMultiselectClick = (event: any) => {
    setIsMultiSelectOrder(false);
    setIsMultiSelectFile(false);
    setIsSelectAllFile(false);
    setIsSelectAllOrder(false);
    setIsMultiSelectFolders(false);
    setSelectedOrders([]);
    setSelectedFiles([]);
    setSelectedFolders([]);
    setIsMultiSelectOrder(false);
  };

  const handleMoveOnMultiselect = (event: any) => {
    console.log(selectedFiles);
    console.log(selectedOrders);
    // if (SelectAllFile||isSelectAllFile) {
    //   if ((AllSelectedFiles && AllSelectedFiles.length > 0)) {
    //     setMoveDialogView(true);
    //   } else {
    //     props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FILESELECT"));
    //   }
    // } else if (SelectAllOrder||isSelectAllOrder) {
    //   if ((AllSelectedOrder && AllSelectedOrder.length > 0)) {
    //     setMoveDialogView(true);
    //     setSelectedOrders(AllSelectedOrder);
    //   } else {
    //     props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FILESELECT"));
    //   }
    // }
    // else
    if (
      (selectedFiles && selectedFiles.length > 0) ||
      (selectedOrders && selectedOrders.length > 0) ||
      (selectedFolders && selectedFolders.length > 0)
    ) {
      setMoveDialogView(true);
    } else {
      props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FILESELECT"));
    }
  };

  document.addEventListener("click", (event) => {
    let id = (event.target as HTMLElement).getAttribute("id");
    if (id === "idcontextmenushow" || id === "idcontextmenushowicon") {
      setIsMenuContext(true);
      setContextMenuView(true);
    } else if (isMenuContext || contextMenuView) {
      setIsMenuContext(false);
      setContextMenuView(false);
    }
  });

  // let sheetview = "col-lg-12 full-screen-view-single-level-right";
  // if (
  //   protocolOrder.KenodclassName === "clsdisplayblock" &&
  //   protocolOrder.IsShowDesigner === true
  // ) {
  //   sheetview = "col-lg-9 full-screen-view-single-level-right";
  // } else if (protocolOrder.KenodclassName === "clsdisplayblock") {
  //   sheetview = "col-lg-12 full-screen-view-single-level-right";
  // } else {
  //   sheetview = "col-lg-9 full-screen-view-single-level-right";
  // }
  // console.log(
  //   selectedTreeItem && selectedTreeItem.items
  //     ? process(
  //       selectedTreeItem.items.map((item) => {
  //         if (item.order !== undefined) {
  //           item.order.directorycode = item.directorycode;
  //         }
  //         return {
  //           ...item,
  //           ...item.order,
  //           // link: generateLink(item.order !== undefined ? item.order.protocolordercode : ""),
  //           [SELECTED_FIELD]: gridSelection[idGetter(item)],
  //         };
  //       }),
  //       stateContentData
  //     )
  //     : !selectedTreeItem
  //       ? process(
  //         stateData.map((item) => {
  //           if (item.order !== undefined) {
  //             item.order.directorycode = item.directorycode;
  //           }
  //           return {
  //             ...item,
  //             ...item.order,
  //             // link: generateLink(item.order !== undefined ? item.order.protocolordercode : ""),
  //             [SELECTED_FIELD]: gridSelection[idGetter(item)],
  //           };
  //         }),
  //         stateContentData
  //       )
  //       : null
  // );

  const onfilterTypeChange = (key: any) => {
    localStorage.setItem("protocolorderfiltertype", key);
    setfilterType(key);
  };

  const onOrderShared = (item: any) => {
    if (selectedTreeItem !== undefined && selectedTreeItem !== null) {
      let directorycode = selectedTreeItem?.directorycode;
      let filefor = selectedTreeItem?.filefor;
      if (
        filefor === "UR" &&
        directorycode !== undefined &&
        directorycode?.toString() === sessionStorage.getItem("User")
      ) {
        let selectedtreeitems =
          selectedTreeItem !== undefined ? selectedTreeItem?.items : [];
        let selecteditem = selectedGridItem;
        selectedtreeitems = selectedtreeitems?.map((obj: any) => {
          if (
            obj.directorycode === item.order.order.protocolordercode &&
            obj.order !== undefined
          ) {
            if (obj.order.sharebyme === undefined) {
              obj.order.sharebyme = [];
            }
            let shareindex = obj.order.sharebyme.findIndex(
              (shareobj: any) =>
                shareobj.sharedbycode === item.order.sharedbycode
            );
            let itemvalue = item.order;
            itemvalue.sharedonDate = convertDateFormat(
              convertUTCDateToLocalDate(new Date(itemvalue.sharedon)),
              intl
            );
            if (shareindex <= -1) {
              obj.order.sharebyme.push(itemvalue);
            } else {
              obj.order.sharebyme[shareindex] = itemvalue;
            }
            selecteditem = obj;
          }
          return obj;
        });
        if (selectedtreeitems !== undefined) {
          selectedTreeItem.items = selectedtreeitems;
          setSelectedTreeItem(selectedTreeItem);
          setSelectedGridItem(selecteditem);
          setDetailsData(selecteditem);
        }
      }
    }
  };
  const closeunsharelist = (_item: any) => {
    setIsunshareopen(false);
    setSelectedUnsharedItem({});
  };

  const onorderunshare = (item: any) => {
    let selectunshare: any = selectedUnsharedItem;
    if (selectunshare !== undefined && Object.keys(selectunshare).length > 0) {
      let unsharedindex = selectunshare.sharebyme.findIndex(
        (obj: any) => obj.sharedbycode === item.sharedbycode
      );
      if (unsharedindex > -1) {
        let canremove = false;
        selectunshare.sharebyme.splice(unsharedindex, 1);
        if (selectunshare.sharebyme.length <= 0) {
          delete selectunshare.sharebyme;
          if (
            selectunshare.assignedto === undefined &&
            selectunshare.sharetome === undefined
          ) {
            canremove = true;
          }
        }
        let newData = stateData;
        let selectedtree = selectedTreeItem;
        if (selectedTreeItem?.directorycode !== undefined) {
          if (!canremove) {
            newData = addorderitemstoFolderwithfilefor(
              stateData,
              selectedTreeItem?.directorycode,
              intl,
              [selectunshare],
              "UR",
              screen
            );
            setStateData(newData);
            setSelectedGridItem(selectunshare);
            setSelectedUnsharedItem(selectunshare);
          } else if (canremove) {
            newData = deleteorderitemstoFolderwithfilefor(
              stateData,
              selectedTreeItem?.directorycode,
              intl,
              [selectunshare],
              "OSBM",
              screen
            );
            setStateData(newData);
            setSelectedGridItem({});
            setSelectedUnsharedItem({});
            setDetailsData(null);
          }
          selectedtree = getDirectoryOncodeandfilefor(
            newData,
            selectedTreeItem?.directorycode,
            "OSBM"
          );
          setSelectedTreeItem(selectedtree);
          // setSelectedTreeItemDuplicate(selectedtree);
        }

        setPullcontents(true);
      }
      let passobj = [{
        protocolordercode: selectunshare.protocolordercode,
        createby: { usercode: sessionStorage.User },
        stepstartdate: GetutcDate(new Date()),
        viewoption: 6,
        orderobjects: JSON.stringify({
          protocolordercode: selectunshare.protocolordercode,
          protoclordername: selectunshare.protoclordername,
          action: "unshare",
          privileges: item?.sharerights,
          sharebyusername: item.sharebyusername,
          sharetousername: item.sharetousername,
        })
      }]
      ProtocolOrderTransactionDataUpdate(passobj);
    }
  };
  /**
   * Used to get the selected from and to date for date filteration
   * @param From date
   * @param To date
   */
  const setdateRange = (e: any, isrest: Boolean) => {
    setfromRange(e.from);
    settoRange(e.to);
    setchangedtodate(e.changedtodate);
    let daydiff = dateDiffInDays(new Date(e.from), new Date(e.to)).toString();
    localStorage.setItem("protocolorderdatefilterdiff", daydiff);
    initialorders = null;
    if (e.projects !== undefined && e.test !== undefined && !isrest) {
      setFliterproject(e.projects);
      setFlitertest(e.test);
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        protocoltype,
        SearchCriteriaType.value,
        orderflag,
        e.test,
        e.projects,
        e.iscancelled
      );
    } else if (e.orderflag !== undefined && !isrest) {
      // if (e.orderflag === 1 || e.orderflag === 2) {
      // let orderflagval = e.orderflag === 1 ? "N" : "R"
      setOrderflag(e.orderflag);
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        protocoltype,
        SearchCriteriaType.value,
        e.orderflag,
        flitertest,
        fliterproject,
        e.iscancelled
      );
      // }
    }
    else if (e.filetype !== undefined && !isrest && e.projects == undefined && (e.test === undefined || e.test.testcode === -1)) {
      setProtocoltype(e.filetype);
      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        e.filetype,
        SearchCriteriaType.value,
        orderflag,
        flitertest,
        fliterproject,
        e.iscancelled
      );
    }
    else if (isrest) {
      setProtocoltype(-1);
      setOrderflag(-1);
      setSearchContentText("");
      setSearchCriteriaType(0);
      setFlitertest({ testcode: -1, testname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }) });
      setFliterproject({ projectcode: -1, projectname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }) });
      setIscancelled(false);

      getordersforfolders(
        selectedTreeItem,
        selectedTreeItem,
        e.from,
        e.to,
        -1,
        "",
        -1,
        { testcode: -1, testname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }) },
        { projectcode: -1, projectname: props.t("Dashboard.IDS_LBL_SEARCHBYALL", { param: "", }) },
        e.iscancelled
      );
    }
    // else if(){

    // }

    // if (!isrest) {
    //   setIsFiltered(true);
    // } else {
    //   setIsFiltered(false);
    // }
  };

  let filesaveurl: any, fileremoveurl: any;
  if (selectedCDPTreeItem) {
    filesaveurl =
      selectedCDPTreeItem !== undefined && selectedCDPTreeItem !== null
        ? ELNurl +
        "/Instrument/uploadfilesprotocolfolder/" +
        selectedCDPTreeItem.directorycode +
        "/" +
        selectedCDPTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/uploadfilesprotocolfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;

    fileremoveurl =
      selectedCDPTreeItem !== undefined && selectedCDPTreeItem !== null
        ? ELNurl +
        "/Instrument/removefilesprotocolfolder/" +
        selectedCDPTreeItem.directorycode +
        "/" +
        selectedCDPTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/removefilesprotocolfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;
  } else {
    filesaveurl =
      selectedTreeItem !== undefined && selectedTreeItem !== null
        ? ELNurl +
        "/Instrument/uploadfilesprotocolfolder/" +
        selectedTreeItem.directorycode +
        "/" +
        selectedTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/uploadfilesprotocolfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;

    fileremoveurl =
      selectedTreeItem !== undefined && selectedTreeItem !== null
        ? ELNurl +
        "/Instrument/removefilesprotocolfolder/" +
        selectedTreeItem.directorycode +
        "/" +
        selectedTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/removefilesprotocolfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;
  }
  let homeuploadfile =
    ELNurl +
    "/Instrument/uploadfilesprotocolfolder/" +
    -1 +
    "/" +
    "DR" +
    "/" +
    sessionStorage.getItem("tenantid") +
    "/" +
    isMultitenant +
    "/" +
    sessionStorage.getItem("User") +
    "/" +
    sessionStorage.getItem("Usersite") +
    "/" +
    new Date() +
    "/" +
    fileviewfor;

  let homeremovefile =
    ELNurl +
    "/Instrument/removefilesprotocolfolder/" +
    -1 +
    "/" +
    "DR" +
    "/" +
    sessionStorage.getItem("tenantid") +
    "/" +
    isMultitenant +
    "/" +
    sessionStorage.getItem("User") +
    "/" +
    sessionStorage.getItem("Usersite") +
    "/" +
    new Date() +
    "/" +
    fileviewfor;

  const searchonButtonClick = (
    SearchContentText: any,
    searchCriteriaType: any,
    fromRange: any,
    toRange: any
  ) => {
    setfromRange(fromRange);
    settoRange(toRange);
    let daydiff = dateDiffInDays(
      new Date(fromRange),
      new Date(toRange)
    ).toString();
    localStorage.setItem("protocolorderdatefilterdiff", daydiff);
    if (
      SearchContentText !== "" &&
      searchCriteriaType.value !== undefined &&
      searchCriteriaType.value === 2
    ) {
      setSearchCriteriaType({ ...searchCriteriaType });
      setSearchContentText(SearchContentText);
      if (
        selectedTreeItem !== undefined &&
        selectedTreeItem !== null &&
        selectedTreeItem.items !== undefined
      ) {
        let filterorders = selectedTreeItem.items.filter((item) =>
          item.order.keyword
            .toLowerCase()
            .includes(SearchContentText.toLowerCase())
        );
        setSelectedTreeItem({
          ...selectedTreeItem,
          items: filterorders,
        });
      }
    } else if (
      searchCriteriaType.value !== undefined &&
      (searchCriteriaType.value === 3 || searchCriteriaType.value === 1)
    ) {
      setSearchCriteriaType({ ...searchCriteriaType });
      if (searchCriteriaType.value === 3) {
        setSearchContentText({ SearchContentText });
      } else if (searchCriteriaType.value === 1) {
        setSearchContentText("");
      }
    }
  };

  const updateskiptake = (skiptake: any) => {
    setTakeskip(skiptake);
  };

  const handleoncolumnchange = (column: any, splititems: any) => {
    setColumns([...column]);
    setsplitBtnItems(splititems);
  };

  const handleSelectAllOrderClick = (event: any) => {
    if (selectedTreeItem?.items !== undefined) {
      if (event.checked) {
        let items: any = [selectedTreeItem?.items];
        console.log(items);
        let orders: any = [];
        items[0].map((obj: any) => {
          if (obj.order !== undefined) {
            orders.push(obj.order);
          }
          return true;
        });

        console.log(orders);
        setSelectedOrders([...orders]);
        setSelectedTreeItem(selectedTreeItem);
        setIsSelectAllOrder(true);
        SelectAllOrder = true;
        AllSelectedOrder = orders;

        console.log(AllSelectedOrder);
      } else {
        setIsSelectAllOrder(false);
        setSelectedOrders([]);
        SelectAllOrder = undefined;
      }
    } else if (stateData !== undefined) {
      if (event.checked) {
        let items: any = stateData;
        console.log(items);
        let orders: any = [];
        items.map((obj: any) => {
          if (obj.order !== undefined) {
            orders.push(obj);
          }
          return true;
        });

        console.log(orders);
        //setSelectedOrders([...orders]);
        setIsSelectAllOrder(true);
        SelectAllOrder = true;
        AllSelectedOrder = orders;
        console.log(AllSelectedOrder);
      } else {
        setIsSelectAllOrder(false);
        SelectAllOrder = undefined;
      }
    }
  };

  const handleSelectAllFileClick = (event: any) => {
    if (selectedTreeItem?.items !== undefined) {
      if (event.checked) {
        let items: any = [selectedTreeItem?.items];
        let files: any = [];
        items[0].map((obj: any) => {
          if (obj.file !== undefined) {
            // obj.selected=true;
            files.push(obj.file);
          }
          return true;
        });
        console.log(files);
        SelectAllFile = true;
        setSelectedTreeItem(selectedTreeItem);
        setSelectedFiles([...files]);
        setIsSelectAllFile(true);
        AllSelectedFiles = files;
        console.log(AllSelectedFiles);
      } else {
        setIsSelectAllFile(false);
        setSelectedFiles([]);
        SelectAllFile = undefined;
      }
    } else if (stateData !== undefined) {
      if (event.checked) {
        let items: any = stateData;
        let files: any = [];
        items.map((obj: any) => {
          if (obj.file !== undefined) {
            files.push(obj.file);
            setSelectedGridItem(obj);
          }
          return true;
        });
        console.log(files);
        //  setSelectedFiles([selectedTreeItem?.items]);
        setSelectedFiles([...files]);
        setIsSelectAllFile(true);
        SelectAllFile = true;
        AllSelectedFiles = files;
        console.log(AllSelectedFiles);
      } else {
        setIsSelectAllFile(false);
        SelectAllFile = undefined;
      }
    }
  };

  const ondeletefile = (file: any) => {
    let filedeleteurl =
      selectedTreeItem !== undefined && selectedTreeItem !== null
        ? ELNurl +
        "/Instrument/deleteprotocolfilesforfolder/" +
        selectedTreeItem.directorycode +
        "/" +
        selectedTreeItem.filefor +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor
        : ELNurl +
        "/Instrument/deleteprotocolfilesforfolder/" +
        -1 +
        "/" +
        "DR" +
        "/" +
        sessionStorage.getItem("tenantid") +
        "/" +
        isMultitenant +
        "/" +
        sessionStorage.getItem("User") +
        "/" +
        sessionStorage.getItem("Usersite") +
        "/" +
        new Date() +
        "/" +
        fileviewfor;

    console.log(stateData);
    setServicecall({
      ServiceToUrl: filedeleteurl,
      ServiceHeaderobject: file,
      ServiceMethodType: "POST",
      ServcieonSuccess: ondeletefileSuccess,
      ServcieonFailure: ondeletefileFailure,
      ServiceTenant: undefined,
      Servicecontenttype: undefined,
      ServcieProcessbar: true,
    });
  };

  const ondeletefileSuccess = (response: any, passdata: any) => {
    confirmAlert({
      title: props.t("Confirm"),
      message: props.t("Do you want to delete this file?"),
      buttons: [
        {
          label: props.t("Yes"),
          onClick: () => {
            let file = passdata;
            let selecttree = getDirectoryOncode(stateData, file.directorycode);
            let directory: number = file.directorycode;

            let newData: any = [];
            if (selectedTreeItem === undefined || selectedTreeItem === null) {
              selecttree = getDirectoryOncode(stateData, file.folderfilecode);
              directory = file.folderfilecode;
              newData = deletefileitemsforhomebutton(stateData, [
                {
                  directorycode: file.folderfilecode,
                  file: file,
                  filefor: "FIL",
                },
              ]);
            } else {
              newData = deletefileitemstoFolderwithfilefor(
                stateData,
                directory,
                intl,
                [
                  {
                    directorycode: file.folderfilecode,
                    file: file,
                    filefor: "FIL",
                  },
                ],
                selecttree !== undefined && selecttree !== null && selecttree?.filefor
                  ? selecttree?.filefor
                  : "",
                screen
              );
            }
            setStateData(newData);

            let passObjDet = {
              objsilentaudit: Silentauditobject(
                "delete",
                "Protocol Orders",
                props.t("Orders.Protocolorders.IDS_AUDIT_FILEDELETE", {
                  file: response.file.filename,
                  user: store.getState().Loggeduser.username,
                })
              ),
            };
            Servicecalls(
              "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
              passObjDet,
              onAuditValidateError.bind(this),
              onAuditValidateFailure.bind(this)
            );
            props.alert.success(props.t("Orders.Protocolorders.IDS_MSG_FILEDELETED"));
          }
        },
        {
          label: props.t("No"),
          onClick: () => {
          }
        }
      ]
    });
  };

  const stopautoregister = (event: any) => {
    console.log(event);
    //let repeat = false;

    let protocolordercode = event.order.protocolordercode;
    let protoclordername = event.order.protoclordername;

    let passObjDet1 = {
      repeat: false,
      protocolordercode: event.order.protocolordercode,
      protoclordername: event.order.protoclordername,
    };
    let passObjDet2 = {
      objsilentaudit: Silentauditobject(
        "stop Auto Register",
        "Sheet Orders",
        props.t("Orders.Sheetorders.IDS_AUDIT_AUTOREGISTEREND", {
          // screen: orderType(stateOrder.Assigntestfor),
          batchid: event.order.protocolordercode,
          //user: store.getState().Loggeduser.username,
        })
      ),
    };

    let passobj3 = {
      protocolordercode: protocolordercode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Orders.Sheetorders.IDS_AUDIT_STOPAUTO", {
        // screen: orderType(stateOrder.Assigntestfor),
        batchid: protoclordername,
        user: store.getState().Loggeduser.username,
      }),
      viewoption: 5,
    };

    if (auditRights.IDS_TSK_AUTOREGORDERCANCEL) {
      let objManualAudit = passObjDet1 as any;
      objManualAudit.objmanualaudit = Manualauditobject(
        "stop Auto Register",
        "Protocol Orders"
      );
      ($("#auditTrailModalProtocolview") as any).modal("show");
      setAuditservicecall({
        AuditUrl: "" + ELNurl + "/protocol/stopprotoautoregister",
        AuditObject: objManualAudit,
        AuditPassfunction: (res: any) => {
          props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_AUTOREGSTOP"));
          updatestateorderdata(res);
          Servicecalls(
            "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler", passObjDet2, onAuditValidateError, onAuditValidateFailure,

            "" + ELNurl + "/protocol/updatetransactionhistory", passobj3, onAuditValidateError, onAuditValidateFailure
          );
        },
        AuditFailfunction: onAuditValidateFailure,
      });
    } else {
      Servicecalls(
        "" + ELNurl + "/protocol/stopprotoautoregister",
        passObjDet1,
        (res: any) => {
          props.alert.success(props.t("Orders.Sheetorders.IDS_MSG_AUTOREGSTOP"));
          console.log(res);
          updatestateorderdata(res);

          // setStoptimeitem(res);
        },
        (res: any) => { }
      );

      Servicecalls(
        "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet2,
        onAuditValidateError,
        onAuditValidateFailure,

        "" + ELNurl + "/protocol/updatetransactionhistory",
        passobj3,
        onAuditValidateError,
        onAuditValidateFailure
      );
    }
  };

  const onordercommonaction = (items: any, actiontype: any) => {
    if (items?.order.protocolordercode !== undefined) {
      let passObjDet = {
        protocolordercode: items?.order.protocolordercode,
        multiusergroupcode: sessionStorage.multiusergroups,
        lstelnprotocolworkflow: Getprotocoluserworkflowfromsession(),
        lsuserMaster: store.getState().Loggeduser
      };
      Servicecalls(
        "" + ELNurl + "/protocol/getsingleprotocolorder",
        passObjDet,
        (response: any) => {
          if (
            response.length > 0 &&
            response[0].lockeduser !== undefined &&
            response[0].lockeduser !== null && actiontype !== "duplicate"
          ) {
            props.alert.error(
              props.t("Orders.Protocolorders.IDS_LBL_CANCELLORDERWIHTOUTUNLOCK")
            );
          } else {
            if (actiontype === "duplicate") {
              setDublicateorderitem(response.length > 0 ? response[0] : items.order !== undefined ? items.order : items);
              setDuplicateorder(true);
            } else {
              setCancellorderitem(
                items.order !== undefined ? items.order : items
              );
              setCancellorder(true);
            }
          }
        },
        () => { }
      );
    }
  };

  const ondeletefileFailure = (_response: any) => { };

  const handleMultiSelectFolderClick = (event: any, item: any) => {
    let itemindex = selectedFolders.findIndex(
      (obj) => obj.directorycode === item.directorycode
    );
    if (itemindex > -1) {
      selectedFolders.splice(itemindex, 1);
    } else {
      selectedFolders.push(item);
    }

    setSelectedFolders([...selectedFolders]);
  };

  const Itemview = React.useCallback(() => {
    return (
      <React.Fragment>
        {contentView === "grid" ? (
          <OverlayScrollbarsComponent style={{ height: "calc(100vh - 235px)" }}>
            <div className="heightgird">
              <Suspense fallback={<div></div>}>
                <GridView
                  data={
                    selectedTreeItem && selectedTreeItem.items
                      ? process(
                        selectedTreeItem.items.map((item) => {
                          if (item.order !== undefined) {
                            item.order.directorycode = item.directorycode;
                          }
                          return {
                            ...item,
                            ...item.order,
                            // link: generateLink(item.order !== undefined ? item.order.protocolordercode : ""),
                            [SELECTED_FIELD]: gridSelection[idGetter(item)],
                          };
                        }),
                        stateContentData
                      )
                      : !selectedTreeItem
                        ? process(
                          stateData.map((item) => {
                            if (item.order !== undefined) {
                              item.order.directorycode = item.directorycode;
                            }
                            return {
                              ...item,
                              ...item.order,
                              // link: generateLink(item.order !== undefined ? item.order.protocolordercode : ""),
                              [SELECTED_FIELD]: gridSelection[idGetter(item)],
                            };
                          }),
                          stateContentData
                        )
                        : null
                  }
                  ondeletefile={ondeletefile}
                  filedownloadurl={
                    ELNurl +
                    "/Instrument/downloadprotocolfileforfolder/" +
                    isMultitenant +
                    "/" +
                    sessionStorage.getItem("tenantid")
                  }
                  sort={stateContentData.sort}
                  dataItemKey={DATA_ITEM_KEY}
                  onSelectionChange={handleSelectionChange}
                  onMultipleSelection={handleMultipleSelection}
                  onSortChange={handleSortChange}
                  onDoubleClick={handleGridDoubleClick}
                  onContextMenu={handleContextMenuView}
                  onOrderShared={onOrderShared}
                  openunsharelist={openunsharelist}
                  props={props}
                  columns={columns}
                  splitItems={splitBtnItems}
                  screen={screen}
                  skiptake={takeskip}
                  updateskiptake={updateskiptake}
                  name={"Protocolorders_1"}
                  isMultiSelectOrder={isMultiSelectOrder}
                  isMultiSelectFile={isMultiSelectFile}
                  isMultiSelectFolders={isMultiSelectFolders}
                  onMultiFolderSelect={handleMultiSelectFolderClick}
                  multiSelectedFolders={selectedFolders}
                  onMultiFileSelect={handleMultiSelectFileClick}
                  onordercommonaction={onordercommonaction}
                  onOrderOpen={handleOrderopenClick}
                  handleExcelExport={handleExcelExport}
                  stopautoregister={stopautoregister}
                  onMultiOrderSelect={handleMultiSelectClick}
                  multiSelectedOrders={selectedOrders}
                  onSelectAllOrderClick={handleSelectAllOrderClick}
                  isSelectAllOrder={isSelectAllOrder}
                  SelectAllOrder={SelectAllOrder}
                  isSelectAllFile={isSelectAllFile}
                  SelectAllFile={SelectAllFile}
                  multiSelectedFiles={selectedFiles}
                  onSelectAllFileClick={handleSelectAllFileClick}
                />
              </Suspense>
            </div>
          </OverlayScrollbarsComponent>

        ) : (
          <OverlayScrollbarsComponent style={{ height: "calc(100vh - 235px)" }}>
            <Suspense fallback={<div></div>}>
              <ListView
                data={
                  selectedTreeItem && selectedTreeItem.items
                    ? process(
                      selectedTreeItem.items.map((item) => ({
                        ...item,
                        [SELECTED_FIELD]: gridSelection[idGetter(item)],
                      })),
                      stateContentData
                    )
                    : !selectedTreeItem
                      ? process(
                        stateData.map((item) => ({
                          ...item,
                          [SELECTED_FIELD]: gridSelection[idGetter(item)],
                        })),
                        stateContentData
                      )
                      : null
                }
                ondeletefile={ondeletefile}
                filedownloadurl={
                  ELNurl +
                  "/Instrument/downloadprotocolfileforfolder/" +
                  isMultitenant +
                  "/" +
                  sessionStorage.getItem("tenantid")
                }
                sort={stateContentData.sort}
                onSelectionChange={handleSelectionChange}
                onMultipleSelection={handleMultipleSelection}
                onItemClick={handleListItemClick}
                onDoubleClick={handleGridDoubleClick}
                onContextMenu={handleContextMenuView}
                onOrderOpen={handleOrderopenClick}
                // onOrderOpen={handleOrderopenClickfirst}
                multiSelectedOrders={selectedOrders}
                onSelectAllFileClick={handleSelectAllFileClick}
                onSelectAllOrderClick={handleSelectAllOrderClick}
                isMultiSelectFile={isMultiSelectFile}
                isSelectAllFile={isSelectAllFile}
                isSelectAllOrder={isSelectAllOrder}
                SelectAllFile={SelectAllFile}
                SelectAllOrder={SelectAllOrder}
                onMultiOrderSelect={handleMultiSelectClick}
                isMultiSelectOrder={isMultiSelectOrder}
                onOrderShared={onOrderShared}
                props={props}
                screen={screen}
                openunsharelist={openunsharelist}
                closeunsharelist={closeunsharelist}
                multiSelectedFiles={selectedFiles}
                columns={columns}
                isMultiSelectFolders={isMultiSelectFolders}
                onMultiFolderSelect={handleMultiSelectFolderClick}
                multiSelectedFolders={selectedFolders}
                activekey={
                  selectedTreeItem !== null && selectedTreeItem !== undefined
                    ? selectedTreeItem.filefor
                    : ""
                }
                onordercommonaction={onordercommonaction}
                onMultiFileSelect={handleMultiSelectFileClick}
                stopautoregister={stopautoregister}
              />
            </Suspense>
          </OverlayScrollbarsComponent>
        )}
      </React.Fragment>
    );
  }, [
    selectedTreeItem,
    stateData,
    stateContentData,
    selectedGridItem,
    contentView,
    isMultiSelectOrder,
    isMenuContext,
    takeskip,
    gridSelection,
    selectedOrders,
    selectedFiles,
    isMultiSelectFile,
    isMultiSelectFolders,
    selectedFolders,
    columns,
  ]);

  const handleAddFileChange = (event: UploadAddEvent) => {
    if (
      event &&
      event.event &&
      event.event.affectedFiles &&
      event.event.affectedFiles.length > 0 &&
      event.event.affectedFiles[0].status === 3 &&
      event.event.affectedFiles[0].progress === 0
    ) {
      if (event.files) {
        setAddedfiles(event.files);
      }
      Servicecalls(
        "" + ELNurl + "/Instrument/validateprotocolexistonfolder",
        {
          directorycode: selectedTreeItem?.directorycode,
          filefor: selectedTreeItem?.filefor,
          filename: event.event.affectedFiles[0].name,
        },
        onvalidateSuccess.bind(this),
        onvalidateFailure.bind(this)
      );
    }
  };
  const onvalidateSuccess = (response: any) => {
    if (response.status) {
      if (addedfiles) {
        setFiles(addedfiles);
      }
    }
  };

  const closeModel = () => {
    setCancellorder(false);
    setDuplicateorder(false);
    setCancellorderitem("");
    setDublicateorderitem("");
  };

  const onsavecancelformodal = (saveActiontype: any) => {
    if (cancellorderitem !== undefined && cancellorderitem !== null && cancellorderitem !== "" && saveActiontype === "cancellorder") {
      let passObjDet = cancellorderitem;
      passObjDet.ordercancell = 1;
      if (auditRights.IDS_TSK_CANCELORDER) {
        passObjDet.objmanualaudit = Manualauditobject(
          "cancel",
          "Protocol Orders"
        );
        ($("#auditTrailModalProtocolview") as any).modal("show");
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/protocol/cancelprotocolorder",
          AuditObject: passObjDet,
          AuditPassfunction: oncancelprotocolordersucess,
          AuditFailfunction: oncancelprotocolorderFailure,
        });
      } else {
        Servicecalls(
          "" + ELNurl + "/protocol/cancelprotocolorder",
          passObjDet,
          oncancelprotocolordersucess.bind(this),
          oncancelprotocolorderFailure.bind(this)
        );
      }
    } else {
      console.log(dublicateorderitem);
      const {
        testcode,
        lstestmasterlocal,
        lsprojectmaster,
        protocolordercode,
        protocoltype,
        lsprotocolmaster,
        testname,
        keyword,
        tittle,
        lsrepositories,
        lsrepositoriesdata,
        elnmaterial,
        elnmaterialinventory,
        assignedto,
        directorycode,
        orderdisplaytype,
        viewoption,
        repeat,
        lsprotocolselectedTeam,
        teamselected
      } = dublicateorderitem;

      const sequence = getsequenceoncode(2);
      const projectName = lsprojectmaster?.projectname || "";
      const projectCode = lsprojectmaster?.projectid || "";
      const taskName = testname || "";
      const sequenceid = sequence
        ? formsequenceformatview(
          JSON.parse(sequence.sqf),
          sequence.sep,
          "g",
          {
            projectname: projectName,
            projectcode: projectCode,
            task: taskName,
            ordertype: getprotocolordertype(Number(protocoltype)),
            protocolordercode
          }
        )
        : undefined;
      const passObjDet: any = {
        testcode,
        protocolordercode,
        lstestmasterlocal,
        lsprojectmaster,
        protocoltype,
        lsprotocolmaster,
        testname,
        keyword,
        tittle,
        lsrepositories,
        lsrepositoriesdata,
        elnmaterial,
        elnmaterialinventory,
        assignedto,
        directorycode,
        orderdisplaytype,
        viewoption,
        repeat,
        lsprotocolselectedTeam,
        teamselected,
        sitecode: sessionStorage.Usersite,
        ismultitenant: isMultitenant,
        createdbyusername: sessionStorage.Username,
        objuser: { multiusergroupcode: sessionStorage.multiusergroups },
        multiusergroupcode: sessionStorage.multiusergroups,
        createby: sessionStorage.User,
        templateversionno: lsprotocolmaster?.approved !== undefined && lsprotocolmaster?.approved === 1 ? (lsprotocolmaster?.versionno) : (lsprotocolmaster?.versionno - 1),
        // templateversionno: lsprotocolmaster?.versionno ? lsprotocolmaster?.versionno : 1,
        lsuserMaster: store.getState().Loggeduser,
        lstelnprotocolworkflow: workflow,
        sequenceid,
        orderstarted: 0,
        isDefault: protocoldefaultcheck(),
        lsActiveWidgets: {
          screenname: "Protocol_Order",
          activityType: "Clone",
          userId: sessionStorage.User,
        }
      };
      console.log(passObjDet);
      console.log("kumu")
      let Audit = AuditTrailValidation(
        "IDS_MDL_ORDERS",
        "IDS_SCN_PROTOCOLORDERS",
        "IDS_TSK_CLONEORDER"
      );
      if (Audit) {
        ($("#auditTrailModalProtocolview") as any).modal("show");
        passObjDet.objmanualaudit = Manualauditobject(
          "cloned",
          "Protocol Orders"
        );
        setAuditservicecall({
          AuditUrl: "" + ELNurl + "/protocol/registerDuplicateOrder",
          AuditObject: passObjDet,
          AuditPassfunction: oninsertordersuccess.bind(this, true, null),
          AuditFailfunction: oninsertorderfailure.bind(this),
        });
      } else {
        setServicecall({
          ServiceToUrl:
            "" + ELNurl + "/protocol/registerDuplicateOrder",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: oninsertordersuccess.bind(this, true, null),
          ServcieonFailure: ongetordersfailure,
          ServiceTenant: undefined,
          Servicecontenttype: undefined,
        });
      }
    }
  }
  const oncancelprotocolordersucess = (response: any) => {
    response = ProtocolSequence(response);
    ($("#auditTrailModalProtocolview") as any).modal("hide");
    let responseorder = [];
    responseorder.push(response);
    let folderdata =
      stateData !== undefined && stateData !== null && stateData.length > 0
        ? stateData
        : initialorders !== null
          ? initialorders
          : [];
    let directorycode: any =
      selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
    let filefor: any =
      selectedTreeItem !== null ? selectedTreeItem.filefor : "";
    let newdata = replaceonechangeorderordertoFolderwithfilefor(
      folderdata,
      directorycode,
      intl,
      responseorder !== undefined && responseorder.length > 0
        ? responseorder
        : [],
      filefor,
      screen
    );

    let selectedtree = getDirectoryOncodeandfilefor(
      newdata,
      directorycode,
      filefor
    );
    setCancellorder(false);
    props.alert.success(
      props.t("Orders.Protocolorders.IDS_MSG_ORDERCANCELLEDSUCESS", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") })
    );
    setSelectedTreeItem(selectedtree);
    setStateData(newdata);
    setPullcontents(true);
    setDetailsData(null);
    let passObjDet1 = {
      objsilentaudit: Silentauditobject(
        "cancel",
        "Protocol Orders",
        props.t("Orders.Protocolorders.IDS_AUDIT_CANCELORDER", {
          order: response.protoclordername,
          screen: orderTypeforprotocol(response.protocoltype),
          user: store.getState().Loggeduser.username,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet1,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );

    let passobj = {
      // protocolorderstepcode: this.state.protocolToBeEdited.protocolorderstepcode,
      protocolordercode: cancellorderitem.protocolordercode,
      createby: { usercode: sessionStorage.User },
      stepstartdate: GetutcDate(new Date()),
      action: props.t("Templates.Protocoltemplates.IDS_LBL_PROCESSORDER", {
        batchid: cancellorderitem.protoclordername,
        Processed: "Cancelled",
        user2: sessionStorage.Username,
      }),
      viewoption: 5,
      orderobjects: JSON.stringify({
        protocolordercode: cancellorderitem.protocolordercode,
        protoclordername: cancellorderitem.protoclordername,
        action: "Cancelledorder",
        versionno: cancellorderitem?.versionno,
        sequenceid: cancellorderitem?.sequenceid,
        Reason: response?.objuser?.comments || undefined
      })
    };

    Servicecalls(
      "" + ELNurl + "/protocol/updatetransactionhistory",
      passobj,
      (res: any) => {
        getordersforfolders(
          selectedTreeItem,
          selectedTreeItem,
          fromRange,
          toRange,
          protocoltype,
          SearchCriteriaType.value,
          orderflag,
          flitertest,
          fliterproject,
          iscancelled
        );
      },
      (res: any) => {

      }
    );
  };

  const oncancelprotocolorderFailure = (_response: any) => { };

  const onvalidateFailure = (_response: any) => { };

  const handleDeleteOnMultiselect = (event: any) => {
    //  ondeletefile();
    console.log(selectedFiles);

    if (
      isMultiSelectFile &&
      SelectAllFile &&
      AllSelectedFiles &&
      AllSelectedFiles.length
    ) {
      ondeletemultifile(AllSelectedFiles);
    } else if (isMultiSelectFile && selectedFiles && selectedFiles.length) {
      ondeletemultifile(selectedFiles);
    } else if (
      isMultiSelectFolders &&
      selectedFolders &&
      selectedFolders.length
    ) {
      ondeletemultifolder(selectedFolders);
    } else {
      props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_PLEASESELECTARECORD"));
    }
  };

  const ondeletemultifolder = (_multifolder: any) => {
    if (
      selectedTreeItem !== undefined &&
      selectedTreeItem !== null &&
      selectedTreeItem.parentdircode === -1
    ) {
      let issingleparent = stateData.findIndex(
        (obj) =>
          obj.parentdircode === -1 &&
          obj.directorycode !== selectedTreeItem?.directorycode
      );
      if (issingleparent <= -1) {
        props.alert.error("The system should have atleast one directory.");
      } else {
        setDeleteDialogView(true);
      }
    } else {
      setDeleteDialogView(true);
    }
  };

  const ondeletemultifile = (multifile: any) => {
    setDeleteDialogView(true);
    // let filedeleteurl =
    //   selectedTreeItem !== undefined && selectedTreeItem !== null ? ELNurl + '/Instrument/deletemultifilesforfolderonprotocol/' + selectedTreeItem.directorycode
    //     + '/' + selectedTreeItem.filefor + '/' + sessionStorage.getItem("tenantid") + '/' + isMultitenant
    //     + '/' + sessionStorage.getItem("User") + '/' + sessionStorage.getItem("Usersite") + '/' + new Date() +
    //     '/' + fileviewfor
    //     : ELNurl + '/Instrument/deletemultifilesforfolderonprotocol/' + -1
    //     + '/' + "DR" + '/' + sessionStorage.getItem("tenantid") + '/' + isMultitenant
    //     + '/' + sessionStorage.getItem("User") + '/' + sessionStorage.getItem("Usersite") + '/' + new Date() +
    //     '/' + fileviewfor;

    // console.log(stateData);
    // setServicecall({
    //   ServiceToUrl: filedeleteurl,
    //   ServiceHeaderobject: multifile,
    //   ServiceMethodType: "POST",
    //   ServcieonSuccess: ondeletemultifileSuccess,
    //   ServcieonFailure: ondeletefileFailure,
    //   ServiceTenant: undefined,
    //   Servicecontenttype: undefined,
    //   ServcieProcessbar: true
    // });
  };

  const ondeletemultifileSuccess = (_response: any, passdata: any) => {
    let file = passdata;
    let newData: any = [];
    let updateddata: any = [];

    file.forEach((item: any) => {
      let selecttree = getDirectoryOncode(stateData, item.directorycode);
      let directory: number = item.directorycode;
      if (selectedTreeItem !== undefined && selectedTreeItem !== null) {
        if (updateddata.length === 0) {
          newData = deletefileitemstoFolderwithfilefor(
            stateData,
            directory,
            intl,
            [
              {
                directorycode: item.folderfilecode,
                file: item,
                filefor: "FIL",
              },
            ],
            selecttree !== undefined &&
              selecttree !== null &&
              selecttree?.filefor
              ? selecttree?.filefor
              : "",
            screen
          );
          updateddata = newData;
        } else {
          newData = deletefileitemstoFolderwithfilefor(
            updateddata,
            directory,
            intl,
            [
              {
                directorycode: item.folderfilecode,
                file: item,
                filefor: "FIL",
              },
            ],
            selecttree !== undefined &&
              selecttree !== null &&
              selecttree?.filefor
              ? selecttree?.filefor
              : "",
            screen
          );
        }
        updateddata = newData;
      } else {
        newData = deletefileitemsforhomebutton(stateData, [
          {
            directorycode: item.folderfilecode,
            file: item,
            filefor: "FIL",
          },
        ]);
      }
    });
    props.alert.success(props.t("Orders.Sheetorders.IDS_MULTIFILEDELETE"));

    setStateData(newData);
    setIsMultiSelectFile(false);
    setIsSelectAllFile(false);
    setSelectedFiles([]);
    setDetailsData(null);
    setDeleteDialogView(false);
    // let file = passdata;
    // let newData: any = [];
    // let updateddata: any = [];
    // file.forEach((item: any) => {

    //   let selecttree = getDirectoryOncode(stateData, item.directorycode);
    //   let directory: number = item.directorycode;
    //   if (selectedTreeItem !== undefined && selectedTreeItem !== null) {
    //     if (updateddata.length === 0) {
    //       newData = deletefileitemstoFolderwithfilefor(
    //         stateData,
    //         directory,
    //         intl,
    //         [{
    //           directorycode: item.folderfilecode,
    //           file: item,
    //           filefor: "FIL"
    //         }],
    //         selecttree !== undefined && selecttree !== null && selecttree?.filefor ? selecttree?.filefor : "",
    //         screen
    //       );
    //       updateddata = newData;
    //     }
    //     else {
    //       newData = deletefileitemstoFolderwithfilefor(
    //         updateddata,
    //         directory,
    //         intl,
    //         [{
    //           directorycode: item.folderfilecode,
    //           file: item,
    //           filefor: "FIL"
    //         }],
    //         selecttree !== undefined && selecttree !== null && selecttree?.filefor ? selecttree?.filefor : "",
    //         screen
    //       );
    //     }
    //     updateddata = newData;
    //   } else {
    //     newData = deletefileitemsforhomebutton(
    //       stateData,
    //       [{
    //         directorycode: item.folderfilecode,
    //         file: item,
    //         filefor: "FIL"
    //       }],
    //     );
    //   }
    // })
    // props.alert.success(props.t("Orders.Sheetorders.IDS_MULTIFILEDELETE"));

    // setStateData(newData);
    // setIsMultiSelectFile(false);
    // setSelectedFiles([]);
  };

  const updateorder = (order: any) => {
    if (
      selectedTreeItem &&
      selectedTreeItem.directorycode &&
      (selectedTreeItem.filefor === "DPO" ||
        selectedTreeItem.filefor === "EPO") &&
      order &&
      order.orderflag &&
      order.orderflag.trim() === "R"
    ) {
      let newData = removeDataItem(stateData, {
        directorycode: order.protocolordercode,
      });
      let selectedtree = getDirectoryOncode(
        newData,
        selectedTreeItem.directorycode
      );
      setStateData(newData);
      setSelectedTreeItem(selectedtree);
    } else if (
      selectedTreeItem &&
      selectedTreeItem.directorycode &&
      (selectedTreeItem.filefor === "MYO" || order.orderflag.trim() === "R")
    ) {
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      if (order !== undefined) {
        let responseorder = [order];
        let newdata = replaceonechangeorderordertoFolderwithfilefor(
          folderdata,
          directorycode,
          intl,
          responseorder !== undefined && responseorder.length > 0
            ? responseorder
            : [],
          filefor,
          screen
        );
        let selectedtree = getDirectoryOncode(
          newdata,
          selectedTreeItem.directorycode
        );
        setStateData(newdata);
        setSelectedTreeItem(selectedtree);
      }
    } else if (
      selectedTreeItem &&
      selectedTreeItem.directorycode &&
      order.orderflag.trim() === "N"
    ) {
      order.canuserprocess = true;
      let responseorder = [];
      responseorder.push(order);
      let folderdata =
        stateData !== undefined && stateData !== null && stateData.length > 0
          ? stateData
          : initialorders !== null
            ? initialorders
            : [];
      let directorycode: any =
        selectedTreeItem !== null ? selectedTreeItem.directorycode : null;
      let filefor: any =
        selectedTreeItem !== null ? selectedTreeItem.filefor : "";
      if (responseorder !== undefined && responseorder.length > 0) {
        let testmastervalues =
          testmasterdummy !== null ? testmasterdummy : testmaster;
        if (testmastervalues !== null) {
          responseorder.map((item: any) => {
            let test = testmastervalues.filter(
              (items: any) => items[0] === item.testcode
            );
            if (test.length > 0) {
              item.testname = test[0][2];
            }
            return item;
          });
        }
      }
      let newdata = replaceonechangeorderordertoFolderwithfilefor(
        folderdata,
        directorycode,
        intl,
        responseorder !== undefined && responseorder.length > 0
          ? responseorder
          : [],
        filefor,
        screen
      );

      let selectedtree = getDirectoryOncodeandfilefor(
        newdata,
        directorycode,
        filefor
      );
      let protocolOrder = {
        ...responseorder[0],
        isprotocolprocess: true,
        // KenodclassName: "clsdisplayblock",
        // orderDetailsclassName: "clsDisplaynone",
        stopDisabled: true,
        lstelnprotocolworkflow: workflow,
      };
      setSelectedTreeItem(selectedtree);
      setStateData(newdata);
      setProtocolOrder(protocolOrder);
      const protocolorderopen: any = true;
      const payload = {
        protocolOrder,
        protocolorderopen,
        isdashboardclick,
        selectedTreeItem,
      };
      store.dispatch(updatewithoutcloseprotocolorderdatas(payload));
    }
  };

  const folderview = () => {
    return (
      <div
        className={
          "k-widget k-filemanager k-filemanager-resizable " +
          // protocolOrder.orderDetailsclassName +
          " cls-filemanager "
        }
      // style={{ display: !protocolOrder.stopDisabled ? "block" : "none" }}
      >
        <div className="k-filemanager-header">
          <GlobalContext.Provider value={protocolrights}>
            <FileManagerToolbar
              splitItems={splitBtnItems}
              sortSelectedText={sortSelectedText}
              sort={stateContentData.sort}
              files={files}
              filesaveurl={filesaveurl}
              fileremoveurl={fileremoveurl}
              homeuploadfile={homeuploadfile}
              homeremovefile={homeremovefile}
              columns={columns}
              onNewFolderClick={handleNewFolderClick}
              onCreateOrderClick={handleRegisterOrder}
              onSearchChange={handleSearchChange}
              onSwitchChange={handleSwitchChange}
              onViewChange={handleViewChange}
              onSortChange={handleSortChange}
              onFileChange={handleFileChange}
              onAddFileChange={handleAddFileChange}
              onSelectAllFileClick={handleSelectAllFileClick}
              onSelectAllOrderClick={handleSelectAllOrderClick}
              isMultiSelectFile={isMultiSelectFile}
              isSelectAllFile={isSelectAllFile}
              isSelectAllOrder={isSelectAllOrder}
              SelectAllFile={SelectAllFile}
              SelectAllOrder={SelectAllOrder}
              onClearFileList={handleClearFileList}
              isMultiSelectFolders={isMultiSelectFolders}
              onUploadComplete={handleUploadComplete}
              onContextMenu={handleContextMenuView}
              isMultiSelectOrder={isMultiSelectOrder}
              onCloseMultiSelect={handleCloseMultiselectClick}
              onMultiselectMove={handleMoveOnMultiselect}
              sessionvalues={props.sessionvalues}
              // folderdata={stateData}
              onMultiselectDelete={handleDeleteOnMultiselect}
              selectedItem={selectedGridItem}
              selectedFolder={selectedTreeItem}
              folderdata={getFolderTree(stateData, selectedTreeItem)}
              t={props.t}
              EnableAddDialog={false}
              userData={stateUserData}
              props={props}
              screen={screen}
              view={
                localStorage.getItem("elnprotocolorderview") !== undefined &&
                  localStorage.getItem("elnprotocolorderview") !== null &&
                  localStorage.getItem("elnprotocolorderview") === "grid"
                  ? false
                  : true
              }
              oncolumnchange={handleoncolumnchange}
              rights={protocolrights}
              selectedCDPFolder={selectedCDPTreeItem}
              stateCDFData={getFolderTree(stateCDFData, selectedCDPTreeItem)}
              onFolderCDPItemClick={handleCDPTreeItemClick}
              onradioCDFbtnonClick={onradioCDFbtnclick}
              onCDFselectstate={SelectedCDFvalue}
              handlecancelClick={handlecancelClick}
              handleexportClick={handleexportClick}
            />
          </GlobalContext.Provider>
        </div>
        <Suspense fallback={<div></div>}>
          <ProtocolordershowContext.Provider value={protocolrights}>
            <DateFilter
              t={props.t}
              setFilterType={onfilterTypeChange}
              filterType={filterType}
              fromRange={fromRange}
              toRange={toRange}
              setDateRange={setdateRange}
              props={props}
              screen={screen}
              folder={selectedTreeItem}
              searchonButtonClick={searchonButtonClick}
              SearchCriteriaType={SearchCriteriaType.index}
              SearchContent={SearchContentText.SearchContentText}
              orderType={protocoltype}
              orderflag={orderflag}
              flitertest={flitertest}
              fliterproject={fliterproject}
              ismultitenant={isMultitenant}
            />
          </ProtocolordershowContext.Provider>
        </Suspense>
        <div className="k-filemanager-content-container">
          <Splitter panes={panes} onChange={handleSplitterChange}>
            <OverlayScrollbarsComponent
              style={{ height: "calc(100vh - 200px)" }}
            >
              <Suspense fallback={<div></div>}>
                <FolderTree
                  data={getFolderTree(stateData, selectedTreeItem)}
                  selected={selectedTreeItem}
                  selectedItem={selectedTreeItem}
                  onItemClick={handleTreeItemClick}
                  onContextMenu={handleContextMenuView}
                />
              </Suspense>
            </OverlayScrollbarsComponent>
            <div className="k-filemanager-content positioned-tr-group iconed-breadcrumb table-header-overflow sticky-header-order">
              <Suspense fallback={<div></div>}>
                <div className="row breadcrumb-search mr-0">
                  <div className="col-9 pr-0">
                    {" "}
                    <BreadcrumbComponent
                      data={convertToBreadcrumbData(selectedTreeItem, screen)}
                      onBreadcrumbSelect={handleBreadcrumbSelection}
                    />
                  </div>
                  <form
                    className="k-filemanager-search-tool k-textbox k-toolbar-last-visible col-3 float-right pr-0"
                    autoComplete="off"
                    id="breadcrumb_searchform"
                  >
                    <Input
                      className="k-input "
                      placeholder={props.t("Header.IDS_LBL_SEARCH")}
                      onChange={handleSearchChange}
                      value={SearchValue}
                      style={{ height: "100%" }}
                    />
                    <span className="k-input-icon">
                      <span className="k-icon k-i-search"></span>
                    </span>
                  </form>
                </div>
              </Suspense>
              {Itemview()}
              {contextMenuView ? (
                <Suspense fallback={<div></div>}>
                  <ContextMenu
                    offset={menuOffSet}
                    onContextMenuCLick={handleContextMenuClick}
                    selectedItem={selectedGridItem}
                    ismenucontext={isMenuContext}
                    rights={protocolrights}
                    t={props.t}
                    screen={"Protocol"}
                  />
                </Suspense>
              ) : (
                ""
              )}
              {editDialogView ? (
                <Suspense fallback={<div></div>}>
                  <EditDialog
                    editValue={
                      Object.keys(selectedGridItem).length
                        ? selectedGridItem
                        : selectedTreeItem
                    }
                    onDialogClose={handleDialogClose}
                    onDialogClick={handleDialogClick}
                    selectedFolder={selectedTreeItem}
                    sessionvalues={props.sessionvalues}
                    t={props.t}
                    alert={props.alert}
                    screen={screen}
                  />
                </Suspense>
              ) : (
                ""
              )}
              {deleteDialogView ? (
                <Suspense fallback={<div></div>}>
                  <DeleteDialog
                    onDialogClose={handleDialogClose}
                    onDialogClick={handleDialogClick}
                    selectedFolder={selectedTreeItem}
                    // folderdata={stateData}
                    folderdata={getFolderTree(stateData, selectedTreeItem)}
                    selectedItem={deletefolderevents ? selectedTreeItem : selectedGridItem}
                    sessionvalues={props.sessionvalues}
                    userData={stateUserData}
                    t={props.t}
                    selectedFolders={selectedFolders}
                    screen={"protocolorder"}
                  />
                </Suspense>
              ) : (
                ""
              )}
              {moveDialogView && (
                <Suspense fallback={<div></div>}>
                  <MoveDialog
                    // folderdata={stateData}
                    // selectedItem={selectedGridItem}
                    // selectedFolder={selectedTreeItem}
                    // userData={stateUserData}
                    // onDialogClose={handleDialogClose}
                    // onDialogClick={handlemoveDialogClick}
                    // sessionvalues={props.sessionvalues}
                    // t={props.t}
                    folderdata={getFolderTree(stateData, selectedTreeItem)}
                    selectedItem={selectedGridItem}
                    selectedFolder={selectedTreeItem}
                    userData={stateUserData}
                    onDialogClose={handleDialogClose}
                    onDialogClick={handlemoveDialogClick}
                    sessionvalues={props.sessionvalues}
                    mutifolders={selectedFolders}
                    isSelectAllFile={isSelectAllFile}
                    SelectAllFile={SelectAllFile}
                    SelectAllOrder={SelectAllOrder}
                    isSelectAllOrder={isSelectAllOrder}
                    isshowallfolder={
                      isMultiSelectFile
                        ? // &&
                        // selectedFiles !== undefined &&
                        // selectedFiles.length > 0 || selectedGridItem.file !== undefined
                        // ? 0 : isMultiSelectFolders ? 1 : 2)}
                        2
                        : isMultiSelectFolders
                          ? 1
                          : 2
                    }
                    t={props.t}
                    alert={props.alert}
                    screen={"protocolorder"}
                  />
                </Suspense>
              )}

              {adddialogVisible ? (
                <Suspense fallback={<div></div>}>
                  <DialogComponent
                    className="dialogue-inner-panel form-group fixed-dashboard"
                    title={props.t(
                      "Orders.Sheetorders.IDS_LBL_CREATENEWFOLDER"
                    )}
                    onClose={handleDialogClose}
                  >
                    <AddDialog
                      addValue={undefined}
                      onDialogClose={handleDialogClose}
                      onDialogClick={handleDialogClick}
                      sessionvalues={props.sessionvalues}
                      t={props.t}
                      alert={props.alert}
                      // selectedFolder={selectedTreeItem}
                      selectedFolder={
                        Isview_Constence &&
                          Object.keys(selectedGridItem).length > 0
                          ? selectedGridItem
                          : selectedTreeItem
                      }
                      props={{
                        selectedFolder:
                          Isview_Constence &&
                            Object.keys(selectedGridItem).length > 0
                            ? selectedGridItem
                            : selectedTreeItem,
                        selectedCDPFolder: selectedCDPTreeItem,
                        stateCDFData: getFolderTree(
                          stateCDFData,
                          selectedCDPTreeItem ? selectedCDPTreeItem : null
                        ),
                        onFolderCDPItemClick: handleCDPTreeItemClick,
                        onradioCDFbtnonClick: onradioCDFbtnclick,
                        onCDFselectstate: SelectedCDFvalue,
                        handlecancelClick: handlecancelClick,
                      }}
                    />
                  </DialogComponent>
                </Suspense>
              ) : (
                ""
              )}
            </div>
            <OverlayScrollbarsComponent
              style={{ height: "calc(100vh - 200px)" }}
            >
              <Suspense fallback={<div></div>}>
                <FileInformation
                  data={detailsData}
                  screen={screen}
                  filefor={selectedTreeItem?.filefor}
                  selectedteamname={sessionStorage.selectedteamname}
                  t={props.t}
                />
              </Suspense>
            </OverlayScrollbarsComponent>
          </Splitter>
        </div>
      </div>
    );
  };

  return (
    <div>
      {!protocolorderopen && folderview()}

      {protocolorderopen ? (
        <div>
          <Protocolorder
            notifiystate={protocolOrder}
            order={protocolOrder}
            props={props}
            // sheetview={sheetview}
            closeprotocolorder={handleorderonclose}
            alert={props.alert}
            protocolorderopen={protocolorderopen}
            OpenedProtocolOrder={openedprotocolOrder}
            // activekey={typeof props.isnotificationprocess === "object" ? selectedTreeItem !== null && Object.keys(props.isnotificationprocess).length === 0 ? selectedTreeItem.filefor : "" : selectedTreeItem !== null && props.isnotificationprocess === undefined ? selectedTreeItem.filefor : ""}
            // activekey={typeof props.isnotificationprocess === "object" && props.isnotificationprocess ?
            //   props.isnotificationprocess?.approved === 1 || (props.isnotificationprocess?.assignedto !== undefined && props.isnotificationprocess?.orderflag === "R") ? "ECO"
            //     : props.isnotificationprocess?.assignedto?.usercode === sessionStorage.getItem("User") ? "MYO" : props.isnotificationprocess?.assignedto !== undefined ? "ASO" : props.isnotificationprocess?.sharebyme !== undefined ? "OSBM" : props.isnotificationprocess?.sharetome !== undefined ? "OSTM" : "EPO" :
            //   // selectedTreeItem?.filefor && selectedTreeItem !== null && Object.keys(props.isnotificationprocess).length === 0
            //   //   ? selectedTreeItem.filefor
            //   //   : "" :
            //   selectedTreeItem?.filefor && selectedTreeItem !== null && props.isnotificationprocess === undefined
            //     ? selectedTreeItem.filefor : selectedTreeItem === undefined ? "DR" : ""}
            activekey={
              // isdashboardclick
              //   ?
              protocolOrder?.approved === 1 ||
                (protocolOrder?.assignedto !== undefined &&
                  protocolOrder?.orderflag === "R")
                ? "ECO"
                : protocolOrder?.assignedto?.usercode ===
                  Number(sessionStorage.getItem("User"))
                  ? "MYO"
                  : protocolOrder?.assignedto !== undefined
                    ? "ASO"
                    : protocolOrder?.sharebyme !== undefined
                      ? "OSBM"
                      : protocolOrder?.sharetome !== undefined
                        ? "OSTM"
                        : "EPO"
              // : // selectedTreeItem?.filefor && selectedTreeItem !== null && Object.keys(protocolOrder).length === 0
              // //   ? selectedTreeItem.filefor
              // //   : "" :
              // selectedTreeItem?.filefor &&
              //   selectedTreeItem !== null &&
              //   props.isnotificationprocess === undefined
              // ? selectedTreeItem.filefor
              // : selectedTreeItem === undefined
              // ? "DR"
              // : ""
            }
            onworkflowupdate={onworkflowupdate}
            updateorder={updateorder}
            Updateorderapprovalstatus={Updateorderapprovalstatus}
            idle_save={idle_save}
            cansave={protocolOrder !== undefined && protocolOrder?.lockeduser === Number(sessionStorage.User) ? true : false}
            updatestateorderdata={updatestateorderdata}
          />
        </div>
      ) : (
        false
      )}
      {isunshareopen && (
        <Unsharelistview
          isOpen={isunshareopen}
          closeunsharelist={closeunsharelist}
          shareitem={selectedUnsharedItem}
          onorderunshare={onorderunshare}
          screen={screen}
          t={props.t}
        />
      )}
      <Service
        Tourl={servicecall.ServiceToUrl}
        MethodType={servicecall.ServiceMethodType}
        onSuccess={servicecall.ServcieonSuccess}
        onFailure={servicecall.ServcieonFailure}
        Headerobject={servicecall.ServiceHeaderobject}
        onReseturl={() => {
          setServicecall({ ...servicecall, ServiceToUrl: "" });
        }}
        ServiceTenant={servicecall.ServiceTenant}
        contenttype={servicecall.Servicecontenttype}
      ></Service>
      <div>
        {(cancellorder || dublicateorder) && (
          <Suspense fallback={<div></div>}>
            <CommonDialog
              saveActiontype={cancellorder ? "cancellorder" : "dublicateorder"}
              header={cancellorder ? isMultitenant === 2 ? "Orders.Protocolorders.IDS_LBL_CANCELLTASKS" : "Orders.Protocolorders.IDS_LBL_CANCELLORDER" : "Orders.Protocolorders.IDS_LBL_DUBLICATEORDER"}
              bodycontent={
                cancellorder
                  ? props.t("Orders.Protocolorders.IDS_LBL_CANCELLORDERCON", {
                    screenname:
                      isMultitenant === 2
                        ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
                        : props.t("Dashboard.IDS_LBL_PROTOCOLORDERS"),
                  })
                  : props.t("Orders.Protocolorders.IDS_LBL_DUBLICATEORDERCON", {
                    screenname:
                      isMultitenant === 2
                        ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS")
                        : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERS"),
                  })
              }
              submitbuttonname={props.t(
                "Templates.Protocoltemplates.IDS_LBL_SUBMIT",
                { param: "" }
              )}
              closeuttonname={props.t(
                "Templates.Protocoltemplates.IDS_LBL_CLOSE",
                { param: "" }
              )}
              closeModel={closeModel}
              onsavecancelformodal={onsavecancelformodal}
              t={props.t}
            />
          </Suspense>
        )}
      </div>
      <Suspense fallback={<div></div>}>
        <Audit
          AuditId="auditTrailModalProtocolview"
          AuditUrl={Auditservicecall.AuditUrl}
          AuditObject={Auditservicecall.AuditObject}
          AuditPassfunction={Auditservicecall.AuditPassfunction}
          AuditFailfunction={Auditservicecall.AuditFailfunction}
          Auditfilefunction={Auditservicecall.Auditfilefunction}
          AuditCancelfunction={Auditservicecall.AuditCancelfunction ? Auditservicecall.AuditCancelfunction : Auditcancel}
          alert={props.alert}
        />
      </Suspense>
      {isupgradeopen && (
        <Suspense fallback={<div></div>}>
          <Upgrade
            isopen={isupgradeopen}
            onpopupclose={() => {
              setisupgradeopen(false);
            }}
            popcontent={props.t("UPGRADE.IDS_LBL_UPGRADDESCRIPTION")}
            popheader={props.t("UPGRADE.IDS_LBL_UPGRADEINMBTITLE")}
          />
        </Suspense>
      )}
    </div>
  );
};

export default withAlert()(withTranslation(Protocolorderstructure));
